import type { Dict } from '../types';

export const esES: Dict = {
  'chat.amrCard.switchTitle': 'Falló la llamada al modelo — esta ejecución está en pausa',
  'chat.amrCard.switchBody': 'Cambia al servicio oficial de modelos AMR de Gini Studio — sin configurar API Key. Tras iniciar sesión, autorizar y recargar, esta ejecución se reintentará automáticamente.',
  'chat.amrCard.chipOfficial': 'Alojamiento oficial',
  'chat.amrCard.chipNoKey': 'Sin API Key',
  'chat.amrCard.chipAutoRetry': 'Reintento automático tras iniciar sesión',
  'chat.amrCard.switchCta': 'Cambiar a AMR y reintentar',
  'chat.amrError.authMessage': 'Tu cuenta de AMR aún no está autorizada. Autorízala y esta ejecución se reintentará automáticamente.',
  'chat.amrError.balanceMessage': 'Tu saldo de AMR se ha agotado. Recarga para continuar esta ejecución.',
  'chat.amrError.authorizeCta': 'Autorizar y reintentar',
  'chat.amrError.rechargeCta': 'Recargar AMR',
  'chat.antigravityError.launchTerminalCta': 'Iniciar sesión desde el terminal',
  'chat.antigravityError.launchSwitchModelCta': 'Cambiar de modelo en el terminal',
  'common.cancel': 'Cancelar',
  'common.save': 'Guardar',
  'common.close': 'Cerrar',
  'common.clear': 'Limpiar',
  'common.delete': 'Eliminar',
  'common.rename': 'Renombrar',
  'common.edit': 'Editar',
  'common.preview': 'Vista previa',
  'common.share': 'Compartir',
  'common.search': 'Buscar',
  'common.searchEllipsis': 'Buscar…',
  'common.loading': 'Cargando…',
  'common.all': 'Todos',
  'common.none': 'Ninguno',
  'common.default': 'Predeterminado',
  'common.installed': 'instalado',
  'common.notInstalled': 'no instalado',
  'common.active': 'activo',
  'common.offline': 'sin conexión',
  'common.selected': 'seleccionado',
  'common.create': 'Crear',
  'common.openPreview': 'Abrir vista previa',
  'common.exitFullscreen': 'Salir de pantalla completa',
  'common.fullscreen': 'Pantalla completa',
  'common.openInNewTab': 'Abrir en pestaña nueva',
  'common.exportPdf': 'Exportar como PDF',
  'common.exportZip': 'Descargar como .zip',
  'common.exportHtml': 'Exportar como HTML independiente',
  'common.exportImage': 'Exportar como imagen',
  'common.exportImageFailed': 'Error al capturar la imagen. Inténtalo de nuevo o usa la herramienta de captura de pantalla de tu navegador.',
  'common.justNow': 'justo ahora',
  'common.minutesAgo': 'hace {n} min',
  'common.hoursAgo': 'hace {n} h',
  'common.daysAgo': 'hace {n} d',
  'common.weeksAgo': 'hace {n} sem',
  'common.now': 'ahora',
  'common.minutesShort': '{n} min',
  'common.hoursShort': '{n} h',
  'common.daysShort': '{n} d',
  'common.untitled': 'Sin título',
  'plugins.availableDetails.provenance': 'Procedencia',
  'plugins.availableDetails.provenanceLine': 'de {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'de {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'Instalar',
  'plugins.availableDetails.version': 'Versión',
  'plugins.availableDetails.pluginVersion': 'Versión del plugin',
  'plugins.availableDetails.copyInstallCommand': 'Copiar comando de instalación',
  'plugins.availableDetails.copied': 'Copiado',
  'plugins.availableDetails.deprecatedPrefix': 'Obsoleto: {message}',
  'plugins.availableDetails.deprecatedFallback': 'Esta versión se ha marcado como obsoleta.',
  'plugins.availableDetails.yanked': 'Retirada.',
  'plugins.availableDetails.yankedWithReason': 'Retirada: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (obsoleto)',
  'plugins.availableDetails.versionYankedSuffix': ' (retirada)',
  'plugins.availableDetails.ref': 'Ref',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'Permisos',
  'plugins.availableDetails.capabilitySummary': 'Resumen de capacidades',
  'plugins.actions.copyInstallCommand': 'Copiar comando de instalación',
  'plugins.actions.copyPluginId': 'Copiar ID del plugin',
  'plugins.actions.copyReadmeBadge': 'Copiar insignia README',
  'plugins.actions.openSourceGithub': 'Abrir código fuente en GitHub',
  'plugins.actions.openSource': 'Abrir código fuente',
  'plugins.actions.openHomepage': 'Abrir página de inicio',
  'plugins.actions.openMarketplace': 'Abrir en el marketplace',
  'app.brand': 'GINI Studio',
  'app.brandPill': 'Vista previa de investigación',
  'app.brandSubtitle': 'por Nexu Labs',
  'app.welcomeLoading': 'Cargando espacio de trabajo…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'Te damos la bienvenida',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'Empezar a partir de un brief',
  'settings.onboardingCreateBody': 'Describe el sitio web, la app, la presentación, la imagen o el vídeo que quieres. Gini Studio creará un proyecto y mantendrá el trabajo editable.',
  'settings.onboardingMemoryTitle': 'Guardar el contexto de trabajo',
  'settings.onboardingMemoryBody': 'Añade preferencias, datos del proyecto y reglas recurrentes para que los chats futuros recuperen el contexto adecuado.',
  'settings.onboardingSystemsTitle': 'Incorpora tu sistema de diseño',
  'settings.onboardingSystemsBody': 'Elige o crea un sistema de marca para que el trabajo generado respete los colores, la tipografía y el lenguaje de producto reales.',
  'settings.onboardingExecutionTitle': 'Elige cómo se ejecuta la generación',
  'settings.onboardingExecutionBody': 'CLI oficial con configuración en un clic y ajustes predeterminados listos para usar. Usa una sola clave para elegir entre muchos modelos con mejores precios.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Recomendado oficialmente',
  'settings.onboardingAmrCloudBenefitReady': 'Sin despliegue',
  'settings.onboardingAmrCloudBenefitModels': 'Compatible con Claude Opus 4.8',
  'settings.onboardingAmrCloudBenefitPricing': 'Harness SOTA',
  'settings.onboardingAmrCloudUpcomingLabel': 'Próximamente',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'Imagen y video',
  'settings.onboardingAmrCloudUpcomingSkills': 'Skills masivas',
  'settings.onboardingAmrCloudUpcomingRouting': 'Enrutamiento inteligente',
  'settings.onboardingAmrModelSourceLabel': 'AMR CLI',
  'settings.onboardingAmrCloudAuthorizeAction': 'Autorizar AMR',
  'settings.onboardingAmrCloudAuthorizedAction': 'Autorizado',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'Design system',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': 'Mantente al día',
  'settings.onboardingNewsletterTitle': 'No te pierdas nada',
  'settings.onboardingNewsletterBody': 'Recibe novedades de producto, nuevas plantillas, design systems y trabajo de embajadores en tu bandeja. Opcional: puedes omitirlo.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingRecommended': 'Recommended',
  'settings.onboardingAmrCloudOfficialBadge': 'Oficial',
  'settings.onboardingLocalTitle': 'Local coding agent',
  'settings.onboardingLocalBody': 'Use an installed CLI such as local coding agents, Codex, Cursor, Gemini, or OpenCode.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Bring your own key',
  'settings.onboardingByokBody': 'Use your own model provider credentials.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'About you',
  'settings.onboardingProfileBody': 'Optional details for better defaults.',
  'settings.onboardingRoleLabel': 'Your role',
  'settings.onboardingOrgSizeLabel': 'Organization size',
  'settings.onboardingUseCaseLabel': 'Use case',
  'settings.onboardingSourceLabel': 'Where did you hear about us?',
  'settings.onboardingSelectPlaceholder': 'Select one',
  'settings.onboardingSelectMultiplePlaceholder': 'Select one or more',
  'settings.onboardingOrgSolo': 'Solo / personal (1)',
  'settings.onboardingOrgTeam': 'Small team (2-10)',
  'settings.onboardingOrgStartup': 'Startup / SMB (11-50)',
  'settings.onboardingOrgGrowth': 'Growth company (51-200)',
  'settings.onboardingOrgMidMarket': 'Mid-market (201-1000)',
  'settings.onboardingOrgEnterprise': 'Enterprise (1000+)',
  'settings.onboardingRolePm': '📋 Product manager',
  'settings.onboardingRoleDesigner': '🎨 Designer',
  'settings.onboardingRoleEngineer': '💻 Engineer',
  'settings.onboardingRoleMarketing': '📣 Marketing',
  'settings.onboardingRoleGrowth': '📈 Growth',
  'settings.onboardingRoleOps': '⚙️ Operations',
  'settings.onboardingRoleFounder': '🚀 Founder / executive',
  'settings.onboardingRoleStudent': '🎓 Student / educator',
  'settings.onboardingRoleOther': '✨ Other',
  'settings.onboardingUseProduct': '🎨 Product design',
  'settings.onboardingUseDesignSystem': '🧩 Design system',
  'settings.onboardingUsePrototype': '📱 Prototype / app UI',
  'settings.onboardingUseLanding': '🌐 Landing pages',
  'settings.onboardingUseAds': '📣 Ads / social content',
  'settings.onboardingUseDashboard': '📊 Dashboards / internal tools',
  'settings.onboardingUseDeck': '🖥️ Presentation / deck',
  'settings.onboardingUseMarketing': '📈 Marketing / growth',
  'settings.onboardingUseEngineering': '🤝 Engineering handoff',
  'settings.onboardingUseAgency': '💼 Agency / client work',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceFriend': '👥 Friend or coworker',
  'settings.onboardingSourceSocial': '📱 Social media',
  'settings.onboardingSourceProductHunt': '🅿️ Product Hunt',
  'settings.onboardingSourceCommunity': '💬 Design / AI community',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceBlog': '📰 Blog or newsletter',
  'settings.onboardingSourceAiTool': '✨ AI tool recommendation',
  'settings.onboardingSourceSearch': '🔍 Search',
  'settings.onboardingSourceEvent': '🎤 Event or community',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.onboardingSkip': 'Skip for now',
  'settings.kicker': 'Ajustes',
  'settings.title': 'Modo de ejecución',
  'settings.subtitle': 'Elige entre CLI local y BYOK.',
  'settings.modeAria': 'Modo de ejecución',
  'settings.protocolAria': 'Protocolo de API',
  'settings.modeDaemon': 'CLI local',
  'settings.modeDaemonHelp': 'Ejecuta a través de una CLI de agente de código en tu máquina',
  'settings.modeDaemonOffline': 'El daemon no está en ejecución',
  'settings.modeDaemonOfflineMeta': 'daemon sin conexión',
  'settings.modeDaemonInstalledMeta': '{count} instalados',
  'settings.modeApi': 'Proveedor de API',
  'settings.modeApiMeta': 'BYOK',
  'settings.byokNoFileToolsNotice': 'BYOK no puede leer, escribir ni editar archivos del proyecto. Usa la CLI local cuando necesites cambios en el código.',
  'settings.codeAgent': 'Agente de código',
  'settings.codeAgentHint': 'Detectado al escanear tu PATH. Elige la CLI por la que quieres que pasen las generaciones.',
  'settings.rescan': '↻ Reescanear',
  'settings.rescanTitle': 'Reescanear PATH',
  'settings.rescanRunning': 'Escaneando...',
  'settings.rescanSuccess': 'Escaneo completado. {count} disponibles.',
  'settings.designSystemRenameFailed': 'No se pudo cambiar el nombre. Comprueba el daemon e inténtalo de nuevo.',
  'settings.rescanFailed': 'El escaneo falló. Comprueba el daemon e inténtalo de nuevo.',
  'settings.test': 'Probar',
  'settings.testTitle': 'Envía un mensaje minúsculo de prueba para verificar la conexión',
  'settings.testRunning': 'Probando conexión…',
  'settings.byokReadyToTest': 'Listo para probar',
  'settings.testCancel': 'Cancelar',
  'settings.testRetry': 'Reintentar prueba',
  'settings.required': 'obligatorio',
  'settings.testMissingFields': 'Rellena {fields} para probar la conexión.',
  'settings.testSuccessApi': 'Conectado. Respondió en {ms} ms — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} respondió en {ms} ms — \'{sample}\'',
  'settings.testAuthFailed': 'Autenticación fallida. Comprueba tu clave de API.',
  'settings.testForbidden': 'Acceso prohibido. Verifica cuenta, región u organización.',
  'settings.testNotFoundModel': 'No se encontró el modelo \'{model}\' en este endpoint.',
  'settings.testInvalidModelId': 'El id de modelo \'{model}\' no es válido. Los ids personalizados deben empezar con una letra o un número y no contener espacios.',
  'settings.testInvalidBaseUrl': 'La Base URL no es válida o no es accesible.',
  'settings.testRateLimited': 'El proveedor limitó la prueba. La configuración parece válida.',
  'settings.testUpstream': 'El proveedor devolvió {status}. Inténtalo de nuevo.',
  'settings.testTimeout': 'La prueba expiró tras {ms} ms.',
  'settings.testAgentMissing': '{agentName} no está instalado o no está en el PATH.',
  'settings.testAgentSpawn': 'No se pudo iniciar {agentName}: {detail}.',
  'settings.testUnknown': 'Prueba fallida: {detail}',
  'settings.agentInstall.install': 'Instalar',
  'settings.agentInstall.docs': 'Documentación',
  'settings.agentInstall.pathHint': 'Si instalaste una CLI con npm o Homebrew y sigue apareciendo como no instalada, asegúrate de que el directorio bin de la herramienta esté en el PATH que hereda el daemon de Gini Studio (Terminal y apps GUI pueden diferir en macOS). Consulta QUICKSTART.md (sección "Local agent CLI and PATH").',
  'settings.agentInstall.stepOpenLinks': 'Abre Instalar o Docs para el agente que prefieras.',
  'settings.agentInstall.stepAuth': 'Autentícate con la CLI del proveedor (inicia sesión o añade credenciales API) antes de volver a Gini Studio.',
  'settings.agentInstall.stepRescan': 'Haz clic en Reescanear en esta sección.',
  'settings.agentInstall.stepSelect': 'Selecciona la tarjeta del agente cuando aparezca como instalado.',
  'settings.noAgentsDetected': 'Aún no se ha detectado ningún agente. Instala local coding agents, Codex, Devin for Terminal, Gemini CLI, OpenCode, Cursor Agent, Qwen o GitHub Copilot CLI y pulsa Reescanear.',
  'settings.agentInstalledGroup': 'Tus CLI ({count})',
  'settings.agentInstallGroup': 'Disponibles para instalar ({count})',
  'settings.agentAuthRequired': 'Autenticación requerida',
  'settings.agentAuthUnknown': 'Estado de autenticación desconocido',
  'settings.amrCloud': 'Gini Studio AMR',
  'settings.amrAuthorize': 'Autorizar',
  'settings.amrBenefitOfficial': 'Officially maintained',
  'settings.amrBenefitLowerPrice': 'Lower price',
  'settings.amrBenefitManyModels': 'Muchos modelos',
  'settings.amrPromoBonus': 'Bonificación limitada: +100%',
  'settings.amrSignInToContinue': 'Inicia sesión para continuar',
  'settings.amrSignIn': 'Iniciar sesión',
  'settings.amrSignedIn': 'Sesión iniciada',
  'settings.amrNotSignedIn': 'Sin sesión iniciada',
  'settings.amrSigningIn': 'Iniciando sesión…',
  'settings.amrCancelSignIn': 'Cancelar inicio de sesión',
  'settings.amrAccountStatus': 'Estado de la cuenta AMR',
  'settings.amrConsole': 'Consola AMR',
  'settings.amrLoginErrorCompact': 'Error al iniciar sesión en AMR.',
  'settings.advanced': 'Avanzado',
  'settings.amrLogin': 'Iniciar sesión',
  'settings.amrLogout': 'Cerrar sesión',
  'settings.amrLoggingIn': 'Iniciando sesión…',
  'settings.amrLoggingOut': 'Cerrando sesión…',
  'auth.logout': 'Cerrar sesión',
  'auth.loggingOut': 'Cerrando sesión…',
  'settings.amrLoggedInAs': 'Sesión iniciada como {email}',
  'settings.amrLoggedInWithPlan': 'Sesión iniciada como {email} · {plan}',
  'settings.amrLoggedInPill': 'Sesión iniciada',
  'settings.amrNotLoggedIn': 'Sin sesión iniciada',
  'settings.apiSection': 'API de Anthropic',
  'settings.quickFillProvider': 'Rellenar proveedor',
  'settings.providerPreset': 'Preajuste de gateway',
  'settings.protocolGroupProtocols': 'Protocolos',
  'settings.protocolGroupGateways': 'Pasarelas',
  'settings.customProvider': 'Proveedor personalizado',
  'settings.apiKey': 'Clave de API',
  'settings.apiKeyGetLink': 'Obtener clave ↗',
  'settings.showKey': 'Mostrar clave',
  'settings.hideKey': 'Ocultar clave',
  'settings.show': 'Mostrar',
  'settings.hide': 'Ocultar',
  'settings.model': 'Modelo',
  'settings.apiKeyInvalid': 'API key no válida.',
  'settings.apiKeyCleaned': 'Se eliminaron los espacios sobrantes de la API key.',
  'settings.modelsLoadedFromAccount': '✓ Se cargaron {count} modelos de tu cuenta.',
  'settings.modelsLoadedCount': '✓ Se cargaron {count} modelos.',
  'settings.modelSourceAccount': 'De tu cuenta',
  'settings.modelSourceSuggested': 'Sugerido',
  'settings.fetchModels': 'Obtener modelos',
  'settings.fetchModelsTitle': 'Obtener los modelos disponibles de este proveedor',
  'settings.fetchModelsRunning': 'Obteniendo modelos…',
  'settings.fetchModelsMissingFields': 'Rellena {fields} para obtener los modelos.',
  'settings.fetchModelsInvalidBaseUrl': 'Introduce una Base URL válida para obtener los modelos.',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI usa nombres de implementación, por lo que la detección de modelos no está disponible aquí.',
  'settings.fetchModelsUnsupportedOllama': 'La detección de modelos de Ollama Cloud aún no está disponible. Elige o escribe un modelo.',
  'settings.fetchModelsSuccess': 'Se obtuvieron {count} modelos.',
  'settings.fetchModelsEmpty': 'No se devolvió ningún modelo de texto compatible.',
  'settings.fetchModelsUnsupported': 'La detección de modelos no está disponible para este protocolo.',
  'settings.fetchModelsFailed': 'No se pudieron obtener los modelos: {detail}',
  'settings.suggestedModelsHint': 'Estos son modelos sugeridos para este protocolo. Tu proveedor puede admitir modelos diferentes.',
  'settings.baseUrl': 'URL base',
  'settings.baseUrlInvalid': 'Usa una URL pública http:// o https://.',
  'settings.baseUrlCustomize': 'Personalizar',
  'settings.baseUrlDefaultHint': 'Endpoint predeterminado. Normalmente no hace falta cambiarlo.',
  'settings.azureBaseUrlPlaceholder': 'https://my-resource.openai.azure.com',
  'settings.azureBaseUrlHint': 'Encuéntralo en el portal de Azure → tu recurso → Endpoint.',
  'settings.azureDeploymentModel': 'Nombre del despliegue',
  'settings.azureCustomDeploymentName': 'Nombre de implementación personalizado',
  'settings.azureDeploymentModelHint': 'Para Azure OpenAI, este campo se usa como nombre del despliegue en /openai/deployments/<model>. Introduce el nombre del despliegue que creaste en Azure.',
  'settings.azureModelFetchHint': 'Introduce el nombre de la implementación de tu recurso de Azure. Las implementaciones de Azure no se pueden obtener automáticamente.',
  'settings.apiVersion': 'Versión de API',
  'settings.byokImageModel': 'Modelo de generación de imágenes',
  'settings.byokVideoModel': 'Modelo de generación de vídeo',
  'settings.byokVideoI2vHint': 'Modelo de imagen a vídeo: se requiere una imagen de referencia (si no eliges una, se usa la más reciente del proyecto)',
  'settings.byokSpeechModel': 'Modelo de voz',
  'settings.byokSpeechVoice': 'Voz',
  'settings.byokModelDefaultOption': 'Predeterminado',
  'settings.maxTokens': 'Tokens máx. (opcional)',
  'settings.maxTokensHint': 'Tope para la longitud de la respuesta. Cada modelo tiene un valor por defecto ajustado (visible en el placeholder); déjalo vacío para usarlo o introduce un número para anularlo.',
  'settings.apiHint': 'Las llamadas pasan por el proxy del daemon local hasta la URL base configurada. La clave se guarda solo en este navegador y se envía con las solicitudes al proveedor.',
  'settings.skipForNow': 'Omitir por ahora',
  'settings.getStarted': 'Empezar',
  'settings.envConfigure': 'Modo de ejecución',
  'settings.localCli': 'CLI local',
  'settings.anthropicApi': 'API de Anthropic',
  'settings.noAgentSelected': 'ningún agente seleccionado',
  'settings.language': 'Idioma',
  'settings.languageHint': 'Cambia el idioma de la interfaz. Se guarda en este navegador.',
  'settings.appearance': 'Apariencia',
  'settings.appearanceHint': 'Elige claro, oscuro o seguir la configuración del sistema.',
  'settings.themeSystem': 'Sistema',
  'settings.themeLight': 'Claro',
  'settings.themeDark': 'Oscuro',
  'settings.agentModelHead': 'Modelo para:',
  'settings.modelPicker': 'Modelo',
  'settings.modelSourceLive': 'En vivo desde la CLI',
  'settings.modelSourceFallback': 'Lista integrada',
  'settings.reasoningPicker': 'Esfuerzo de razonamiento',
  'settings.modelPickerHint': 'Se obtiene de la CLI cuando expone un comando `models`. «Predeterminado» deja la elección a la propia configuración de la CLI; «Personalizado…» permite escribir cualquier id de modelo aceptado por la CLI.',
  'settings.modelPickerLiveHint': 'Los modelos se actualizaron desde la CLI instalada. Predeterminado sigue usando la configuración de la CLI.',
  'settings.modelPickerLiveCatalogOnlyHint': 'Los modelos se actualizaron desde la CLI instalada.',
  'settings.modelPickerFallbackHint': 'Mostrando valores predeterminados integrados. Pulsa Reescanear para obtener modelos en vivo desde la CLI.',
  'settings.cliEnvTitle': 'CLI config locations',
  'settings.cliEnvHint': 'Set non-secret config directories for packaged app runs and agent detection.',
  'settings.cliEnvClaudeConfigDir': 'Directorio de configuración de local coding agents',
  'settings.cliEnvClaudeBaseUrl': 'Base URL del proxy de Claude',
  'settings.cliEnvClaudeApiKey': 'API key del proxy de Claude',
  'settings.cliEnvCodexHome': 'Directorio principal de Codex',
  'settings.cliEnvCodexBin': 'Ruta del ejecutable de Codex',
  'settings.cliEnvCodexBaseUrl': 'Base URL del proxy de Codex/OpenAI',
  'settings.cliEnvCodexApiKey': 'API key del proxy de Codex/OpenAI',
  'settings.modelCustom': 'Personalizado (escribe abajo)…',
  'settings.modelCustomLabel': 'Id de modelo personalizado',
  'settings.modelCustomPlaceholder': 'p. ej., anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Proveedores de medios',
  'settings.mediaProvidersHint': 'Claves de API para generación de imagen, vídeo y audio. Se guardan localmente y se sincronizan con el daemon local.',
  'settings.mcpServerTitle': 'Servidor MCP',
  'settings.mcpServerHint': 'Expón Gini Studio como servidor MCP para tu agente de código.',
  'settings.externalMcpTitle': 'MCP externo',
  'settings.externalMcpHint': 'Añade herramientas MCP desde servicios externos (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'Clave de API',
  'settings.mediaProviderBaseUrl': 'URL base',
  'settings.mediaProviderConfigured': 'Configurado',
  'settings.mediaProviderUnset': 'Sin configurar',
  'settings.mediaProviderClear': 'Limpiar',
  'settings.mediaProviderClearConfirm': '¿Eliminar la configuración guardada de {name}? Tendrás que introducirla de nuevo para usar {name}.',
  'settings.mediaProviderPlaceholder': 'Pega la clave de API',
  'settings.mediaProviderBaseUrlPlaceholder': 'Sobrescribir URL base por defecto',
  'settings.mediaProviderReload': 'Recargar desde el daemon',
  'settings.mediaProviderReloadError': 'No se pudieron recargar los ajustes de los proveedores de medios desde el daemon local.',
  'settings.mediaProviderReloadSuccess': 'Se recargaron los ajustes de los proveedores de medios desde el daemon local.',
  'settings.mediaProviderLoadError': 'No se pudieron cargar los ajustes de los proveedores de medios desde el daemon local. Por ahora se usarán los ajustes guardados en el navegador.',
  'settings.mediaProviderComingSoonHint': 'Rastreamos estos para la hoja de ruta; el daemon aún no incluye un cliente, por lo que no hay nada que configurar.',
  'settings.privacy': 'Privacidad',
  'settings.privacyHint': 'Qué datos se comparten con el equipo de Gini Studio',
  'settings.privacyConsentKicker': 'Ayúdanos a mejorar Gini Studio',
  'settings.privacyConsentLead': 'Gini Studio puede compartir datos de uso con nuestro equipo para ayudarnos a mejorar. Esto incluye:',
  'settings.privacyConsentFooter': 'Puedes cambiar cualquiera de estas opciones en cualquier momento en Ajustes → Privacidad. Nunca subimos el contenido de los archivos de los artefactos que generas.',
  'settings.privacyConsentShare': 'Compartir datos de uso',
  'settings.privacyConsentDecline': 'No compartir',
  'settings.privacyConsentAccept': 'Entendido',
  'settings.privacyConsentBannerFooter': 'El uso compartido de datos está activado de forma predeterminada. Puedes desactivarlo en cualquier momento en Ajustes → Privacidad. Nunca subimos el contenido de los archivos de los artefactos que generas.',
  'settings.privacyConsentPolicyLink': 'Leer la política de privacidad',
  'settings.privacyMetrics': 'Métricas anónimas',
  'settings.privacyMetricsHint': 'Número de ejecuciones, uso de tokens, tasa de errores, duración. Sin prompts ni datos del proyecto.',
  'settings.privacyContent': 'Conversation content',
  'settings.privacyContentHint': 'Your prompts and the assistant\'s responses (truncated 8 KB / 16 KB). API keys, tokens, JWTs, emails, IPs, and credit-card numbers are stripped automatically before send.',
  'settings.privacyArtifacts': 'Manifiesto de artefactos del proyecto',
  'settings.privacyArtifactsHint': 'Nombres, tipos y tamaños de los archivos generados. El contenido de los archivos nunca se envía.',
  'settings.privacyInstallationId': 'ID anónimo',
  'settings.privacyOptedOut': 'sin participar',
  'settings.privacyDataDeletion': 'Eliminar mis datos',
  'settings.privacyDataDeletionHint': 'Rota tu ID anónimo y detiene el envío. Las trazas existentes caducan según nuestra política de retención.',
  'settings.about': 'Acerca de',
  'settings.aboutHint': 'Versión y detalles de ejecución',
  'settings.appVersion': 'Versión',
  'settings.appChannel': 'Canal',
  'settings.appRuntime': 'Ejecución',
  'settings.appPlatform': 'Plataforma',
  'settings.appArchitecture': 'Arquitectura',
  'settings.runtimePackaged': 'App empaquetada',
  'settings.runtimeDevelopment': 'Desarrollo',
  'settings.versionUnavailable': 'Los detalles de versión no están disponibles mientras el daemon está offline.',
  'settings.giniStudioCapabilitiesTitle': 'Capacidades de GINI Studio',
  'settings.installLatest': 'Instalar la última versión',
  'settings.alreadyLatest': 'Ya tienes la última versión',
  'settings.mcpTitle': 'Servidor MCP',
  'settings.mcpHint': 'Permite que los agentes de codificación (Cursor, local coding agents, VS Code…) lean directamente tus proyectos de Gini Studio.',
  'settings.mcpDaemonError': 'No se pudo contactar con el daemon local para resolver las rutas de instalación ({error}). Asegúrate de que Gini Studio esté en ejecución y vuelve a abrir este panel.',
  'settings.mcpBuildDaemon': 'Compila primero el daemon.',
  'settings.mcpNodeMissing': 'Falta el binario de Node.',
  'settings.mcpBuildHint': 'Falta apps/daemon/dist/cli.js. Ejecuta `pnpm --filter @open-design/daemon build` y actualiza.',
  'settings.mcpMethodCli': 'Comando de CLI',
  'settings.mcpInstructionCli': 'Ejecuta esto en tu terminal.',
  'settings.mcpMethodToml': 'Configuración TOML',
  'settings.mcpInstructionCodex': 'Añade esta tabla a {path}. La misma configuración se comparte entre el CLI de Codex y la extensión de Codex para el IDE.',
  'settings.mcpMethodOneClick': 'Instalación con un clic',
  'settings.mcpInstructionCursor': 'Haz clic en «Install in Cursor» para instalar con un cuadro de diálogo de aprobación, o fusiona este JSON en {path}.',
  'settings.mcpDeeplinkInstallCursor': 'Instalar en Cursor',
  'settings.mcpMethodJson': 'Configuración JSON',
  'settings.mcpInstructionCopilot': 'Abre la paleta de comandos ({shortcut}), ejecuta «MCP: Open User Configuration» y fusiona este JSON. Copilot Chat debe estar en modo Agent para que las herramientas aparezcan.',
  'settings.mcpInstructionAntigravity': 'En Antigravity: menú «...» del panel del Agent → MCP Servers → Manage MCP Servers → View raw config. Combina este JSON.',
  'settings.mcpInstructionZed': 'Abre los Ajustes de Zed ({shortcut}) y fusiona esto en el objeto de nivel superior. Zed usa «context_servers», no «mcpServers».',
  'settings.mcpInstructionWindsurf': 'Abre {path} (o usa el icono de MCP en Cascade → Configure) y combina:',
  'settings.mcpCopyAria': 'Copiar fragmento de configuración de MCP',
  'settings.mcpResolvingFailed': '# error al resolver las rutas, consulta el error anterior',
  'settings.mcpLoadingPaths': '# cargando rutas de instalación desde el daemon local…',
  'settings.mcpCopied': 'Copiado',
  'settings.mcpCopy': 'Copiar',
  'settings.mcpCursorApproval': 'Cursor muestra un cuadro de diálogo de aprobación antes de escribir la configuración.',
  'settings.mcpCodexOneClickInstall': 'Instalar en Codex',
  'settings.mcpCodexOneClickUninstall': 'Quitar de Codex',
  'settings.mcpCodexOneClickUnavailable': 'No se encontró Codex CLI en el PATH: instala Codex o pega el fragmento manualmente.',
  'settings.mcpCodexInstallSuccess': 'Instalado. Reinicia Codex para cargar el nuevo servidor.',
  'settings.mcpCodexUninstallSuccess': 'Eliminado de Codex.',
  'settings.mcpCodexBusy': 'Trabajando…',
  'settings.mcpCodexInstallError': 'La operación ha fallado: {error}',
  'settings.mcpRestartNote': 'Reinicia tu cliente para detectar el nuevo servidor.',
  'settings.mcpRestartDetail': 'La mayoría de los editores solo cargan los servidores MCP al iniciarse. En Cursor / VS Code / Antigravity / Windsurf puedes ejecutar `Developer: Reload Window` desde la paleta de comandos en lugar de un reinicio completo. Zed y local coding agents requieren cerrar y volver a abrir.',
  'settings.mcpCapabilitiesTitle': 'Qué puede hacer tu agent',
  'settings.mcpCapabilityRead': 'Leer o buscar cualquier archivo de un proyecto (HTML, JSX, CSS, JSON, SVG, Markdown).',
  'settings.mcpCapabilityPull': 'Obtener un paquete de diseño en una sola llamada: el archivo de entrada más cada variable CSS, componente y fuente a la que hace referencia.',
  'settings.mcpCapabilityDefault': 'Usar por defecto el proyecto y el archivo que tienes abiertos en Gini Studio, para que puedas decir «construye esto en mi app» sin indicar de nuevo qué diseño.',
  'settings.mcpRunningNote': 'Gini Studio debe estar en ejecución para que las llamadas a herramientas MCP funcionen. Si iniciaste tu agent de programación antes de abrir Gini Studio, reinicia el agent para que pueda contactar con el daemon activo.',
  'entry.tabDesigns': 'Diseños',
  'entry.tabTemplates': 'Plantillas',
  'entry.tabDesignSystems': 'Sistemas de diseño',
  'entry.tabConnectors': 'Conectores',
  'entry.openSettingsTitle': 'Ajustes',
  'entry.openSettingsAria': 'Abrir ajustes',
  'entry.discordLabel': 'Unirse a Discord',
  'entry.discordOnlineLabel': '{count} en línea',
  'entry.followXLabel': 'Sigue a @ginistudio en X',
  'entry.resizeAria': 'Redimensionar barra lateral',
  'entry.loadingWorkspace': 'Cargando espacio de trabajo…',
  'entry.useEverywhereTitle': 'Usar en todas partes',
  'entry.useEverywhereAria': 'Abrir la guía «Usar en todas partes» (CLI, MCP, HTTP, Skills)',
  'entry.navExpand': 'Mostrar barra lateral',
  'entry.navCollapse': 'Ocultar barra lateral',
  'entry.navNewProject': 'Nuevo proyecto',
  'entry.navHome': 'Inicio',
  'entry.navProjects': 'Proyectos',
  'entry.navTasks': 'Automatizaciones',
  'entry.navPlugins': 'Plugins',
  'entry.navDesignSystems': 'Sistemas de diseño',
  'entry.navIntegrations': 'Integraciones',
  'workspaceTabs.project': 'Proyecto',
  'workspaceTabs.pluginDetails': 'Detalles del plugin',
  'workspaceTabs.marketplace': 'Marketplace',
  'homeHero.title': '¿Qué quieres diseñar?',
  'homeHero.templatesScrollHint': 'Desplázate hacia arriba para explorar más plantillas',
  'homeHero.templatesCollapse': 'Contraer plantillas',
  'homeHero.subtitlePrefix': 'Design, build, and ship polished creative work with GINI Studio.',
  'homeHero.placeholder': 'Describe lo que quieres generar…',
  'homeHero.placeholderActive': 'Edita la consulta de ejemplo o escribe la tuya…',
  'homeHero.skills': 'Skills',
  'homeHero.addMenu': 'Añadir contexto',
  'homeHero.addPlugin': 'Añadir plugin',
  'homeHero.addConnectors': 'Añadir conectores',
  'homeHero.addMcp': 'Añadir servidor MCP',
  'homeHero.noPlugins': 'No hay plugins instalados',
  'homeHero.noMcp': 'No hay servidores MCP',
  'homeHero.noConnectors': 'No hay conectores conectados',
  'homeHero.applying': 'Aplicando…',
  'homeHero.pluginTitle': 'Plugin: {title}',
  'homeHero.pluginPrefix': 'Plugin: {title}',
  'homeHero.skillPrefix': 'Skill: {title}',
  'homeHero.removePlugin': 'Eliminar plugin',
  'homeHero.removePluginAria': 'Eliminar plugin {title}',
  'homeHero.clearActivePlugin': 'Quitar plugin activo',
  'homeHero.clearActiveSkill': 'Quitar skill activa',
  'homeHero.contextItemsResolved': '{n} elementos de contexto resueltos',
  'homeHero.removeFile': 'Eliminar archivo',
  'homeHero.contextSearchResults': 'Resultados de búsqueda de contexto',
  'homeHero.contextSurfaces': 'Fuentes de contexto',
  'homeHero.loadingContext': 'Cargando contexto…',
  'homeHero.noResults': 'No hay resultados para "{query}".',
  'homeHero.searchPrompt': 'Busca archivos, plugins, skills, servidores MCP y conectores.',
  'homeHero.parameters': '{n} parámetros',
  'homeHero.details': 'Detalles',
  'homeHero.toRun': 'para ejecutar',
  'homeHero.forNewLine': 'para nueva línea',
  'homeHero.run': 'Ejecutar',
  'homeHero.typeSomethingToRun': 'Escribe algo para ejecutar',
  'homeHero.promptExamples': 'Ejemplos',
  'homeHero.footer.designSystem': 'Estilo',
  'homeHero.footer.autoDesignSystem': 'Automático',
  'homeHero.footer.autoDesignSystemSummary': 'Elige automáticamente el sistema de diseño y estilo visual más adecuados para el prompt actual.',
  'homeHero.footer.ratio': 'Proporción',
  'homeHero.footer.duration': 'Duración',
  'homeHero.footer.resolution': 'Resolución',
  'homeHero.footer.speakerNotes': 'Notas',
  'homeHero.footer.noSpeakerNotes': 'Sin notas',
  'homeHero.footer.availableCount': '{n} disponibles',
  'homeHero.footer.noMatches': 'Sin coincidencias',
  'homeHero.moreShortcuts': 'Más',
  'homeHero.railAria': 'Elige una categoría de proyecto o un atajo inicial',
  'homeHero.subTypeAria': 'Elige un subtipo',
  'homeHero.confirmReplaceTitle': '¿Reemplazar el prompt actual?',
  'homeHero.confirmReplaceBody': 'Usar {title} reemplazará el texto que hay actualmente en la entrada.',
  'homeHero.confirmReplace': 'Reemplazar',
  'homeHero.chip.prototype': 'Prototipo',
  'homeHero.chip.liveArtifact': 'Artefacto en vivo',
  'homeHero.chip.deck': 'Presentación de diapositivas',
  'homeHero.chip.image': 'Imagen',
  'homeHero.chip.video': 'Vídeo',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.audio': 'Audio',
  'homeHero.chip.createPlugin': 'Crear plugin',
  'homeHero.chip.figma': 'Desde Figma',
  'homeHero.chip.folder': 'Desde carpeta',
  'homeHero.chip.template': 'Desde plantilla',
  'homeHero.chip.liveArtifactHint': 'Crea un artefacto interactivo de HTML/CSS/JS que puedes previsualizar en vivo.',
  'homeHero.chip.hyperframesHint': 'Crea animaciones basadas en HTML: subtítulos, elementos visuales que reaccionan al audio y transiciones de escena.',
  'homeHero.chip.createPluginHint': 'Crea un plugin reutilizable de Gini Studio y añádelo a Mis plugins.',
  'homeHero.chip.figmaHint': 'Migra un marco de Figma al sistema de diseño activo.',
  'homeHero.chip.folderHint': 'Importa una carpeta local existente y continúa editando.',
  'homeHero.chip.templateHint': 'Empieza desde una plantilla incluida.',
  'workingDirPicker.title': 'Carpeta',
  'workingDirPicker.homeTitle': 'Elige dónde debe ubicarse este proyecto',
  'workingDirPicker.processing': 'Procesando…',
  'workingDirPicker.select': 'Choose working directory',
  'workingDirPicker.clearAria': 'Borrar directorio de trabajo',
  'workingDirPicker.replaceFailed': 'No se pudo reemplazar el directorio de trabajo',
  'workingDirPicker.unavailable': 'El selector de carpetas no está disponible en esta versión. Ejecuta la aplicación de escritorio para elegir una carpeta.',
  'workingDirPicker.openUnavailable': 'Abre este proyecto en la aplicación de escritorio para mostrar la carpeta.',
  'workingDirPicker.openFailed': 'No se pudo mostrar esta carpeta',
  'workingDirPicker.showInFileManager': 'Mostrar en el explorador de archivos',
  'workingDirPicker.replace': 'Reemplazar directorio…',
  'workingDirPicker.recent': 'Directorios recientes',
  'handoff.toTarget': 'Transferir a {target}',
  'handoff.openInTarget': 'Abrir en {target}',
  'handoff.openAction': 'Abrir',
  'handoff.menuTitle': '¿En qué editor abrir?',
  'handoff.action': 'Transferir',
  'handoff.fallbackTitle': 'No se han encontrado editores en $PATH: se abre en {target}',
  'handoff.chooseTargetAria': 'Elegir destino de transferencia',
  'handoff.optionsAria': 'Opciones de transferencia',
  'handoff.editorSection': 'Abrir con un editor',
  'handoff.cliSection': 'Copiar para CLI',
  'handoff.clickOpen': 'Haz clic para abrir',
  'handoff.framework': 'Framework de código',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'JavaScript, HTML y CSS sin frameworks',
  'handoff.amrWebsite': 'Abrir el sitio web de AMR',
  'handoff.copyPrompt': 'Copiar prompt',
  'handoff.copyPromptForTarget': 'Copiar prompt para {target}',
  'handoff.copied': 'Copiado',
  'handoff.projectPathUnavailable': 'La ruta del proyecto aún se está cargando. Inténtalo de nuevo en un momento.',
  'handoff.copyFailed': 'Se ha bloqueado la escritura en el portapapeles. Inténtalo de nuevo en un momento.',
  'handoff.promptIntro': 'Continuar desde esta carpeta local del proyecto de Gini Studio:',
  'handoff.promptTarget': 'Destino',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'Vas a tomar el control en {cli}. Por favor:',
  'handoff.promptReadFiles': 'Entra en este directorio o léelo primero. Da prioridad a DESIGN.md, README, el HTML/CSS/JS existente, los recursos y package.json si está presente.',
  'handoff.promptKeepDesign': 'Conserva el diseño visual, la maquetación, las interacciones y los recursos actuales. No te detengas en un plan.',
  'handoff.promptProduceCode': 'Genera o modifica código {framework} real y ejecutable. Si el proyecto ya tiene un stack más claro, señala el conflicto y mantén el resultado ejecutable.',
  'handoff.promptVerify': 'Termina indicándome los comandos de ejecución, vista previa y verificación.',
  'handoff.promptCommandHint': 'Para empezar desde el directorio del proyecto, usa:',
  'handoff.promptProject': 'Proyecto',
  'handoff.promptProjectId': 'ID del proyecto',
  'handoff.notInstalled': 'No instalado',
  'handoff.notDetectedTitle': '{target}: no detectado en $PATH',
  'designSystemPicker.select': 'Elegir sistema de diseño',
  'designSystemPicker.loading': 'Cargando sistemas de diseño…',
  'designSystemPicker.searchPlaceholder': 'Buscar sistemas de diseño (título / categoría / resumen)',
  'designSystemPicker.searchCompactPlaceholder': 'Buscar sistemas de diseño',
  'designSystemPicker.noneTitle': 'Sin sistema de diseño',
  'designSystemPicker.noneSummary': 'Dejar que el modelo elija libremente',
  'designSystemPicker.empty': 'No hay sistemas de diseño coincidentes',
  'designSystemPicker.openPreview': 'Abrir vista previa',
  'designSystemPicker.loadingPreview': 'Cargando vista previa…',
  'designSystemPicker.noPreview': 'No hay página de vista previa. Abre Sistemas de diseño para ver la vista previa completa.',
  'designSystemPicker.previewHint': 'Pasa el cursor sobre un sistema de diseño para previsualizarlo',
  'designSystemPicker.fullscreenAria': 'Vista previa a pantalla completa de {title}',
  'designSystemPicker.closeFullscreen': 'Cerrar la vista previa a pantalla completa',
  'designSystemPicker.closeEsc': 'Cerrar (Esc)',
  'designSystemPicker.previewFrameTitle': 'Vista previa de {title}',
  'designSystemPicker.fullscreenFrameTitle': 'Vista previa a pantalla completa de {title}',
  'recentProjects.title': 'Proyectos recientes',
  'recentProjects.viewAll': 'Ver todo',
  'recentProjects.empty': 'Aún no hay proyectos: escribe un prompt para empezar uno.',
  'pluginsHome.title': 'Explore',
  'pluginsHome.subtitle': 'Flujos de trabajo de Gini Studio listos para usar incluidos con este runtime. Elige uno para cargar un prompt inicial o explora el registro para ver más.',
  'pluginsHome.browseRegistry': 'Explore all',
  'pluginsHome.count': '{filtered} de {total}',
  'pluginsHome.loadingCatalog': 'Cargando catálogo…',
  'pluginsHome.emptyCatalog': 'El catálogo está vacío. Los plugins integrados se incluyen con Gini Studio y deberían aparecer aquí automáticamente; prueba a reiniciar el daemon si esto persiste.',
  'pluginsHome.emptyFiltered': 'Ningún plugin coincide con los filtros actuales.',
  'pluginsHome.clearFilters': 'Borrar filtros',
  'pluginsHome.modeAria': 'Modo de plugin',
  'pluginsHome.featured': 'Guardado',
  'pluginsHome.totalInCatalog': '{n} en el catálogo',
  'pluginsHome.categoryFilterAria': 'Filtro de categoría',
  'pluginsHome.subcategoryFilterAria': 'Filtro de subcategoría de {label}',
  'pluginsHome.allCategory': 'Todos: {label}',
  'pluginsHome.searchPlaceholder': 'Buscar plugins…',
  'pluginsHome.searchAria': 'Buscar plugins',
  'pluginsHome.clearSearch': 'Borrar búsqueda',
  'pluginsHome.facet.import': 'Importar',
  'pluginsHome.facet.create': 'Crear',
  'pluginsHome.facet.export': 'Exportar',
  'pluginsHome.facet.share': 'Compartir',
  'pluginsHome.facet.deploy': 'Desplegar',
  'pluginsHome.facet.refine': 'Refinar',
  'pluginsHome.facet.extend': 'Ampliar',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'Código / carpeta',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'Captura de pantalla',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'Diapositivas',
  'pluginsHome.facet.publicLink': 'Enlace público',
  'pluginsHome.facet.githubPr': 'PR de GitHub',
  'pluginsHome.facet.githubGist': 'Gist de GitHub',
  'pluginsView.lede': 'Explora los flujos de trabajo instalados, descubre entradas del registro, gestiona fuentes y prepara plugins para distribuirlos al equipo.',
  'pluginsView.importPlugin': 'Importar plugin',
  'pluginsView.agentContext': 'Contexto del agent',
  'pluginsView.summaryAria': 'Resumen del plugin',
  'pluginsView.areasAria': 'Áreas del plugin',
  'pluginsView.loading': 'Cargando plugins…',
  'pluginsView.tab.installed': 'Instalado',
  'pluginsView.tab.available': 'Disponible',
  'pluginsView.tab.sources': 'Fuentes',
  'pluginsView.tab.team': 'Equipo',
  'pluginsView.tabHint.installed': 'Tus plugins',
  'pluginsView.tabHint.available': 'Desde fuentes',
  'pluginsView.tabHint.sources': 'Catálogos',
  'pluginsView.tabHint.team': 'Empresa',
  'pluginsView.installedTitle': 'Plugins instalados',
  'pluginsView.installedSubtitle': 'Plugins que has importado o instalado desde fuentes de marketplace.',
  'pluginsView.installedEmpty': 'Todavía no hay plugins de usuario instalados. Usa Crear / Importar o instala una entrada Disponible.',
  'pluginsView.availableTitle': 'Disponibles desde fuentes',
  'pluginsView.availableSubtitle': 'Entradas del catálogo descubiertas en los marketplaces configurados.',
  'pluginsView.availableFiltersAria': 'Filtros de plugins disponibles',
  'pluginsView.searchAvailableAria': 'Buscar plugins disponibles',
  'pluginsView.searchAvailablePlaceholder': 'Buscar plugins disponibles',
  'pluginsView.clearAvailableSearch': 'Borrar búsqueda de plugins disponibles',
  'pluginsView.source': 'Fuente',
  'pluginsView.availableEmptyInstalled': 'Todavía no hay entradas disponibles. Las entradas del catálogo instaladas se quitan de Disponible; desinstala una para volver a hacerla disponible.',
  'pluginsView.availableEmptyFiltered': 'Ninguna entrada disponible coincide con tus filtros.',
  'pluginsView.availableEmptyNoSources': 'Todavía no hay entradas disponibles. Añade una fuente en la pestaña Fuentes.',
  'pluginsView.installing': 'Instalando…',
  'pluginsView.install': 'Instalar',
  'pluginsView.sourcesTitle': 'Fuentes de registro',
  'pluginsView.sourcesSubtitle': 'Catálogos del marketplace que alimentan las entradas de plugins disponibles.',
  'pluginsView.sourceUrl': 'URL de origen',
  'pluginsView.defaultTrust': 'Confianza predeterminada',
  'pluginsView.trust.restricted': 'Restringido',
  'pluginsView.trust.trusted': 'De confianza',
  'pluginsView.trust.official': 'Oficial',
  'pluginsView.adding': 'Añadiendo…',
  'pluginsView.addSource': 'Añadir fuente',
  'pluginsView.sourcesEmpty': 'Aún no hay fuentes de registro configuradas.',
  'pluginsView.pluginsCount': '{n} plugins',
  'pluginsView.catalogVersion': 'catálogo v{version}',
  'pluginsView.trustFor': 'Confianza para {name}',
  'pluginsView.refreshing': 'Actualizando…',
  'pluginsView.removing': 'Eliminando…',
  'pluginsView.teamTitle': 'Marketplaces privados de equipo',
  'pluginsView.teamBody': 'Esta área está reservada para catálogos empresariales y de equipo, políticas de confianza privadas y controles compartidos del ciclo de vida de los plugins.',
  'pluginCard.details': 'Detalles',
  'pluginCard.use': 'Usar',
  'pluginCard.useWithQuery': 'Usar con consulta',
  'pluginCard.applying': 'Aplicando…',
  'pluginCard.publish': 'Publicar',
  'pluginCard.contribute': 'Contribuir',
  'pluginCard.starting': 'Iniciando…',
  'pluginCard.detailsAria': 'Ver detalles de {title}',
  'pluginCard.chooseUseAria': 'Elige cómo usar {title}',
  'pluginCard.useOptionsAria': 'Opciones de uso de {title}',
  'pluginCard.shareAria': 'Compartir {title}',
  'pluginCard.publishAria': 'Publicar {title} como repositorio de GitHub',
  'pluginCard.publishTitle': 'Publicar plugin como repositorio de GitHub',
  'pluginCard.contributeAria': 'Contribuir con {title} a Gini Studio',
  'pluginCard.contributeTitle': 'Contribuir con el plugin a Gini Studio mediante un pull request',
  'skillPluginCandidate.createForMe': 'Crear por mí',
  'skillPluginCandidate.contributeToMain': 'Contribuir a main',
  'skillPluginCandidate.publishRepo': 'Publicar repositorio',
  'skillPluginCandidate.dismiss': 'Descartar',
  'skillPluginCandidate.repoDescription': 'Este repositorio parece que podría funcionar como plugin.',
  'integrations.kicker': 'Integración',
  'integrations.lede': 'Conecta sistemas externos, incorpora herramientas MCP a tu bucle de agente y usa Gini Studio desde otros IDE, scripts y automatizaciones.',
  'integrations.agentReady': 'Listo para agentes',
  'integrations.areasAria': 'Áreas de integración',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Skills',
  'integrations.tabHint.mcp': 'Herramientas externas',
  'integrations.tabHint.connectors': 'Cuentas y API',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'Integraciones de Skills',
  'integrations.skillsBody': 'La gestión de integraciones a nivel de Skill se está trasladando desde otra rama. Esta pestaña está reservada para que MCP, los conectores y la futura configuración de Skills convivan en la misma ruta de Integración.',
  'mcpClient.title': 'Servidores MCP externos',
  'mcpClient.subtitle': 'Herramientas de terceros para tu agente de programación.',
  'mcpClient.addServer': 'Añadir servidor',
  'mcpClient.emptyTitle': 'No hay servidores MCP configurados.',
  'mcpClient.emptyBody': 'Haz clic en «Añadir servidor» para empezar: elige una plantilla (Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…) o configura un servidor stdio / HTTP personalizado.',
  'mcpClient.saveChanges': 'Guardar cambios',
  'mcpClient.storedAt': 'Almacenado en',
  'mcpClient.daemonError': 'No se pudo conectar con el daemon local. Asegúrate de que Gini Studio esté en ejecución y vuelve a abrir este panel.',
  'mcpClient.saveFailed': 'Error al guardar. Comprueba que el daemon esté en ejecución e inténtalo de nuevo.',
  'useEverywhere.modalAria': 'Usa Gini Studio en todas partes',
  'useEverywhere.modalTitle': 'Usa Gini Studio en todas partes',
  'useEverywhere.modalSubtitle': 'Integra Gini Studio en cualquier IDE, Agent o script: CLI, HTTP, MCP y Skills. Usa «Copiar guía para un Agent» y pégala en local coding agents, Codex, Cursor, openclaw o hermes para configurarlo todo.',
  'useEverywhere.closeAria': 'Cerrar usar en todas partes',
  'useEverywhere.closeTitle': 'Cerrar (Esc)',
  'useEverywhere.tabsAria': 'Superficies de integración',
  'useEverywhere.footStrong': 'Transferencia con un solo clic.',
  'useEverywhere.footBody': 'Copia una guía estructurada en markdown sobre la que tu Agent puede actuar de inmediato: instalar, verificar y usar.',
  'useEverywhere.configureMcp': 'Configurar servidor MCP',
  'useEverywhere.copyGuide': 'Copiar guía para un agente',
  'useEverywhere.copy': 'Copiar',
  'useEverywhere.copied': 'Copiado',
  'useEverywhere.copyFailed': 'Error al copiar',
  'useEverywhere.copySnippetAria': 'Copiar fragmento: {label}',
  'useEverywhere.section.overview.tab': 'Resumen',
  'useEverywhere.section.overview.heading': 'Gini Studio funciona allí donde funcione tu agent',
  'useEverywhere.section.overview.intro': 'Gini Studio es más que una ventana: es un daemon local con privilegios (`od`) más un registro de Skills + Sistemas de diseño + Atoms. Una vez que se está ejecutando en tu máquina, cualquier Agent de código (local coding agents, Codex, Cursor, OpenCode/openclaw, Hermes, tu propio script) puede impulsar generaciones, inspeccionar proyectos y producir artefactos de diseño a través de cuatro superficies intercambiables.',
  'useEverywhere.section.overview.bullet1': 'CLI: `od <command>` para scripts headless, CI y automatización de shell.',
  'useEverywhere.section.overview.bullet2': 'Servidor MCP: conecta Gini Studio como servidor Model Context Protocol para que cualquier Agent compatible con MCP pueda listar skills, ejecutar escenarios y leer artefactos.',
  'useEverywhere.section.overview.bullet3': 'API HTTP: endpoints REST + SSE en `http://127.0.0.1:7456/api/*`; la misma superficie que usa la interfaz web.',
  'useEverywhere.section.overview.bullet4': 'Skills: paquetes `SKILL.md` listos para usar (compatibles con Claude) que cualquier Agent que ya esté en tu PATH puede invocar sin necesidad de Gini Studio.',
  'useEverywhere.section.overview.bullet5': 'Artefactos estándar: genera proyectos HTML reales a partir de Skills, plugins predeterminados integrados y ejemplos de plugins de la comunidad antes de que arranque el daemon.',
  'useEverywhere.section.overview.snippet1': 'Inicia el daemon (y la interfaz web) localmente',
  'useEverywhere.section.overview.snippet2': 'Confirma que es accesible',
  'useEverywhere.section.overview.snippet3': 'Ingiere los artefactos estándar antes del arranque',
  'useEverywhere.section.overview.footer': 'El daemon escribe en `./.od/` (local del proyecto) de forma predeterminada. Define `OD_DATA_DIR=~/.open-design` para compartir datos entre proyectos.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'Controla Gini Studio desde cualquier shell',
  'useEverywhere.section.cli.intro': 'El binario `od` se incluye con el daemon y es el mismo binario que usan local coding agents / Codex cuando ejecutan una generación. La mayoría de los subcomandos son clientes ligeros que hacen POST al daemon local, por lo que funcionan igual tanto si lo lanzaste con `pnpm tools-dev` como si lo hiciste como aplicación empaquetada.',
  'useEverywhere.section.cli.bullet1': '`od` (sin argumentos): arranca el daemon y abre la interfaz web.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...`: produce bytes de imagen / vídeo / audio a través del protocolo de medios unificado.',
  'useEverywhere.section.cli.bullet3': '`od run ...`: inicia la ejecución de un proyecto a partir de un prompt + skill.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>`: instala y aplica plugins de la comunidad.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list`: inspecciona lo que está disponible localmente.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor`: verifica el estado del daemon y detecta CLIs de Agent en tu PATH.',
  'useEverywhere.section.cli.snippet1': 'Genera una imagen (delega en el proveedor de medios configurado)',
  'useEverywhere.section.cli.snippet2': 'Ejecuta un plugin de escenario sin interfaz y transmite eventos como líneas JSON',
  'useEverywhere.section.cli.snippet3': 'Inventaría las skills y los sistemas de diseño disponibles localmente',
  'useEverywhere.section.cli.snippet4': 'Comprueba los artefactos sembrados a través de la CLI',
  'useEverywhere.section.cli.snippet5': 'Verificar entorno + Agents detectados (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': 'Todos los subcomandos aceptan `--daemon-url http://127.0.0.1:<port>` para apuntar a un daemon en ejecución concreto, útil cuando se ejecuta una segunda instancia aislada para pruebas.',
  'useEverywhere.section.mcp.tab': 'Servidor MCP',
  'useEverywhere.section.mcp.heading': 'Expón Gini Studio como servidor MCP a cualquier agent de programación',
  'useEverywhere.section.mcp.intro': 'Gini Studio incluye un servidor Model Context Protocol (`od mcp`) que permite a cualquier cliente compatible con MCP —Cursor, local coding agents, Antigravity, VS Code Copilot Chat, openclaw, hermes— descubrir las herramientas de Gini Studio (listar skills, renderizar vistas previas, generar medios, ejecutar plugins) sin tener que recurrir manualmente a la shell. El daemon publica un fragmento de instalación listo para pegar mediante `GET /api/mcp/install-info` para cada cliente principal.',
  'useEverywhere.section.mcp.bullet1': 'Transporte stdio: sin puerto adicional, el cliente lanza `od mcp` directamente.',
  'useEverywhere.section.mcp.bullet2': 'Detecta automáticamente la URL del daemon en ejecución a través del socket de estado IPC local cuando se lanza como sidecar.',
  'useEverywhere.section.mcp.bullet3': 'Recurre a `--daemon-url http://127.0.0.1:<port>` en las instalaciones simples para que el proceso MCP siempre encuentre un daemon en ejecución.',
  'useEverywhere.section.mcp.bullet4': 'Fija `OD_DATA_DIR` para que el proceso MCP generado escriba en el mismo lugar que ya usa el daemon (evita EPERM en los paquetes de aplicaciones de macOS).',
  'useEverywhere.section.mcp.snippet1': 'Configuración genérica de cliente MCP (funciona en Cursor, local coding agents, Codex, …)',
  'useEverywhere.section.mcp.snippet2': 'O: pide al daemon el fragmento adaptado a tu instalación',
  'useEverywhere.section.mcp.snippet3': 'Variante MCP de artefactos en vivo (leer y actualizar paneles)',
  'useEverywhere.section.mcp.footer': 'En la app de Gini Studio, abre Ajustes → Integraciones para copiar un comando de instalación específico del cliente (Cursor, local coding agents, Antigravity, VS Code) en lugar de editar el JSON a mano.',
  'useEverywhere.section.http.tab': 'API HTTP',
  'useEverywhere.section.http.heading': 'La misma superficie REST + SSE que usa la interfaz web',
  'useEverywhere.section.http.intro': 'El daemon local sirve una API HTTP en `http://127.0.0.1:7456` (puerto configurable). Cada endpoint que llama la interfaz web también está disponible para tus scripts. Los endpoints de streaming (turnos de chat, ejecuciones de proyectos) emiten Server-Sent Events con los tipos de contrato de `@open-design/contracts`.',
  'useEverywhere.section.http.bullet1': '`GET /api/health`: actividad del daemon.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` y `GET /api/design-systems`: registros disponibles.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` y `POST /api/projects`: lista y crea proyectos (POST devuelve el proyecto + la primera conversación).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat`: flujo SSE de eventos del Agent para una conversación.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply`: vincula un plugin instalado y obtén su consulta de ejemplo renderizada + las entradas.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents`: CLIs de Agent de código detectados en tu PATH.',
  'useEverywhere.section.http.snippet1': 'Lista las skills instaladas (el agent las usará como plantillas)',
  'useEverywhere.section.http.snippet2': 'Crea un proyecto a partir de un prompt (flujo completo en el servidor)',
  'useEverywhere.section.http.snippet3': 'Transmite un turno de chat (SSE: cada línea es compatible con JSON-Lines)',
  'useEverywhere.section.http.footer': 'Los tipos de TypeScript puros para cada solicitud/respuesta residen en `@open-design/contracts`: impórtalos en tu script para tener autocompletado completo sin tener que configurar un generador.',
  'useEverywhere.section.skills.tab': 'Skills y sin interfaz',
  'useEverywhere.section.skills.heading': 'Skills listas para usar con cualquier Agent, incluso sin Gini Studio en ejecución',
  'useEverywhere.section.skills.intro': 'Una Skill es un directorio con un `SKILL.md` compatible con Claude (front-matter YAML + cuerpo). Gini Studio amplía el formato con el espacio de nombres `od:` (`mode`, `preview`, `design_system`, `inputs`, …) para que el mismo artefacto pueda usarse tanto dentro de Gini Studio como por un Agent corriente como local coding agents, Codex, openclaw o hermes. El descubrimiento sigue una cadena de precedencia para que los proyectos puedan anular sus propias skills.',
  'useEverywhere.section.skills.bullet1': 'Descubrimiento: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (gana el proyecto).',
  'useEverywhere.section.skills.bullet2': 'Crea un enlace simbólico de una skill en varios proyectos para compartirla sin copiarla.',
  'useEverywhere.section.skills.bullet3': 'Cada skill puede declarar conectores, átomos, requisitos del sistema de diseño y un ejemplo de salida `preview` para la galería.',
  'useEverywhere.section.skills.bullet4': 'Sin interfaz: un agent con `od` en su PATH puede llamar a `od skills list` y luego ejecutar cualquier skill; el daemon es opcional para los flujos de solo lectura.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` ejercita la misma forma de artefacto con ejemplos de plugins predeterminados y ejemplos de plugins de la comunidad, y luego almacena los proyectos `index.html` resultantes como datos de prueba reutilizables.',
  'useEverywhere.section.skills.snippet1': 'SKILL.md mínimo (front matter compatible con Claude + extras de Gini Studio)',
  'useEverywhere.section.skills.snippet2': 'Crea un enlace simbólico de una skill compartida en un proyecto (estilo cc-switch)',
  'useEverywhere.section.skills.snippet3': 'Sin interfaz: lista las skills que el daemon ve ahora mismo',
  'useEverywhere.section.skills.snippet4': 'Paquete de fixtures de artefactos sin interfaz',
  'useEverywhere.section.skills.footer': 'Especificación: `docs/skills-protocol.md` y `docs/agent-adapters.md` cubren toda la superficie de adaptadores (local coding agents, Codex, Cursor, agents compatibles con MCP, alternativa de API BYOK) y las estrategias de inyección de skills por adaptador.',
  'tasks.kicker': 'Espacio de trabajo de automatización',
  'tasks.comingSoon': 'Próximamente',
  'tasks.lede': 'Las automatizaciones convierten los prompts en trabajo duradero: Orbit las ejecuta, las rutinas las mantienen, las programaciones deciden cuándo se disparan y los artefactos en vivo muestran lo que ha cambiado.',
  'tasks.newAutomation': 'Nueva automatización',
  'tasks.previewNote': 'Solo superficie de vista previa. Los ajustes de Orbit ya están disponibles hoy; las rutinas, las programaciones y la conexión de artefactos en vivo llegarán a medida que se fusionen las ramas del backend.',
  'tasks.primitivesAria': 'Primitivas de automatización',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'Un runtime persistente para trabajo de agent prolongado o recurrente.',
  'tasks.primitive.orbit.enabled': 'Resumen diario activado',
  'tasks.primitive.orbit.manualOnly': 'Solo manual',
  'tasks.primitive.routines.title': 'Rutinas',
  'tasks.primitive.routines.body': 'Definiciones de tareas duraderas que perduran tras finalizar un solo chat.',
  'tasks.primitive.routines.meta': 'Shell del producto lista',
  'tasks.primitive.schedules.title': 'Programaciones',
  'tasks.primitive.schedules.body': 'Disparadores de tiempo o de evento que deciden cuándo debe ejecutarse una rutina.',
  'tasks.primitive.schedules.meta': 'Rama pendiente',
  'tasks.primitive.liveArtifacts.title': 'Artefactos en vivo',
  'tasks.primitive.liveArtifacts.body': 'Informes y notas que se siguen actualizando mientras un agent trabaja.',
  'tasks.primitive.liveArtifacts.meta': 'Modelo de vista previa',
  'tasks.listAria': 'Lista de automatizaciones',
  'tasks.routinesAndRuns': '{n} rutinas y ejecuciones',
  'tasks.filtersAria': 'Filtros de automatización',
  'tasks.filter.scheduled': 'Programado',
  'tasks.filter.running': 'En ejecución',
  'tasks.filter.done': 'Hecho',
  'tasks.configurationAria': 'Configuración de la automatización',
  'tasks.slot.trigger': 'Disparador',
  'tasks.slot.pattern': 'Patrón',
  'tasks.slot.runtime': 'Entorno de ejecución',
  'tasks.slot.output': 'Salida',
  'tasks.liveArtifact': 'Artefacto en vivo',
  'tasks.viewProgress': 'Ver progreso',
  'tasks.pause': 'Pausar',
  'tasks.runNow': 'Ejecutar ahora',
  'tasks.openArtifact': 'Abrir artefacto',
  'tasks.status.dailyAt': 'Diario · {time}',
  'tasks.status.pausedManual': 'En pausa · solo manual',
  'tasks.sample.orbit.title': 'Resumen del conector de Orbit Daily',
  'tasks.sample.orbit.metaEnabled': 'El resumen del conector está programado',
  'tasks.sample.orbit.metaDisabled': 'Abre los ajustes de Orbit para activarlo',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · artefacto en vivo',
  'tasks.sample.orbit.previewDisabled': 'No hay ninguna ejecución programada',
  'tasks.sample.orbit.triggerEnabled': 'Programación · diariamente a las {time}',
  'tasks.sample.orbit.triggerDisabled': 'Manual · ejecutar bajo demanda',
  'tasks.sample.orbit.pattern': 'Rutina · resumen de conectores',
  'tasks.sample.orbit.runtime': 'Orbit · programado por el daemon',
  'tasks.sample.orbit.output': 'Artefacto en vivo · informe actualizable',
  'tasks.sample.orbit.artifactMetaEnabled': 'Se actualiza tras cada ejecución',
  'tasks.sample.orbit.artifactMetaDisabled': 'Esperando la programación',
  'tasks.sample.orbit.body1': '# Resumen de actividad de Orbit Daily',
  'tasks.sample.orbit.body2': 'Conectores comprobados · aciertos, omisiones y fallos',
  'tasks.sample.orbit.body3': 'Los aspectos destacados se convierten en un artefacto en vivo actualizable.',
  'tasks.sample.mcp.title': 'Investigación de alternativas a MCP',
  'tasks.sample.mcp.status': 'Ejecutándose en orbit · 2h 14min',
  'tasks.sample.mcp.meta': '14 / 30 fuentes procesadas',
  'tasks.sample.mcp.preview': 'research_notes.md · en directo',
  'tasks.sample.mcp.trigger': 'Manual · una sola vez',
  'tasks.sample.mcp.pattern': 'Prompt de investigación profunda',
  'tasks.sample.mcp.runtime': 'Remoto · persistente',
  'tasks.sample.mcp.output': 'Informe en directo · actualización automática',
  'tasks.sample.mcp.artifactMeta': 'Actualizado hace 12 s',
  'tasks.sample.mcp.body1': '# Alternativas a MCP: hallazgos provisionales',
  'tasks.sample.mcp.body2': '14 fuentes revisadas · 3 candidatos preseleccionados',
  'tasks.sample.mcp.body3': '## Lista de preseleccionados',
  'tasks.sample.mcp.body4': '- Esquemas de llamadas a herramientas mediante JSON-RPC...',
  'tasks.sample.mcp.body5': '- Protocolos de Agent basados en gRPC...',
  'tasks.sample.weekly.title': 'Resumen semanal del equipo',
  'tasks.sample.weekly.status': 'Siguiente: lun 9:00',
  'tasks.sample.weekly.meta': 'Actualiza el documento semanal del equipo',
  'tasks.sample.weekly.preview': 'team_weekly.md · siguiente artefacto',
  'tasks.sample.weekly.trigger': 'Programación · semanal',
  'tasks.sample.weekly.pattern': 'Rutina · resumen del equipo',
  'tasks.sample.weekly.runtime': 'Remoto · recurrente',
  'tasks.sample.weekly.output': 'Artefacto en directo · markdown',
  'tasks.sample.weekly.artifactMeta': 'Última actualización hace 4 d',
  'tasks.sample.weekly.body1': '# Resumen semanal del equipo',
  'tasks.sample.weekly.body2': '## En curso',
  'tasks.sample.weekly.body3': '- Revisión de integración del sistema de diseño',
  'tasks.sample.weekly.body4': '- Repaso de calidad de los conectores',
  'tasks.sample.weekly.body5': '## Riesgos',
  'tasks.sample.pr.title': 'Recordatorio de revisión de PR',
  'tasks.sample.pr.status': 'Con cada PR nuevo · activado hace 23min',
  'tasks.sample.pr.meta': 'Envía un mensaje directo de Slack',
  'tasks.sample.pr.preview': 'La última entrega se realizó correctamente',
  'tasks.sample.pr.trigger': 'Evento · PR nuevo',
  'tasks.sample.pr.pattern': 'Rutina · notificación',
  'tasks.sample.pr.runtime': 'Local · ejecución rápida',
  'tasks.sample.pr.output': 'Mensaje · mensaje directo de Slack',
  'tasks.sample.pr.artifactMeta': 'Última activación hace 23 min',
  'tasks.sample.pr.body1': 'Se abrió el PR n.º 184 para revisión',
  'tasks.sample.pr.body2': 'Revisores asignados: design-platform, web-runtime',
  'tasks.sample.pr.body3': 'Entrega: mensaje directo de Slack enviado',
  'tasks.sample.meeting.title': 'Preparación previa a la reunión',
  'tasks.sample.meeting.status': 'Mañana · 10:00',
  'tasks.sample.meeting.meta': 'Una sola vez · envía resumen',
  'tasks.sample.meeting.preview': 'meeting_brief.md · en cola',
  'tasks.sample.meeting.trigger': 'Programación · una sola vez',
  'tasks.sample.meeting.pattern': 'Prompt de preparación',
  'tasks.sample.meeting.runtime': 'Remoto · limitado',
  'tasks.sample.meeting.output': 'Artefacto + mensaje',
  'tasks.sample.meeting.artifactMeta': 'En cola para generación',
  'tasks.sample.meeting.body1': '# Resumen de la reunión',
  'tasks.sample.meeting.body2': 'Fuente del orden del día: evento del calendario + documentos vinculados',
  'tasks.sample.meeting.body3': 'La salida incluirá decisiones, bloqueos y preguntas.',
  'tasks.sample.candidate.title': 'Seguimiento de candidatos',
  'tasks.sample.candidate.status': 'Fallido · requiere atención',
  'tasks.sample.candidate.meta': 'Autenticación caducada',
  'tasks.sample.candidate.preview': 'Vuelve a conectar Greenhouse para reanudar',
  'tasks.sample.candidate.trigger': 'Programación · diaria',
  'tasks.sample.candidate.pattern': 'Rutina · sincronización de candidatos',
  'tasks.sample.candidate.runtime': 'Remoto · recurrente',
  'tasks.sample.candidate.output': 'Artefacto en directo · tabla',
  'tasks.sample.candidate.artifactMeta': 'En pausa hasta que se restablezca la autenticación',
  'tasks.sample.candidate.body1': '# Flujo de candidatos',
  'tasks.sample.candidate.body2': 'Última sincronización correcta: hace 2 d',
  'tasks.sample.candidate.body3': 'Acción requerida: vuelve a conectar la cuenta de origen.',
  'routines.title': 'Automatizaciones',
  'routines.subtitle': 'Automatizaciones programadas que se ejecutan sin supervisión.',
  'routines.newAutomation': 'Nueva automatización',
  'routines.loading': 'Cargando…',
  'routines.empty': 'Todavía no hay automatizaciones.',
  'routines.emptyHint': 'Haz clic en Nueva automatización para programar una ejecución del agent sin supervisión.',
  'routines.runHistoryLoading': 'Cargando ejecuciones…',
  'routines.runHistoryEmpty': 'Todavía no hay ejecuciones.',
  'routines.fieldName': 'Nombre',
  'routines.fieldNamePlaceholder': 'Resumen matutino',
  'routines.fieldPrompt': 'Prompt',
  'routines.fieldPromptPlaceholder': 'Extrae la actividad de ayer en GitHub + Linear y resume lo que cambió.',
  'routines.fieldSchedule': 'Programación',
  'routines.fieldMinute': 'Minuto de cada hora',
  'routines.fieldTime': 'Hora',
  'routines.fieldTimezone': 'Zona horaria',
  'routines.fieldsetProject': 'Proyecto',
  'routines.kind.hourly': 'Cada hora',
  'routines.kind.daily': 'Diariamente',
  'routines.kind.weekdays': 'Días laborables',
  'routines.kind.weekly': 'Semanalmente',
  'routines.weekday.short.0': 'Dom',
  'routines.weekday.short.1': 'Lun',
  'routines.weekday.short.2': 'Mar',
  'routines.weekday.short.3': 'Mié',
  'routines.weekday.short.4': 'Jue',
  'routines.weekday.short.5': 'Vie',
  'routines.weekday.short.6': 'Sáb',
  'routines.weekday.long.0': 'Domingo',
  'routines.weekday.long.1': 'Lunes',
  'routines.weekday.long.2': 'Martes',
  'routines.weekday.long.3': 'Miércoles',
  'routines.weekday.long.4': 'Jueves',
  'routines.weekday.long.5': 'Viernes',
  'routines.weekday.long.6': 'Sábado',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'Se ejecuta cada hora en el :{minute}',
  'routines.describe.daily': 'Se ejecuta diariamente a las {time} {tz}',
  'routines.describe.weekdays': 'Se ejecuta de lun. a vie. a las {time} {tz}',
  'routines.describe.weekly': 'Se ejecuta cada {day} a las {time} {tz}',
  'routines.modeCreate': 'Crear un proyecto nuevo en cada ejecución',
  'routines.modeCreateHint': 'Un espacio de trabajo nuevo y aislado en cada disparo.',
  'routines.modeReuse': 'Reutilizar un proyecto existente',
  'routines.modeReuseHint': 'Cada ejecución se aloja como una conversación nueva dentro del proyecto.',
  'routines.pickProject': '— Elige un proyecto —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ nuevo proyecto en cada ejecución',
  'routines.tagPaused': 'en pausa',
  'routines.metaNext': 'siguiente: {when}',
  'routines.metaLast': 'última:',
  'routines.triggerManual': 'manual',
  'routines.triggerScheduled': 'programada',
  'routines.openProject': 'Abrir proyecto',
  'routines.openProjectTitle': 'Abrir el proyecto en el que escribió esta ejecución',
  'routines.runNow': 'Ejecutar ahora',
  'routines.edit': 'Editar',
  'routines.pause': 'Pausar',
  'routines.resume': 'Reanudar',
  'routines.history': 'Historial',
  'routines.hideHistory': 'Ocultar historial',
  'routines.delete': 'Eliminar',
  'routines.deleteTitle': 'Eliminar esta automatización',
  'routines.cancel': 'Cancelar',
  'routines.save': 'Guardar',
  'routines.saving': 'Guardando…',
  'routines.create': 'Crear',
  'routines.creating': 'Creando…',
  'routines.status.queued': 'en cola',
  'routines.status.running': 'en ejecución',
  'routines.status.succeeded': 'completada',
  'routines.status.failed': 'fallida',
  'routines.status.canceled': 'cancelado',
  'routines.confirmDelete': '¿Eliminar esta automatización? Se conservan las ejecuciones anteriores y sus proyectos.',
  'routines.errorPickProject': 'Elige un proyecto para reutilizarlo o cambia a «Crear uno nuevo en cada ejecución»',
  'routines.errorAgentEmptyOutput': 'El agent finalizó sin generar ningún resultado. Es posible que el modelo o el proveedor devolviera una respuesta vacía; revisa los registros del agent para ver si hay errores anteriores.',
  'entry.helpAria': 'Ayuda',
  'entry.helpMenuAria': 'Menú de ayuda',
  'entry.helpGetHelp': 'Obtener ayuda en GitHub',
  'entry.helpSubmitFeature': 'Enviar una sugerencia',
  'entry.helpWhatsNew': 'Novedades',
  'entry.helpDownloadDesktop': 'Descargar app de escritorio',
  'entry.tabImageTemplates': 'Plantillas de imagen',
  'entry.tabVideoTemplates': 'Plantillas de vídeo',
  'promptTemplates.searchPlaceholder': 'Buscar plantillas…',
  'promptTemplates.countLabel': '{n} resultados',
  'promptTemplates.emptyImage': 'Aún no hay plantillas de prompt de imagen instaladas.',
  'promptTemplates.emptyVideo': 'Aún no hay plantillas de prompt de vídeo instaladas.',
  'promptTemplates.emptyNoMatch': 'Ninguna plantilla coincide con tu búsqueda.',
  'promptTemplates.attributionFooter': 'Adaptadas de bibliotecas públicas de prompts. Cada tarjeta enlaza al autor original.',
  'promptTemplates.openPreviewTitle': 'Abrir prompt y vista previa',
  'promptTemplates.sourcePrefix': 'Fuente:',
  'promptTemplates.fetchError': 'No se pudo cargar el cuerpo de esta plantilla.',
  'promptTemplates.promptLabel': 'Cuerpo del prompt',
  'promptTemplates.copyPrompt': 'Copiar prompt',
  'promptTemplates.copyDone': '¡Copiado!',
  'promptTemplates.modelHint': 'Modelo sugerido: {model}',
  'promptTemplates.openSource': 'Ver original',
  'promptTemplates.openFullscreen': 'Abrir vista previa en pantalla completa',
  'promptTemplates.closeFullscreen': 'Cerrar vista previa en pantalla completa',
  'promptTemplates.allSources': 'Todas las fuentes',
  'promptTemplates.sourceFilterAria': 'Filtrar por fuente',
  'promptTemplates.retry': 'Reintentar',
  'connectors.title': 'Conectores',
  'connectors.subtitle': 'Fuentes de datos locales y futuras que pueden alimentar artefactos en vivo.',
  'connectors.account': 'Cuenta',
  'connectors.noAccount': 'Sin conectar',
  'connectors.tools': 'Herramientas',
  'connectors.connect': 'Conectar',
  'connectors.disconnect': 'Desconectar',
  'connectors.authorizationPending': 'Esperando autorización...',
  'connectors.authorizationPendingHint': 'Completa la autorización en la ventana abierta.',
  'connectors.cancelAuthorization': 'Cancelar',
  'connectors.configure': 'Configurar',
  'connectors.unavailable': 'No disponible',
  'connectors.phaseStubTitle': 'Las API de conectores llegarán en la fase 3; esta es una superficie de vista previa.',
  'connectors.statusAvailable': 'Disponible',
  'connectors.statusConnected': 'Conectado',
  'connectors.statusError': 'Error',
  'connectors.statusDisabled': 'Desactivado',
  'connectors.gateTitle': 'Añade tu API key de Composio para continuar',
  'connectors.gateBody': 'Pega tu clave arriba y haz clic en Guardar clave para cargar las integraciones disponibles.',
  'connectors.aboutLabel': 'Acerca de',
  'connectors.detailsLabel': 'Detalles',
  'connectors.statusLabel': 'Estado',
  'connectors.category.aiAgents': 'Agents de IA',
  'connectors.category.aiInfrastructure': 'Infraestructura de IA',
  'connectors.category.accounting': 'Contabilidad',
  'connectors.category.admin': 'Administración',
  'connectors.category.advertising': 'Publicidad',
  'connectors.category.analytics': 'Analítica',
  'connectors.category.automation': 'Automatización',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Calendario',
  'connectors.category.commerce': 'Comercio',
  'connectors.category.communication': 'Comunicación',
  'connectors.category.contacts': 'Contactos',
  'connectors.category.dataPlatform': 'Plataforma de datos',
  'connectors.category.database': 'Base de datos',
  'connectors.category.design': 'Diseño',
  'connectors.category.developer': 'Desarrollador',
  'connectors.category.documentation': 'Documentación',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Educación',
  'connectors.category.email': 'Correo electrónico',
  'connectors.category.events': 'Eventos',
  'connectors.category.fieldService': 'Servicio de campo',
  'connectors.category.finance': 'Finanzas',
  'connectors.category.fitness': 'Fitness',
  'connectors.category.forms': 'Formularios',
  'connectors.category.gaming': 'Videojuegos',
  'connectors.category.hr': 'HR',
  'connectors.category.hospitality': 'Hostelería',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Integración',
  'connectors.category.localization': 'Localización',
  'connectors.category.logistics': 'Logística',
  'connectors.category.maps': 'Mapas',
  'connectors.category.marketing': 'Marketing',
  'connectors.category.media': 'Medios',
  'connectors.category.meetings': 'Reuniones',
  'connectors.category.nonprofit': 'Sin ánimo de lucro',
  'connectors.category.observability': 'Observabilidad',
  'connectors.category.payments': 'Pagos',
  'connectors.category.personal': 'Personal',
  'connectors.category.presentations': 'Presentaciones',
  'connectors.category.procurement': 'Compras',
  'connectors.category.product': 'Producto',
  'connectors.category.productivity': 'Productividad',
  'connectors.category.projectManagement': 'Gestión de proyectos',
  'connectors.category.recruiting': 'Selección de personal',
  'connectors.category.research': 'Investigación',
  'connectors.category.salesIntelligence': 'Inteligencia de ventas',
  'connectors.category.scheduling': 'Programación',
  'connectors.category.search': 'Búsqueda',
  'connectors.category.security': 'Seguridad',
  'connectors.category.signing': 'Firma',
  'connectors.category.social': 'Redes sociales',
  'connectors.category.spreadsheets': 'Hojas de cálculo',
  'connectors.category.storage': 'Almacenamiento',
  'connectors.category.support': 'Soporte',
  'connectors.category.surveys': 'Encuestas',
  'connectors.category.tasks': 'Tareas',
  'connectors.category.timeTracking': 'Control de tiempo',
  'connectors.category.video': 'Vídeo',
  'connectors.category.whiteboard': 'Pizarra',
  'connectors.categoryLabel': 'Categoría',
  'connectors.providerLabel': 'Proveedor',
  'connectors.toolsSection': 'Herramientas',
  'connectors.toolsLoading': 'Cargando herramientas…',
  'connectors.noToolsAvailable': 'Aún no hay herramientas disponibles. Conéctate para descubrir qué expone esta integración.',
  'connectors.toolDetailsUnavailable': 'Los detalles de las herramientas no están disponibles, pero este conector informa de {n} herramientas.',
  'connectors.loadMoreTools': 'Cargar más herramientas',
  'connectors.openDetailsAria': 'Abrir detalles de {name}',
  'connectors.toolsBadgeNone': 'Sin herramientas',
  'connectors.toolsBadgeOne': '{n} herramienta',
  'connectors.toolsBadgeMany': '{n} herramientas',
  'connectors.searchPlaceholder': 'Buscar conectores…',
  'connectors.searchAriaLabel': 'Buscar conectores por nombre, proveedor o herramienta',
  'connectors.searchClear': 'Borrar búsqueda',
  'connectors.emptyNoMatchTitle': 'Ningún conector coincide con «{query}»',
  'connectors.emptyNoMatchBody': 'Prueba con otra palabra clave o borra la búsqueda para explorar el catálogo completo.',
  'connectors.emptyNoMatchAction': 'Borrar búsqueda',
  'newproj.tabPrototype': 'Prototipo',
  'newproj.tabLiveArtifact': 'Artefacto en vivo',
  'newproj.tabDeck': 'Presentación',
  'newproj.tabTemplate': 'Desde plantilla',
  'newproj.tabMedia': 'Medios',
  'newproj.tabOther': 'Otro',
  'newproj.titlePrototype': 'Nuevo prototipo',
  'newproj.titleLiveArtifact': 'Nuevo artefacto en vivo',
  'newproj.titleDeck': 'Nueva presentación',
  'newproj.titleTemplate': 'Empezar desde una plantilla',
  'newproj.titleImage': 'Nueva imagen',
  'newproj.titleVideo': 'Nuevo vídeo',
  'newproj.titleAudio': 'Nuevo audio',
  'newproj.titleMedia': 'Nuevo medio',
  'newproj.titleOther': 'Nuevo proyecto',
  'newproj.namePlaceholder': 'Nombre del proyecto',
  'newproj.fidelityLabel': 'Fidelidad',
  'newproj.fidelityWireframe': 'Wireframe',
  'newproj.fidelityHigh': 'Alta fidelidad',
  'newproj.toggleSpeakerNotes': 'Usar notas del orador',
  'newproj.toggleSpeakerNotesHint': 'Menos texto en las diapositivas: deja los puntos clave en las notas.',
  'newproj.toggleAnimations': 'Incluir animaciones',
  'newproj.toggleAnimationsHint': 'Añade movimiento (entrada, hover, transiciones) sobre la plantilla.',
  'newproj.targetPlatformsLabel': 'Plataformas de destino',
  'newproj.targetPlatformsHint': 'Elige una o varias. La web adaptable solo cubre los puntos de ruptura del navegador; añade iOS, Android, app para tablet o app de escritorio para variantes nativas multiplataforma.',
  'newproj.platform.responsive.label': 'Web adaptable',
  'newproj.platform.responsive.hint': 'Una experiencia web adaptada a navegadores de escritorio, tablet y móvil',
  'newproj.platform.webDesktop.label': 'Web de escritorio',
  'newproj.platform.webDesktop.hint': 'Producto o página de aterrizaje centrados en el navegador',
  'newproj.platform.mobileIos.label': 'App de iOS',
  'newproj.platform.mobileIos.hint': 'Marcos de iPhone y reglas de interacción de iOS',
  'newproj.platform.mobileAndroid.label': 'App de Android',
  'newproj.platform.mobileAndroid.hint': 'Marcos de Pixel y reglas de interacción de Material',
  'newproj.platform.tablet.label': 'App para tablet',
  'newproj.platform.tablet.hint': 'Experiencia de tablet de estilo nativo con vistas divididas',
  'newproj.platform.desktopApp.label': 'App de escritorio',
  'newproj.platform.desktopApp.hint': 'Interfaz de app de macOS/Windows',
  'newproj.surfaceOptionsLabel': 'Superficies complementarias',
  'newproj.includeLandingPage': 'Incluir página de aterrizaje',
  'newproj.includeLandingPageHint': 'Añade una página de marketing adaptable para anuncios, listas de espera, campañas de lanzamiento, descargas de apps o explicación del producto.',
  'newproj.includeOsWidgets': 'Incluir widgets del sistema operativo',
  'newproj.includeOsWidgetsHint': 'Añade widgets nativos de la plataforma para la pantalla de inicio, la pantalla de bloqueo o de acceso rápido en aplicaciones de móvil/tableta.',
  'newproj.includeOsWidgetsDisabledHint': 'Disponible cuando se selecciona una aplicación de iOS, Android o tableta como plataforma de destino.',
  'newproj.templateLabel': 'Plantilla',
  'newproj.noTemplatesTitle': 'Aún no hay plantillas',
  'newproj.noTemplatesBody': 'Abre cualquier proyecto y usa el menú Compartir dentro del visor de archivos para convertirlo en plantilla. Las plantillas aparecerán aquí.',
  'newproj.savedTemplate': 'Plantilla guardada',
  'newproj.fileSingular': 'archivo',
  'newproj.filePlural': 'archivos',
  'newproj.create': 'Crear',
  'newproj.locationLabel': 'Guardar en',
  'newproj.locationDefault': 'Proyectos de Gini Studio',
  'newproj.locationExternalBase': 'Base externa',
  'newproj.createLiveArtifact': 'Crear artefacto en vivo',
  'newproj.createFromTemplate': 'Crear desde plantilla',
  'newproj.createDisabledTitle': 'Guarda primero un proyecto como plantilla (menú Compartir dentro de cualquier proyecto).',
  'newproj.importClaudeZip': 'Importar ZIP de GINI Studio',
  'newproj.importClaudeZipTitle': 'Importar una exportación .zip de GINI Studio',
  'newproj.importingClaudeZip': 'Importando…',
  'newproj.privacyFooter': 'Por defecto, solo tú puedes ver tu proyecto.',
  'newproj.designSystem': 'Sistema de diseño',
  'newproj.dsNoneFreeform': 'Ninguno: estilo libre',
  'newproj.dsNoneSubtitleEmpty': 'Sin tokens de sistema, elige tu propia paleta',
  'newproj.dsNoneSubtitleSelected': 'Omitir tokens de sistema. El agente elige su propia paleta.',
  'newproj.dsCategoryFallback': 'Sistema de diseño',
  'newproj.dsSearch': 'Buscar sistemas de diseño…',
  'newproj.dsModeAria': 'Modo de selección',
  'newproj.dsModeSingle': 'Único',
  'newproj.dsModeMulti': 'Múltiple',
  'newproj.dsNoneTitle': 'Ninguno: estilo libre',
  'newproj.dsNoneSub': 'Omitir tokens de sistema. El agente elige su propia paleta.',
  'newproj.dsEmpty': 'Ningún sistema de diseño coincide con «{query}».',
  'newproj.dsFootSingular': 'es solo inspiración.',
  'newproj.dsFootPlural': 'son solo inspiración.',
  'newproj.dsFootClear': 'Limpiar',
  'newproj.dsBadgeDefault': 'PREDETERMINADO',
  'newproj.dsPrimaryFallback': 'Principal',
  'newproj.surfaceImage': 'Imagen',
  'newproj.surfaceVideo': 'Vídeo',
  'newproj.surfaceAudio': 'Audio',
  'newproj.modelLabel': 'Modelo',
  'newproj.modelSearch': 'Buscar modelos…',
  'newproj.modelEmpty': 'No hay modelos que coincidan.',
  'newproj.modelRecommended': 'Recomendado',
  'newproj.modelMissingTitle': 'Elegir un modelo',
  'newproj.modelMissingSub': 'Elige un modelo para esta superficie.',
  'newproj.aspectLabel': 'Proporción',
  'newproj.videoLengthLabel': 'Duración',
  'newproj.videoLengthSeconds': '{n} s',
  'newproj.audioKindLabel': 'Tipo de audio',
  'newproj.audioKindMusic': 'Música',
  'newproj.audioKindSpeech': 'Voz / TTS',
  'newproj.audioKindSfx': 'Efecto de sonido',
  'newproj.audioDurationLabel': 'Duración',
  'newproj.audioDurationSeconds': '{n} s',
  'newproj.voiceLabel': 'Voz',
  'newproj.voicePlaceholder': 'Id de voz del proveedor, opcional',
  'newproj.connectorsLabel': 'Conectores',
  'newproj.connectorsHint': 'Fuentes de datos de las que puede obtener datos este artefacto.',
  'newproj.connectorsEmptyTitle': 'No hay conectores configurados',
  'newproj.connectorsEmptyBody': 'Conecta una fuente de datos para que tu artefacto en vivo pueda obtener cifras reales en lugar de marcadores de posición.',
  'newproj.connectorsEmptyCta': 'Configurar conectores →',
  'newproj.connectorsLoading': 'Cargando conectores…',
  'newproj.connectorsCountOne': '{n} conectado',
  'newproj.connectorsCountMany': '{n} conectados',
  'newproj.connectorsManage': 'Gestionar',
  'newproj.promptTemplateLabel': 'Plantilla de referencia',
  'newproj.promptTemplateNoneTitle': 'Ninguna — escribe la tuya',
  'newproj.promptTemplateNoneSub': 'Sáltate la galería y describe tu propio briefing',
  'newproj.promptTemplateRefSub': 'Plantilla de referencia',
  'newproj.promptTemplateSearch': 'Buscar plantillas…',
  'newproj.promptTemplateEmpty': 'Aún no hay plantillas para este formato.',
  'newproj.promptTemplateBodyLabel': 'Prompt (editable)',
  'newproj.promptTemplateOptimizeHint': 'Edita lo que quieras — tus cambios se incorporan al briefing del agente.',
  'newproj.promptTemplateBodyEmpty': 'Cuerpo vacío — el agente no recibirá ninguna referencia de plantilla.',
  'newproj.deleteTemplateTitle': 'Eliminar plantilla',
  'newproj.deleteTemplateConfirm': '¿Eliminar «{name}»? Esta acción no se puede deshacer.',
  'newproj.deleteTemplateConfirmCta': 'Eliminar plantilla',
  'newproj.deleteTemplateError': 'No se pudo eliminar esta plantilla. Inténtalo de nuevo.',
  'designs.subRecent': 'Recientes',
  'designs.subYours': 'Tus diseños',
  'designs.filterAria': 'Filtrar proyectos',
  'designs.searchPlaceholder': 'Buscar…',
  'designs.emptyNoProjects': 'Aún no hay proyectos.',
  'designs.emptyNoMatch': 'Ningún proyecto coincide con tu búsqueda.',
  'designs.deleteTitle': 'Eliminar proyecto',
  'designs.deleteConfirm': '¿Eliminar «{name}»?',
  'designs.cardFreeform': 'estilo libre',
  'designs.badgeLive': 'En vivo',
  'designs.liveArtifactBadgesAria': 'Insignias de artefacto en vivo',
  'designs.liveCount': '{n} en vivo',
  'designs.statusLive': 'Artefacto en vivo',
  'designs.statusArchived': 'Archivado',
  'designs.statusError': 'Error',
  'designs.statusRefreshing': 'Actualizando…',
  'designs.statusRefreshFailed': 'Error al actualizar',
  'designs.statusRefreshed': 'Actualizado',
  'designs.status.notStarted': 'Sin empezar',
  'designs.status.queued': 'En cola',
  'designs.status.running': 'En ejecución',
  'designs.status.awaitingInput': 'Necesita respuesta',
  'designs.status.succeeded': 'Completado',
  'designs.status.published': 'Publicado',
  'designs.status.failed': 'Fallido',
  'designs.status.canceled': 'Cancelado',
  'designs.viewToggleAria': 'Modo de vista',
  'designs.viewGrid': 'Vista en cuadrícula',
  'designs.viewKanban': 'Vista en tablero',
  'designs.kanbanEmptyColumn': 'Sin diseños',
  'designs.deleteAria': 'Eliminar proyecto {name}',
  'designs.menuMore': 'Más acciones',
  'designs.menuRename': 'Cambiar nombre',
  'designs.menuDelete': 'Eliminar',
  'designs.renamePrompt': 'Nuevo nombre para «{name}»',
  'designs.selectMode': 'Seleccionar',
  'designs.cancelSelect': 'Cancelar',
  'designs.deleteSelected': 'Eliminar seleccionados',
  'designs.selectedCount': '{n} seleccionados',
  'designs.deleteSelectedConfirm': '¿Eliminar {n} proyecto(s)?',
  'designs.deleteSelectedSuccess': '{n} proyecto(s) eliminado(s) correctamente.',
  'designs.deleteSelectedPartial': '{deleted} proyecto(s) eliminado(s); {failed} con errores.',
  'designs.tagPrototype': 'Prototipo',
  'designs.tagLiveArtifact': 'Artefacto en vivo',
  'designs.tagSlide': 'Diapositiva',
  'designs.tagMedia': 'Multimedia',
  'designs.renameTitle': 'Cambiar nombre del proyecto',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Cancelar',
  'examples.typeLabel': 'Tipo',
  'examples.surfaceLabel': 'Superficie',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': 'Imagen',
  'examples.surfaceVideo': 'Vídeo',
  'examples.surfaceAudio': 'Audio',
  'examples.scenarioLabel': 'Escenario',
  'examples.modeAll': 'Todos',
  'examples.modePrototypeDesktop': 'Prototipos · Escritorio',
  'examples.modePrototypeMobile': 'Prototipos · Móvil',
  'examples.modeDeck': 'Diapositivas',
  'examples.modeDocument': 'Documentos y plantillas',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'En vivo',
  'examples.scenarioGeneral': 'General',
  'examples.scenarioEngineering': 'Ingeniería',
  'examples.scenarioProduct': 'Producto',
  'examples.scenarioDesign': 'Diseño',
  'examples.scenarioMarketing': 'Marketing',
  'examples.scenarioSales': 'Ventas',
  'examples.scenarioFinance': 'Finanzas',
  'examples.scenarioHr': 'RR. HH.',
  'examples.scenarioOperations': 'Operaciones',
  'examples.scenarioSupport': 'Soporte',
  'examples.scenarioLegal': 'Legal',
  'examples.scenarioEducation': 'Educación',
  'examples.scenarioPersonal': 'Personal',
  'examples.searchPlaceholder': 'Buscar ejemplos…',
  'examples.searchAria': 'Buscar ejemplos por nombre',
  'examples.emptyNoSkills': 'No hay skills disponibles. ¿Está el daemon en ejecución?',
  'examples.emptyNoMatch': 'Ningún ejemplo coincide con estos filtros.',
  'examples.openPreview': '⤢ Abrir vista previa',
  'examples.loadingPreview': 'Cargando vista previa…',
  'examples.hoverPreview': 'Pasa el cursor para ver la vista previa',
  'examples.usePrompt': 'Usar este prompt',
  'examples.previewModalTitle': 'Abrir vista previa completa (modal)',
  'examples.shareTitle': 'Compartir este ejemplo',
  'examples.shareLoadFirst': 'Pasa el cursor para cargar primero la vista previa',
  'examples.unavailablePlaceholder': 'Sin vista previa {kind} incluida — abre para saber más',
  'examples.shareUnavailable': 'Sin vista previa {kind} incluida para compartir',
  'examples.shareMenu': 'Compartir ▾',
  'examples.exportPdfAllSlides': 'Exportar como PDF (todas las diapositivas)',
  'examples.exportPptxLocked': 'Exportar como PPTX… (abre primero la plantilla)',
  'examples.tagSlideDeck': 'Presentación',
  'examples.tagTemplate': 'Plantilla',
  'examples.tagDesignSystem': 'Sistema de diseño',
  'examples.tagMobilePrototype': 'Prototipo móvil',
  'examples.tagDesktopPrototype': 'Prototipo de escritorio',
  'examples.tagImage': 'Imagen',
  'examples.tagVideo': 'Vídeo',
  'examples.tagAudio': 'Audio',
  'examples.previewLabel': 'Vista previa',
  'ds.surfaceLabel': 'Superficie',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': 'Imagen',
  'ds.surfaceVideo': 'Vídeo',
  'ds.surfaceAudio': 'Audio',
  'ds.searchPlaceholder': 'Buscar sistemas de diseño…',
  'ds.emptyNoMatch': 'Ningún sistema de diseño coincide con tu búsqueda.',
  'ds.badgeDefault': 'PREDETERMINADO',
  'ds.preview': 'Vista previa',
  'ds.previewTitle': 'Vista previa del sistema de diseño',
  'ds.categoryAll': 'Todos',
  'ds.categoryUncategorized': 'Sin categoría',
  'ds.showcase': 'Vitrina',
  'ds.tokens': 'Tokens',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'Cargando DESIGN.md…',
  'avatar.title': 'Cuenta y ajustes',
  'avatar.localCli': 'CLI local',
  'avatar.anthropicApi': 'API de Anthropic',
  'avatar.useLocal': 'Usar CLI local',
  'avatar.useApi': 'Usar API · BYOK',
  'avatar.codeAgent': 'Agente de código',
  'avatar.rescan': 'Reescanear PATH',
  'avatar.amrConsole': 'Cuenta AMR',
  'avatar.amrConsoleMeta': 'Saldo y recarga',
  'avatar.settings': 'Ajustes',
  'avatar.backToProjects': 'Volver a los proyectos',
  'avatar.metaActive': 'activo',
  'avatar.metaOffline': 'sin conexión',
  'avatar.metaSelected': 'seleccionado',
  'avatar.noAgentSelected': 'ningún agente seleccionado',
  'avatar.modelSection': 'Modelo',
  'avatar.modelLabel': 'Modelo',
  'avatar.reasoningLabel': 'Razonamiento',
  'avatar.customSuffix': '(personalizado)',
  'socialShare.openDesignSection': 'Compartir Gini Studio',
  'socialShare.openDesignTitle': 'Gini Studio en GitHub',
  'socialShare.openDesignText': 'Gini Studio es un espacio de trabajo de código abierto para crear, editar, desplegar y entregar artefactos de diseño.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'COMPARTIR EN REDES SOCIALES',
  'socialShare.projectTitle': '{title} · Gini Studio',
  'socialShare.projectText': 'Creado con Gini Studio: {title}. Consulta el artefacto desplegado y dale una estrella al repositorio: {repo}',
  'socialShare.projectCopyText': 'Creado con Gini Studio: {title}\n{url}\nRepositorio de Gini Studio: {repo}',
  'socialShare.deployFirst': 'Desplegar y compartir…',
  'socialShare.copied': 'Copiado',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',
  'inlineSwitcher.chipTitle': 'Cambiar CLI / modelo',
  'inlineSwitcher.chipCli': 'CLI local',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'predeterminado',
  'inlineSwitcher.noAgent': 'sin agente',
  'inlineSwitcher.modeLabel': 'Modo',
  'inlineSwitcher.agentLabel': 'Agente',
  'inlineSwitcher.providerLabel': 'Proveedor',
  'inlineSwitcher.modelLabel': 'Modelo',
  'inlineSwitcher.useCli': 'Usar CLI local',
  'inlineSwitcher.useByok': 'Usar clave API propia',
  'inlineSwitcher.daemonOffline': 'Daemon offline — abrir ajustes',
  'inlineSwitcher.noAgentsDetected': 'No se detectó CLI en PATH',
  'inlineSwitcher.openSettingsForModel': 'Configura el proveedor en Ajustes',
  'inlineSwitcher.missingApiKey': 'Falta la clave API — abre Ajustes para añadirla.',
  'inlineSwitcher.openFullSettings': 'Abrir ajustes de ejecución',
  'inlineSwitcher.customSuffix': '(personalizado)',
  'project.backToProjects': 'Volver a los proyectos',
  'project.metaFreeform': 'estilo libre',
  'project.customInstructions': 'Instrucciones del proyecto',
  'project.customInstructionsPlaceholder': 'Instrucciones para este proyecto (se inyectan en cada mensaje)…',
  'project.resizeChatPanel': 'Redimensionar panel de chat',
  'project.instructionsActive': 'Activo: se incluye en cada mensaje',
  'chat.tabChat': 'Chat',
  'chat.tabComments': 'Comentarios',
  'chat.commentsSoon': 'Comentarios — próximamente',
  'chat.comments.attached': 'Adjunto al chat',
  'chat.comments.emptyAttached': 'No hay comentarios adjuntos.',
  'chat.comments.saved': 'Comentarios guardados',
  'chat.comments.emptySaved': 'No hay comentarios guardados.',
  'chat.comments.add': 'Añadir',
  'chat.comments.addAll': 'Añadir todo',
  'chat.comments.remove': 'Quitar',
  'chat.comments.placeholder': 'Comentar este elemento…',
  'chat.comments.addSend': 'Añadir y enviar',
  'chat.comments.updateSend': 'Actualizar y enviar',
  'chat.comments.removeAttachment': 'Quitar comentario adjunto',
  'chat.comments.removeAttachmentAria': 'Quitar comentario adjunto de {name}',
  'chat.comments.comment': 'Comentario',
  'chat.comments.sendToChat': 'Enviar al chat',
  'chat.comments.sending': 'Enviando…',
  'chat.comments.edit': 'Editar',
  'chat.comments.select': 'Seleccionar',
  'chat.comments.selectAll': 'Seleccionar todo',
  'chat.comments.deselect': 'Deseleccionar',
  'chat.comments.nSelected': '{n} seleccionados',
  'chat.comments.pin': 'Fijar',
  'chat.comments.addNote': 'Añadir nota',
  'chat.comments.savedToast': 'Comentario guardado',
  'chat.comments.pinSavedToast': 'Fijación guardada',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} elementos capturados',
  'chat.comments.clear': 'Borrar',
  'chat.comments.targetImage': 'Imagen',
  'chat.comments.targetControl': 'Control',
  'chat.comments.targetLink': 'Enlace',
  'chat.comments.targetText': 'Texto',
  'chat.comments.targetSection': 'Sección',
  'chat.comments.targetPage': 'Página',
  'chat.comments.targetArea': 'Área',
  'chat.annotationNotePlaceholder': 'Añadir una nota para esta marca',
  'chat.annotationAttachImage': 'Adjuntar imagen',
  'chat.annotationAttachedImages': 'Imágenes adjuntas',
  'chat.annotationAttachedRemove': 'Quitar última imagen',
  'chat.annotationAddToInput': 'Añadir a la entrada',
  'chat.annotationAddingToInput': 'Añadiendo...',
  'chat.annotationQueue': 'Cola',
  'chat.annotationQueueing': 'Añadiendo a la cola...',
  'chat.annotationSending': 'Enviando...',
  'chat.annotationSendDisabledReason': 'Hay una tarea en ejecución',
  'chat.annotationPreviewMissing': 'No se pudo capturar la vista previa. Inténtalo de nuevo.',
  'chat.annotationPreviewMissingInk': 'No se pudo capturar la vista previa. Inténtalo de nuevo para evitar enviar solo la anotación.',
  'chat.annotationTimeout': 'Se agotó el tiempo de envío de la anotación. Inténtalo de nuevo.',
  'chat.annotationFailed': 'Error al enviar la anotación. Inténtalo de nuevo.',
  'chat.annotationProjectCreateFailed': 'No se pudo crear un proyecto, por lo que la anotación no se envió.',
  'chat.annotationUploadFailed': 'Error al subir el adjunto. Inténtalo de nuevo.',
  'chat.conversationsTitle': 'Conversaciones',
  'chat.conversationsAria': 'Historial de conversaciones',
  'chat.newConversation': 'Nueva conversación',
  'chat.newConversationsTitle': 'Nueva conversación',
  'chat.conversationsHeading': 'Conversaciones',
  'chat.new': 'Nueva',
  'chat.emptyConversations': 'Aún no hay conversaciones.',
  'chat.deleteConversation': 'Eliminar conversación',
  'chat.renameConversationLabel': 'Renombrar «{title}»',
  'chat.deleteConversationConfirm': '¿Eliminar «{title}»? Se borrarán sus mensajes.',
  'chat.untitledConversation': 'Conversación sin título',
  'chat.forkedConversationTitle': 'Bifurcación de {title}',
  'chat.forkConversationFailed': 'No se pudo bifurcar esta conversación.',
  'chat.startTitle': 'Empieza una conversación',
  'chat.startHint': 'Describe lo que quieres generar o empieza con uno de estos ejemplos:',
  'chat.fillInputTitle': 'Haz clic para rellenar el campo',
  'chat.jumpToLatest': 'Ir al más reciente',
  'chat.scrollToLatest': 'Desplazar al más reciente',
  'chat.you': 'Tú',
  'chat.openFile': 'Abrir {name}',
  'chat.copyPrompt': 'Copiar prompt',
  'chat.copyErrorDiagnostic': 'Copiar diagnóstico del error',
  'chat.copyDone': '¡Copiado!',
  'chat.inspect.noEditableTargets': 'This page has no editable elements yet.',
  'chat.inspect.noCommentTargets': 'This page has no commentable elements yet.',
  'chat.inspect.editHint': 'Click an element in the canvas to edit its styles.',
  'chat.inspect.commentHint': 'Click an element in the canvas to add a comment.',
  'chat.composerPlaceholder': 'Describe lo que quieres generar…',
  'chat.activeFileEditingLabel': 'Editando',
  'chat.activeFilePlaceholder': 'Pide a Gini Studio que cambie {file}...',
  'chat.designArtifactsShowMore': 'Mostrar {count} archivos de diseño más',
  'chat.mode.chat.label': 'Preguntar',
  'chat.mode.chat.title': 'Modo Ask',
  'chat.mode.chat.summary': 'Para respuestas rápidas, cambios, planificación y conversación sin asumir que hay que crear un artefacto de diseño.',
  'chat.mode.chat.solves': 'Úsalo para aclarar ideas, ajustar prompts, comparar opciones o preguntar sobre trabajo existente.',
  'chat.mode.chat.query1': 'Resume este borrador y señala los huecos.',
  'chat.mode.chat.query2': 'Ayúdame a decidir la mejor estructura para esta landing page.',
  'chat.mode.chat.query3': 'Revisa este diseño y sugiere mejoras concretas.',
  'chat.mode.plan.label': 'Plan',
  'chat.mode.plan.title': 'Modo Plan',
  'chat.mode.plan.summary': 'Investiga y define un enfoque antes de cambiar archivos. Las herramientas de mutación permanecen bloqueadas hasta que apruebes y pases a Diseño.',
  'chat.mode.plan.solves': 'Úsalo para explorar el espacio de trabajo, comparar opciones y producir un plan TodoWrite revisable antes de implementar.',
  'chat.mode.plan.query1': 'Explora este proyecto y propone un plan paso a paso para el rediseño de la landing.',
  'chat.mode.plan.query2': 'Enumera los archivos y secciones que cambiarías antes de construir nada.',
  'chat.mode.plan.query3': 'Compara dos enfoques y recomienda qué plan ejecutar.',
  'chat.mode.plan.badge': 'Plan',
  'chat.mode.plan.approve': 'Aprobar y construir',
  'chat.mode.plan.approveHint': 'Cambia al modo Agent de diseño para ejecutar este plan.',
  'chat.mode.design.label': 'Agent de diseño',
  'chat.mode.design.title': 'Modo Design Agent',
  'chat.mode.design.summary': 'Para crear o cambiar resultados concretos: páginas, prototipos, artefactos en vivo, diapositivas, imágenes, vídeos, HyperFrames, audio, paneles y archivos de proyecto.',
  'chat.mode.design.solves': 'Úsalo cuando quieras que Gini Studio genere archivos, actualice el workspace o convierta un brief en entregables multimodales.',
  'chat.mode.design.query1': 'Crea una landing page de lanzamiento y un prototipo HyperFrames a partir de este brief.',
  'chat.mode.design.query2': 'Haz un deck para inversores de 10 diapositivas con notas de presentación.',
  'chat.mode.design.query3': 'Genera conceptos de imagen, vídeo y audio para esta campaña.',
  'chat.mode.cardBestFor': 'Ideal para',
  'chat.mode.cardTry': 'Prueba con',
  'chat.composerHint': '⌘/Ctrl + Enter para enviar · incluye objetivo, contenido, estilo y formato',
  'chat.cliSettingsTitle': 'Ajustes de CLI y modelo',
  'chat.cliSettingsAria': 'Abrir ajustes de CLI y modelo',
  'chat.attachTitle': 'Adjuntar archivos (o pegar / soltar)',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'Adjuntar archivos',
  'chat.importFigma': 'Importar de Figma',
  'chat.figmaHelp.title': 'How to download a .fig file',
  'chat.figmaHelp.intro': 'From the Figma web or desktop app:',
  'chat.figmaHelp.step1': 'Open the file in Figma.',
  'chat.figmaHelp.step2': 'Go to File → Save local copy... (web: main menu → File).',
  'chat.figmaHelp.step3': 'Figma downloads a .fig file. Drop it onto the composer or upload it.',
  'chat.figmaHelp.note': 'The .fig file is parsed locally and is not uploaded to Figma.',
  'chat.importTitle': 'Importar fuentes (próximamente)',
  'chat.importLabel': 'Importar',
  'chat.importComingSoon': 'Próximamente',
  'chat.importSoon': 'Pronto',
  'chat.importFig': 'Subir archivo .fig',
  'chat.importGitHub': 'Conectar GitHub',
  'chat.importWeb': 'Capturar elemento web',
  'chat.importFolder': 'Vincular carpeta de código',
  'chat.importSkills': 'Skills y sistemas de diseño',
  'chat.importProject': 'Referenciar otro proyecto',
  'chat.importDesignSystemHeader': 'Elegir un sistema de diseño',
  'chat.importDesignSystemBack': 'Atrás',
  'chat.importDesignSystemSearch': 'Buscar sistemas de diseño…',
  'chat.importDesignSystemEmpty': 'Ningún sistema de diseño coincide con "{query}"',
  'chat.importDesignSystemNone': 'Ninguno — libre',
  'chat.importDesignSystemNoneSub': 'No anclar a un sistema esta vez',
  'chat.importDesignSystemActive': 'Activo',
  'chat.importDesignSystemSwitched': 'Sistema de diseño cambiado a {title}',
  'chat.importDesignSystemFailed': 'No se pudo cambiar el sistema de diseño. Vuelve a intentarlo.',
  'chat.importDesignSystemLoadFailed': 'No se pudieron cargar los sistemas de diseño.',
  'browserUse.title': 'Inspiración',
  'browserUse.summary': '{count} acciones web, priorizando la extracción de recursos, el lenguaje de diseño, el movimiento, las comprobaciones visuales y la estructura de componentes.',
  'browserUse.searchAria': 'Buscar inspiración',
  'browserUse.searchPlaceholder': 'Buscar capturas, fuentes, colores, a11y...',
  'browserUse.empty': 'No hay inspiración coincidente',
  'browserUse.unavailable': 'La inspiración no está disponible aquí',
  'browserUse.added': 'Añadido al compositor',
  'browserUse.category.assets': 'Extracción de recursos',
  'browserUse.category.tokens': 'Lenguaje de diseño',
  'browserUse.category.motion': 'Movimiento',
  'browserUse.category.visual': 'Comprobaciones visuales',
  'browserUse.category.structure': 'Componentes',
  'browserUse.category.project': 'Ejecución del proyecto',
  'browserUse.category.general': 'General',
  'browserUse.input.none': 'Sin entrada',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'Selector opcional',
  'browserUse.input.requirementSelector': 'Requisito, selector opcional',
  'browserUse.input.selectorOptional': 'Selector opcional',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'Selector, scale=2',
  'browserUse.input.gridOverlay': '12 columnas, máx. 1200, espacio 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, dominio o términos de búsqueda',
  'browserUse.input.selector': 'Selector',
  'browserUse.input.selectorText': 'Selector y texto',
  'browserUse.input.scroll': 'Píxeles, arriba, abajo o página',
  'browserUse.input.terminalRun': 'Comando, tiempo de espera 120 s',
  'browserUse.input.command': 'Comando',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'Mejores candidatos de logotipo del encabezado, navegación, nombres de clase, posición, imagen OG y favicon como alternativa.',
  'browserUse.action.list_images.output': 'Todas las imágenes de img, srcset, source y fondos CSS con dimensiones y texto alternativo.',
  'browserUse.action.download_assets.output': 'Carpeta de recursos descargados más _manifest.json con compatibilidad de referer y cookies.',
  'browserUse.action.extract_svgs.output': 'SVG en línea y archivos .svg vinculados guardados como archivos SVG individuales.',
  'browserUse.action.optimize_svgs.output': 'Archivos SVG optimizados más ratio de compresión.',
  'browserUse.action.extract_colors.output': 'Paleta ponderada más variables de color CSS :root como palette.json y palette.html.',
  'browserUse.action.extract_fonts.output': 'Principales familias de fuentes, tamaños, grosores y reglas @font-face como typography.json.',
  'browserUse.action.extract_design_tokens.output': 'Radio, sombra, espaciado y variables CSS como tokens.json.',
  'browserUse.action.extract_type_scale.output': 'Escala tipográfica de títulos, cuerpo y botones con tamaño, grosor, interlineado y proporciones.',
  'browserUse.action.extract_buttons.output': 'Biblioteca de estilos de botón deduplicada como buttons.html y buttons.json.',
  'browserUse.action.extract_grid_system.output': 'Contenedores de cuadrícula y flex, dirección, espacios, columnas y anchos máximos como layout.json.',
  'browserUse.action.extract_breakpoints.output': 'Puntos de ruptura de media queries adaptables como breakpoints.json.',
  'browserUse.action.extract_gradients.output': 'Gradientes CSS como gradients.css, gradients.json y HTML de vista previa.',
  'browserUse.action.extract_shadows.output': 'Sombras de caja, sombras de texto y sombras paralelas como shadows.json más vista previa.',
  'browserUse.action.extract_easings.output': 'Funciones de aceleración de transiciones y animaciones como easings.json.',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js y style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': '@keyframes, reglas de transición y transformación, bibliotecas de movimiento detectadas, motion.css y motion.json.',
  'browserUse.action.validate_view.output': 'Rutas de capturas más problemas visuales y de maquetación estructurados.',
  'browserUse.action.audit_layout.output': 'Defectos de maquetación, incluidos desbordamiento, límites, solapamiento y texto recortado como audit.json.',
  'browserUse.action.audit_accessibility.output': 'Problemas de a11y con selectores, etiquetas, roles, foco, contraste y capturas cuando sea útil.',
  'browserUse.action.responsive_screenshots.output': 'Capturas de móvil 390, tableta 834 y escritorio 1440.',
  'browserUse.action.screenshot_full.output': 'Captura de página completa más allá del viewport.',
  'browserUse.action.screenshot_element.output': 'Captura de un solo elemento a 2x de forma predeterminada.',
  'browserUse.action.screenshot_with_grid.output': 'Captura con superposición de cuadrícula de maquetación.',
  'browserUse.action.screenshot_dark_mode.output': 'Captura con prefers-color-scheme: dark.',
  'browserUse.action.generate_styleguide.output': 'Guía de estilo de una página con colores, escala tipográfica, radio y sombras.',
  'browserUse.action.extract_html.output': 'HTML limpio y autónomo sin script, noscript ni atributos de evento en línea.',
  'browserUse.action.extract_component_inventory.output': 'Patrones de componentes repetidos, selectores, recuentos y capturas.',
  'browserUse.action.extract_copy.output': 'Títulos, CTA, texto del cuerpo y descripciones como copy.md y copy.json.',
  'browserUse.action.extract_nav.output': 'Navegación principal y enlaces del pie de página como sitemap.md y nav.json.',
  'browserUse.action.extract_forms.output': 'Campos de formulario, etiquetas, sugerencias de validación y acciones de envío como forms.json.',
  'browserUse.action.run_project.output': 'URL del servidor de desarrollo detectada abierta en la pestaña Browser.',
  'browserUse.action.detect_project.output': 'Framework, gestor de paquetes, comando de instalación, comando de desarrollo y puerto.',
  'browserUse.action.page_info.output': 'URL, título, descripción, imagen OG, color del tema, favicon y viewport.',
  'browserUse.action.snapshot.output': 'Hasta 120 elementos interactivos y de texto visibles con etiqueta, rótulo, href y coordenadas.',
  'browserUse.action.navigate.output': 'Abrir la página y devolver page_info.',
  'browserUse.action.click.output': 'Hacer clic en el primer elemento coincidente tras desplazarlo a la vista.',
  'browserUse.action.type_text.output': 'Rellenar un campo de entrada y emitir eventos input y change.',
  'browserUse.action.scroll.output': 'Posición de desplazamiento actual y máxima.',
  'browserUse.action.extract_og_metadata.output': 'Título meta, descripción, URL canónica, tarjetas OG/Twitter, imagen social y color del tema.',
  'browserUse.action.terminal_run.output': 'stdout, stderr y código de salida.',
  'browserUse.action.terminal_run_background.output': 'ID de la tarea en segundo plano y salida reciente.',
  'browserUse.action.terminal_read.output': 'Salida reciente del terminal compartido.',
  'chat.designToolbox.title': 'Caja de herramientas de diseño',
  'chat.designToolbox.tooltip': 'Caja de herramientas de diseño / Probar suerte',
  'chat.designToolbox.aria': 'Abrir caja de herramientas de diseño',
  'chat.designToolbox.lucky': 'Probar suerte',
  'chat.designToolbox.searchPlaceholder': 'Buscar skills / MCP / plugins / conectores / archivos de diseño...',
  'chat.designToolbox.searchAria': 'Buscar recursos de la caja de herramientas de diseño',
  'chat.designToolbox.followupSection': 'Seguimiento',
  'chat.designToolbox.resourcesSection': 'Recursos globales',
  'chat.designToolbox.selected': 'Seleccionado',
  'chat.designToolbox.noResources': 'No se han encontrado recursos para "{query}".',
  'chat.designToolbox.badge.video': 'Vídeo',
  'chat.designToolbox.badge.image': 'Imagen',
  'chat.designToolbox.badge.motion': 'Movimiento',
  'chat.designToolbox.badge.polish': 'Pulido',
  'chat.designToolbox.action.auto-match.title': 'Asociar siguiente paso',
  'chat.designToolbox.action.auto-match.badge': 'Asociar',
  'chat.designToolbox.action.auto-match.description': 'Define primero el listón de gusto y, a continuación, asocia skills, MCP, plugins, conectores y archivos.',
  'chat.designToolbox.action.motion.title': 'Añadir animación / movimiento',
  'chat.designToolbox.action.motion.badge': 'Movimiento',
  'chat.designToolbox.action.motion.description': 'Añade movimiento de entrada, de desplazamiento, de transición de estado y de microinteracción al HTML o elemento de página actual.',
  'chat.designToolbox.action.motion-polish.title': 'Pulir movimiento',
  'chat.designToolbox.action.motion-polish.badge': 'Sincronización',
  'chat.designToolbox.action.motion-polish.description': 'Revisa la sincronización, la suavización, el rendimiento y las alternativas de movimiento reducido para el movimiento existente.',
  'chat.designToolbox.action.anti-ai-polish.title': 'Eliminar aspecto de IA',
  'chat.designToolbox.action.anti-ai-polish.badge': 'Gusto',
  'chat.designToolbox.action.anti-ai-polish.description': 'Elimina el aspecto de plantilla, los degradados de IA, los apilamientos de tarjetas baratos y los textos imprecisos.',
  'chat.designToolbox.action.visual-polish.title': 'Pulido de diseño / listo para publicar',
  'chat.designToolbox.action.visual-polish.badge': 'Pulido',
  'chat.designToolbox.action.visual-polish.description': 'Audita la jerarquía visual, la tipografía, el espaciado, el comportamiento adaptable, la accesibilidad y la calidad de entrega.',
  'chat.designToolbox.action.image-gen.title': 'Generar imágenes / referencias visuales',
  'chat.designToolbox.action.image-gen.badge': 'Imagen',
  'chat.designToolbox.action.image-gen.description': 'Genera referencias de sección, recursos, iconos, imágenes sociales o un moodboard para la página actual.',
  'chat.designToolbox.action.video-gen.title': 'Generar vídeo / guion de movimiento',
  'chat.designToolbox.action.video-gen.badge': 'Vídeo',
  'chat.designToolbox.action.video-gen.description': 'Convierte el diseño en un vídeo corto, un storyboard de Remotion / Hyperframes o un prompt listo para generación.',
  'chat.designToolbox.kind.skill': 'Skill',
  'chat.designToolbox.kind.plugin': 'Plugin',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'Plantilla MCP',
  'chat.designToolbox.kind.connector': 'Conector',
  'chat.designToolbox.kind.designFile': 'Archivo de diseño',
  'chat.designToolbox.context.browser': 'Navegador',
  'chat.designToolbox.context.designFiles': 'Archivos de diseño',
  'chat.designToolbox.context.designSystem': 'Sistema de diseño',
  'chat.designToolbox.context.folder': 'Carpeta',
  'chat.designToolbox.context.terminal': 'Terminal',
  'chat.designToolbox.context.sideChat': 'Chat lateral',
  'chat.designToolbox.context.liveArtifact': 'Artefacto en vivo',
  'chat.designToolbox.context.file': 'Archivo',
  'chat.designToolbox.prompt.contextGeneric': 'Objetivo actual: el archivo HTML / archivo de diseño / elemento web abierto en este momento.',
  'chat.designToolbox.prompt.contextSpecific': 'Objetivo actual: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'Conserva la intención que ya está en el editor: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'Skill seleccionada: {skill}. Úsala como flujo de trabajo principal en este turno.',
  'chat.designToolbox.prompt.noSkill': 'Si no coincide ninguna skill específica, elige primero la mejor combinación de skills, MCP, plugins, conectores y archivos de diseño disponibles.',
  'chat.designToolbox.prompt.autoMatchIntro': 'Actúa como el orquestador Director Creativo y completa un flujo de trabajo de diseño:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. Define primero qué significa un “diseño atractivo”: audiencia, objetivo de negocio, identidad de marca, referencias de estilo, densidad de información, estándares de color/tipografía/movimiento/recursos y patrones de IA/plantillas que evitar.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. Busca y haz coincidir el índice completo de recursos anterior. No uses solo las recomendaciones de la caja de herramientas de diseño; combina skills, MCP, plugins, conectores y archivos de diseño cuando resulte útil.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. Si el objetivo o el nivel estético sigue sin estar claro, guíame con opciones finitas o una interfaz tipo formulario e incluye un valor predeterminado recomendado. Si está suficientemente claro, ejecuta directamente el siguiente paso.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. Completa el flujo en este orden: diagnóstico -> dirección de estilo -> selección de recursos -> edición/generación concreta -> verificación. En cada paso, explica por qué se eligieron estos recursos y qué hay que confirmar a continuación.',
  'chat.designToolbox.prompt.motion': 'Añade movimiento de alta calidad al elemento HTML / de página actual: elige los 1-2 momentos más útiles de entrada, scroll, transición de estado o microinteracción. Mantenlo contenido, prioriza transform / opacity e incluye alternativas para prefers-reduced-motion.',
  'chat.designToolbox.prompt.motionPolish': 'Revisa y pule el ritmo, la suavización, el rendimiento y la accesibilidad del movimiento existente. Elimina animaciones bruscas, baratas o que perjudiquen la legibilidad; usa una línea de tiempo más refinada cuando sea necesario.',
  'chat.designToolbox.prompt.antiAiPolish': 'Haz una pasada de pulido anti-aspecto-IA: elimina diseños de plantilla, degradados/brillos baratos, pilas de tarjetas sin sentido y textos vagos. Conserva la información y haz que parezca entregado por un diseñador real.',
  'chat.designToolbox.prompt.visualPolish': 'Pule este diseño hasta dejarlo listo para publicar: revisa jerarquía, tipografía, espaciado, comportamiento responsive, estados de los botones, estados vacío/de carga/de error y accesibilidad; corrige directamente los problemas más importantes.',
  'chat.designToolbox.prompt.imageGen': 'Crea el siguiente plan de recursos visuales para este diseño: referencias de sección, recursos hero, ilustraciones, iconos, imágenes para redes sociales o un moodboard. Decide primero qué tipo de imagen falta y luego proporciona prompts de generación ejecutables / un plan de archivos.',
  'chat.designToolbox.prompt.videoGen': 'Orienta este diseño hacia el vídeo: crea un guion gráfico de vídeo corto, una estructura de frames de Hyperframes / Remotion o un prompt listo para Sora/fal. Prioriza que el contenido HTML / de página existente se convierta de forma natural en planos.',
  'chat.designToolbox.prompt.useSkill': 'Usa {skill} en el diseño actual.',
  'chat.designToolbox.prompt.skillInstruction': 'Decide primero el mejor objetivo de seguimiento y luego completa una pasada concreta. Si depende de recursos o API externas, proporciona una alternativa ejecutable o indica qué necesito aportar.',
  'chat.designToolbox.prompt.selectedResource': 'Recurso seleccionado: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'Descripción del recurso: {description}',
  'chat.designToolbox.prompt.pluginResource': 'Usa este plugin como contexto principal del flujo de diseño actual. Si expone entradas o GenUI, guíame para elegir cuando sea necesario; si no encaja con el objetivo, elige un recurso global mejor y explica por qué.',
  'chat.designToolbox.prompt.mcpResource': 'Prioriza esta capacidad de MCP para el siguiente paso de diseño. Cuando se necesiten recursos externos, captura web, generación de imagen/vídeo o datos, decide primero si puede hacer el trabajo y luego ofrece un plan ejecutable.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'Este MCP es una plantilla configurable. Si es la herramienta más útil para este paso de diseño, guía primero la configuración; si existe una alternativa ya configurada, continúa con esa alternativa.',
  'chat.designToolbox.prompt.connectorResource': 'Usa este conector cuando se necesiten datos reales, recursos, contenido de cuenta o acceso a flujos de trabajo externos. Antes de usarlo, explica qué se leerá o escribirá y pide confirmación cuando proceda.',
  'chat.designToolbox.prompt.fileResource': 'Usa este archivo de diseño como objetivo de diseño actual o recurso de referencia y completa el siguiente paso a partir de él. Si hay que comparar otros archivos, sigue buscando en todos los archivos de diseño.',
  'chat.designToolbox.prompt.resourceIndex': 'Índice global de recursos: skills({skills}), plugins({plugins}), MCP({mcpEnabled} activados / {mcpTemplates} plantillas), conectores({connectors} conectados), archivos de diseño({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'Skills disponibles para búsqueda',
  'chat.designToolbox.prompt.searchablePlugins': 'Plugins disponibles para búsqueda',
  'chat.designToolbox.prompt.availableMcp': 'MCP disponibles',
  'chat.designToolbox.prompt.connectedConnectors': 'Conectores conectados',
  'chat.designToolbox.prompt.referenceDesignFiles': 'Archivos de diseño de referencia',
  'chat.designToolbox.prompt.mcpTemplateName': 'Plantilla de {name}',
  'chat.designToolbox.prompt.processRule': 'Regla del flujo de trabajo: define primero el objetivo estético y las restricciones, luego busca y haz coincidir recursos; cuando se necesite la elección del usuario, genera una interfaz de opciones finitas y continúa tras la confirmación.',
  'chat.designToolbox.prompt.moreSuffix': ', +{count} más',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'Superficies de menciones',
  'chat.mentionTabAll': 'Todos',
  'chat.mentionTabTabs': 'Pestañas',
  'chat.mentionTabPlugins': 'Plugins',
  'chat.mentionTabSkills': 'Skills',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'Conectores',
  'chat.mentionTabFiles': 'Archivos de diseño',
  'chat.mentionNoResults': 'No hay resultados para “{query}”.',
  'chat.mentionSearchPrompt': 'Busca archivos de diseño, pestañas, plugins, skills, servidores MCP y conectores.',
  'chat.mentionSectionTabs': 'Pestañas',
  'chat.mentionSectionPlugins': 'Plugins',
  'chat.mentionSectionSkills': 'Skills',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'Conectores',
  'chat.mentionSectionFiles': 'Archivos de diseño',
  'chat.mentionActiveSkill': 'Activo',
  'chat.mentionUseMcpTitle': 'Usar {name}',
  'chat.mentionUseConnectorTitle': 'Usar {name}',
  'chat.mentionPluginOfficial': 'Oficial',
  'chat.mentionPluginMine': 'Mi plugin',
  'chat.linkedFolderRemoveAria': 'Eliminar carpeta vinculada {path}',
  'chat.linkedFolderNotFound': 'La carpeta no existe',
  'chat.linkedFolderAlready': 'Esta carpeta ya está vinculada',
  'chat.linkedFolderPickError': 'No se pudo abrir el selector de carpetas',
  'chat.queuedHeader': 'En cola',
  'chat.queuedToSend': 'para enviar',
  'chat.queuedEditQueuedTaskAria': 'Editar tarea en cola',
  'chat.queuedSave': 'Guardar',
  'chat.queuedCancel': 'Cancelar',
  'chat.queuedReorder': 'Arrastra para reordenar',
  'chat.queuedEdit': 'Editar',
  'chat.queuedMore': 'más en cola',
  'chat.queuedFollowUpFallback': 'Seguimiento en cola',
  'chat.send': 'Enviar',
  'chat.stop': 'Detener',
  'chat.removeAria': 'Quitar {name}',
  'chat.example1Title': 'Pitch deck editorial',
  'chat.example1Tag': 'Revista',
  'chat.example1Prompt': 'Una presentación editorial de 10 diapositivas para un estudio de diseño que levanta una ronda seed: maquetación con grid suizo, titulares serif enormes con capitulares marcadas, números de sección en monoespaciada, abundante espacio en blanco y diapositivas a sangre con foto intercaladas con otras densas en texto. Portada, visión, mercado, producto, tracción, equipo, petición y contacto.',
  'chat.example2Title': 'Dashboard de analítica SaaS',
  'chat.example2Tag': 'Datos',
  'chat.example2Prompt': 'Un dashboard denso de analítica para un SaaS de herramientas para desarrolladores: tira de KPIs con variaciones semana a semana, dos gráficos de líneas apilados (MRR y workspaces activos), un mapa de calor mundial de uso, una rejilla de retención por cohortes, un ranking de clientes principales y un feed de eventos en tiempo real. Tema oscuro, números monoespaciados tabulares, acentos con sparklines.',
  'chat.example3Title': 'Memoria anual long-scroll',
  'chat.example3Tag': 'Editorial',
  'chat.example3Prompt': 'Una memoria anual interactiva para una ONG climática: maquetación editorial long-scroll mezclando grandes bloques de citas, visualizaciones de datos (barras apiladas, contadores animados, un mapa coroplético de proyectos), separadores con fotografía, muro de donantes y llamada a la acción final. Cuerpo en serif moderna, etiquetas de gráficos en sans-serif, paleta terrosa de papel.',
  'preview.shareMenu': 'Compartir',
  'preview.exportMenu': 'Exportar',
  'preview.shareTemplateBadge': 'Plantilla',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Copiar enlace de la plantilla',
  'preview.copyShareText': 'Copiar texto para compartir',
  'preview.shareSocialGroup': 'Compartir en redes sociales',
  'preview.shareCopyGroup': 'Copiar',
  'preview.shareExportGroup': 'Exportar archivos',
  'preview.shareCopied': 'Copiado',
  'preview.shareCopyFailed': 'Error al copiar',
  'preview.shareTextDefault': 'Plantilla de Gini Studio: {title}',
  'preview.openInNewTab': 'Abrir en pestaña nueva',
  'preview.exit': '⤓ Salir',
  'preview.fullscreen': '⤢ Pantalla completa',
  'preview.closeTitle': 'Cerrar (Esc)',
  'preview.loading': 'Cargando {label}…',
  'preview.errorTitle': 'No se pudo cargar este ejemplo.',
  'preview.errorBody': 'No se pudo obtener el HTML del ejemplo. Asegúrate de que Gini Studio esté en ejecución e inténtalo de nuevo.',
  'preview.retry': 'Reintentar',
  'preview.unavailableTitle': 'No hay vista previa incluida para {noun}.',
  'preview.unavailableBody': 'Ejecuta el prompt en el chat para generar un resultado {kind}.',
  'preview.nounSkill': 'esta skill',
  'preview.nounPlugin': 'este plugin',
  'preview.nounTemplate': 'esta plantilla',
  'preview.showSidebar': 'Mostrar {label}',
  'preview.hideSidebar': 'Ocultar {label}',
  'misc.savedTemplate': 'Plantilla guardada',
  'misc.primary': 'Principal',
  'misc.designSystem': 'Sistema de diseño',
  'workspace.designFiles': 'Archivos de diseño',
  'workspace.focusMode': 'Enfocar el espacio de trabajo',
  'workspace.showChat': 'Mostrar chat',
  'workspace.closeTab': 'Cerrar pestaña',
  'workspace.deleteFileConfirm': '¿Eliminar «{name}» de la carpeta del proyecto?',
  'workspace.deleteSelectedFilesConfirm': '¿Eliminar {n} archivo(s) seleccionado(s) de la carpeta del proyecto?',
  'workspace.deleteSelectedFilesPartial': 'No se pudieron eliminar {n} archivo(s).',
  'workspace.openFromDesignFiles': 'Abre un archivo desde',
  'workspace.designFilesLink': 'Archivos de diseño',
  'workspace.loadingSketch': 'Cargando boceto…',
  'workspace.newTab': 'Nueva pestaña',
  'workspace.searchFilesPlaceholder': 'Buscar archivos…',
  'workspace.openTabs': 'Abrir pestañas',
  'workspace.openFile': 'Abrir un archivo',
  'workspace.noFilesMatch': 'No hay archivos coincidentes',
  'workspace.allFiles': 'Todos',
  'workspace.createNew': 'Crear nuevo',
  'workspace.tabOpen': 'Abierto',
  'workspace.sideChatContextBanner': 'Contexto de la conversación actual integrado',
  'workspace.sideChatDefaultTitle': 'Chat lateral',
  'workspace.newTerminal': 'Nueva terminal',
  'workspace.newTerminalDescription': 'Abrir un shell en el directorio del proyecto en una pestaña nueva',
  'workspace.newBrowser': 'Nuevo navegador',
  'workspace.newBrowserDescription': 'Abrir una pestaña de navegador integrada para sitios de referencia y tareas',
  'workspace.terminalStarting': 'Iniciando terminal…',
  'workspace.terminalStartingDescription': 'Preparando el shell del proyecto. Normalmente tarda unos segundos.',
  'workspace.terminalSessionEnded': 'Sesión finalizada',
  'workspace.terminalReconnecting': 'Reconectando…',
  'workspace.terminalStartFailed': 'No se pudo iniciar la sesión de terminal',
  'workspace.terminalRestart': 'Reiniciar',
  'generationPreview.title': 'Generando…',
  'generationPreview.failedTitle': 'Error de generación',
  'generationPreview.failedFallback': 'Algo salió mal. Inténtalo de nuevo.',
  'generationPreview.footnote': 'Suele tardar de 2 a 5 minutos',
  'generationPreview.stepUnderstand': 'Entendiendo los requisitos',
  'generationPreview.stepGenerate': 'Generando la página',
  'generationPreview.stepPrepare': 'Preparando la vista previa',
  'generationPreview.retry': 'Reintentar',
  'generationPreview.awaitingTitle': 'Esperando tu respuesta',
  'generationPreview.awaitingLead': 'Responde unas preguntas en el chat para continuar.',
  'generationPreview.stoppedTitle': 'Generación en pausa',
  'generationPreview.stoppedLead': 'Reanuda los pasos restantes desde el chat de la izquierda.',
  'generationPreview.reasonAuth': 'Sesión o autorización caducada',
  'generationPreview.reasonRateLimited': 'Demasiadas solicitudes',
  'generationPreview.reasonService': 'Servicio de generación no disponible',
  'generationPreview.reasonBalance': 'Saldo de la cuenta agotado',
  'designFiles.title': 'Archivos de diseño',
  'designFiles.upload': 'Subir archivos',
  'designFiles.pasteText': 'Pegar como archivo de texto',
  'designFiles.newSketch': 'Nuevo boceto',
  'designFiles.empty': 'Las creaciones aparecerán aquí',
  'designFiles.refresh': 'Actualizar',
  'designFiles.delete': 'Eliminar',
  'designFiles.searchPlaceholder': 'Buscar archivos…',
  'designFiles.up': 'Subir',
  'designFiles.back': 'Atrás',
  'designFiles.crumbs': 'proyecto',
  'designFiles.rowMenu': 'Menú de la fila',
  'designFiles.openInTab': 'Abrir en pestaña',
  'designFiles.download': 'Descargar',
  'designFiles.downloadSelected': 'Descargar {n} como ZIP',
  'designFiles.deleteSelected': 'Eliminar {n}',
  'designFiles.clearSelection': 'Limpiar selección',
  'designFiles.selectPage': 'Seleccionar todo en la página',
  'designFiles.selectAll': 'Seleccionar todo',
  'designFiles.dropTitle': '⤓ Suelta archivos aquí',
  'designFiles.dropDesc': 'Imágenes, documentos, referencias o carpetas: el agente los usará como contexto.',
  'designFiles.upload.title': 'Subir archivos',
  'designFiles.paste.title': 'Pegar texto como archivo',
  'designFiles.upload.label': 'Subir',
  'designFiles.paste.label': 'Pegar',
  'designFiles.previewOpen': 'Abrir',
  'designFiles.previewClose': 'Cerrar vista previa',
  'designFiles.modified': 'Modificado {time} · {size}',
  'designFiles.weeksAgo': 'hace {n} sem',
  'designFiles.groupBy': 'Agrupar por',
  'designFiles.groupByKind': 'Tipo',
  'designFiles.groupByModified': 'Modificado',
  'designFiles.filterBy': 'Filtrar por tipo',
  'designFiles.filterClear': 'Borrar',
  'designFiles.filterCount': '{n} tipos',
  'designFiles.expandGroup': 'Expandir',
  'designFiles.collapseGroup': 'Contraer',
  'designFiles.sectionPages': 'Páginas',
  'designFiles.sectionScripts': 'Scripts',
  'designFiles.sectionImages': 'Imágenes',
  'designFiles.sectionSketches': 'Bocetos',
  'designFiles.sectionLiveArtifacts': 'Artefactos en vivo',
  'designFiles.sectionOther': 'Otros',
  'designFiles.modifiedToday': 'Hoy',
  'designFiles.modifiedYesterday': 'Ayer',
  'designFiles.modifiedPrevious7Days': 'Últimos 7 días',
  'designFiles.modifiedPrevious30Days': 'Últimos 30 días',
  'designFiles.modifiedOlder': 'Anterior',
  'designFiles.showMore': 'Mostrar +{n} más',
  'designFiles.kindHtml': 'Página HTML',
  'designFiles.kindImage': 'Imagen',
  'designFiles.kindSketch': 'Boceto',
  'designFiles.kindText': 'Texto',
  'designFiles.kindCode': 'Script',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Documento',
  'designFiles.kindPresentation': 'Presentación',
  'designFiles.kindSpreadsheet': 'Hoja de cálculo',
  'designFiles.kindLiveArtifact': 'Artefacto en vivo',
  'designFiles.kindBinary': 'Binario',
  'designFiles.kindFolder': 'Carpeta',
  'designFiles.folderCount': '{n} archivos',
  'designFiles.newFolderTitle': 'Nueva carpeta',
  'designFiles.newFolderLabel': 'Nombre de la carpeta',
  'designFiles.moveTitle': 'Mover a la carpeta',
  'designFiles.moveLabel': 'Carpeta de destino',
  'designFiles.moveRoot': 'Raíz del proyecto',
  'designFiles.moveNewFolder': 'Nueva carpeta…',
  'designFiles.move': 'Mover',
  'designFiles.copyPath': 'Copiar ruta',
  'designFiles.copiedPath': 'Ruta copiada',
  'designFiles.deleteFolderConfirm': '¿Eliminar la carpeta "{name}" y todo su contenido?',
  'designFiles.folderCreated': 'Carpeta "{name}" creada',
  'designFiles.folderDeleted': 'Carpeta "{name}" eliminada',
  'designFiles.filesMoved': '{n} movido(s) a {dest}',
  'designFiles.colName': 'Nombre',
  'designFiles.colKind': 'Tipo',
  'designFiles.colModified': 'Modificado',
  'designFiles.perPage': 'Mostrar',
  'designFiles.all': 'Todos',
  'designFiles.prev': 'Anterior',
  'designFiles.next': 'Siguiente',
  'designFiles.jumpToPage': 'Ir a la página',
  'designFiles.pageInfo': '{start}–{end} de {total}',
  'designFiles.sectionFolders': 'Carpetas',
  'designFiles.sectionStylesheets': 'Hojas de estilos',
  'designFiles.sectionDocuments': 'Documentos',
  'designFiles.kindStylesheet': 'Hoja de estilos',
  'designFiles.modifiedExt': 'Modificado {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'Información útil',
  'designFiles.usefulInfoTip': 'Haz doble clic en cualquier archivo para abrirlo en una pestaña completa.',
  'quickSwitcher.placeholder': 'Abrir archivo…',
  'quickSwitcher.empty': 'No hay archivos en este proyecto',
  'quickSwitcher.noMatches': 'Sin resultados',
  'quickSwitcher.navigate': 'navegar',
  'quickSwitcher.open': 'abrir',
  'quickSwitcher.close': 'cerrar',
  'pasteDialog.title': 'Pegar texto',
  'pasteDialog.hint': 'Se guarda en la carpeta del proyecto. Elige cualquier nombre.',
  'pasteDialog.fileNameLabel': 'Nombre del archivo',
  'pasteDialog.namePlaceholder': 'notas.txt',
  'pasteDialog.contentLabel': 'Contenido',
  'pasteDialog.contentPlaceholder': 'Pega lo que quieras…',
  'pasteDialog.save': 'Guardar',
  'pasteDialog.cancel': 'Cancelar',
  'sketch.save': 'Guardar boceto',
  'sketch.cancel': 'Cancelar',
  'sketch.saving': 'Guardando…',
  'sketch.saved': 'Guardado',
  'sketch.tooltipDirty': 'Cambios sin guardar',
  'sketch.tooltipClean': 'Guardado',
  'fileViewer.empty': 'Selecciona un archivo para verlo.',
  'fileViewer.loading': 'Cargando…',
  'fileViewer.exportPptx': 'Exportar como PPTX',
  'fileViewer.openInNewTab': 'Abrir en pestaña nueva',
  'fileViewer.copyPath': 'Copiar ruta',
  'fileViewer.copied': '¡Copiado!',
  'fileViewer.share': 'Compartir',
  'fileViewer.binaryMeta': 'Binario · {size}',
  'fileViewer.binaryNote': 'Archivo binario ({size} bytes). Descárgalo o ábrelo desde el disco para inspeccionarlo.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Documento',
  'fileViewer.presentationMeta': 'Presentación',
  'fileViewer.spreadsheetMeta': 'Hoja de cálculo',
  'fileViewer.previewUnavailable': 'Vista previa no disponible. Descarga o abre el archivo para inspeccionarlo.',
  'fileViewer.download': 'Descargar',
  'fileViewer.open': 'Abrir',
  'fileViewer.imageMeta': 'Imagen · {size}',
  'fileViewer.reactMeta': 'Componente React · {size}',
  'fileViewer.sketchMeta': 'Boceto · {size}',
  'fileViewer.markdownStreamingMeta': 'Vista previa en streaming…',
  'fileViewer.markdownErrorMeta': 'La vista previa puede estar incompleta (error de generación).',
  'fileViewer.markdownStreamingStatus': 'Streaming… mostrando markdown parcial.',
  'fileViewer.markdownErrorStatus': 'Error de generación. Mostrando el último contenido disponible.',
  'fileViewer.videoMeta': 'Vídeo · {size}',
  'fileViewer.audioMeta': 'Audio · {size}',
  'fileViewer.reload': 'Recargar',
  'fileViewer.reloadDisk': 'Recargar desde el disco',
  'fileViewer.copy': 'Copiar',
  'fileViewer.copyTitle': 'Copiar el contenido del archivo',
  'fileViewer.saveDisabled': 'Guardar (visor de solo lectura)',
  'fileViewer.save': 'Guardar',
  'fileViewer.preview': 'Vista previa',
  'fileViewer.source': 'Código fuente',
  'fileViewer.tweaks': 'Ajustes',
  'fileViewer.tweaksUnavailable': 'Sin panel de ajustes en este artefacto',
  'fileViewer.jsxModuleTitle': 'Sin vista previa independiente',
  'fileViewer.jsxModuleBody': 'Este archivo es un módulo de componente cargado por otra página.',
  'fileViewer.jsxModuleCta': 'Abre la página que lo renderiza:',
  'fileViewer.comment': 'Comentar',
  'fileViewer.edit': 'Editar',
  'fileViewer.draw': 'Dibujar',
  'fileViewer.mark': 'Marcar',
  'fileViewer.markTool': 'Herramienta de marcado',
  'fileViewer.boxSelect': 'Seleccionar área',
  'fileViewer.screenshot': 'Captura',
  'manualEdit.layers': 'Capas',
  'manualEdit.editableCount': '{count} editables',
  'manualEdit.hiddenBadge': 'Oculto',
  'manualEdit.title': 'Editor manual',
  'manualEdit.fallbackTitle': 'Editar',
  'manualEdit.movePanel': 'Mover el panel de edición',
  'manualEdit.editParams': 'Editar parámetros',
  'manualEdit.closePanel': 'Cerrar el panel de edición',
  'manualEdit.selectLayer': 'Selecciona una capa',
  'manualEdit.empty': 'Haz clic en un elemento de la vista previa o elige una capa.',
  'manualEdit.noEditableLayers': 'No se encontraron capas editables.',
  'manualEdit.noClass': 'sin clase',
  'manualEdit.tabsAria': 'Pestañas de edición manual',
  'manualEdit.tabContent': 'Contenido',
  'manualEdit.tabStyle': 'Estilo',
  'manualEdit.tabAttributes': 'Atributos',
  'manualEdit.tabHtml': 'Html',
  'manualEdit.tabSource': 'Código fuente',
  'manualEdit.attributesJson': 'JSON de atributos',
  'manualEdit.selectedHtml': 'HTML del elemento seleccionado',
  'manualEdit.fullSource': 'Código fuente completo del artefacto',
  'manualEdit.applyContent': 'Aplicar contenido',
  'manualEdit.applyStyle': 'Aplicar estilo',
  'manualEdit.applyAttributes': 'Aplicar atributos',
  'manualEdit.applyHtml': 'Aplicar HTML',
  'manualEdit.applySource': 'Aplicar código fuente',
  'manualEdit.invalidAttributes': 'JSON de atributos no válido.',
  'manualEdit.changes': 'Cambios',
  'manualEdit.undo': 'Deshacer',
  'manualEdit.redo': 'Rehacer',
  'manualEdit.noChanges': 'Aún no hay ediciones manuales.',
  'manualEdit.imageUrl': 'URL de la imagen',
  'manualEdit.altText': 'Texto alternativo',
  'manualEdit.label': 'Etiqueta',
  'manualEdit.text': 'Texto',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': 'Color del texto',
  'manualEdit.background': 'Fondo',
  'manualEdit.fontSize': 'Tamaño de fuente',
  'manualEdit.weight': 'Grosor',
  'manualEdit.align': 'Alineación',
  'manualEdit.padding': 'Relleno',
  'manualEdit.margin': 'Margen',
  'manualEdit.radius': 'Radio',
  'manualEdit.border': 'Borde',
  'manualEdit.width': 'Ancho',
  'manualEdit.minHeight': 'Altura mínima',
  'manualEdit.deleteElement': 'Eliminar elemento',
  'manualEdit.deleteElementConfirm': '¿Eliminar el elemento seleccionado? Esta acción se puede revertir con Deshacer.',
  'manualEdit.uploadImage': 'Subir imagen',
  'manualEdit.uploadingImage': 'Subiendo imagen…',
  'manualEdit.uploadImageFailed': 'No se pudo subir la imagen.',
  'manualEdit.focusSlides': 'Enfocar diapositivas',
  'manualEdit.showPanels': 'Mostrar paneles',
  'fileViewer.zoomOut': 'Reducir zoom',
  'fileViewer.zoomIn': 'Aumentar zoom',
  'fileViewer.resetZoom': 'Restablecer zoom',
  'fileViewer.viewportAria': 'Vista previa del viewport',
  'fileViewer.viewportDesktop': 'Escritorio',
  'fileViewer.viewportDesktopTitle': 'Vista previa de escritorio a ancho completo',
  'fileViewer.viewportTablet': 'Tableta',
  'fileViewer.viewportTabletTitle': 'Vista previa de tableta a 820 × 1180 (base vertical moderna)',
  'fileViewer.viewportMobile': 'Móvil',
  'fileViewer.viewportMobileTitle': 'Vista previa de móvil a 390 × 844',
  'fileViewer.reloadAria': 'Recargar',
  'fileViewer.previousSlide': 'Diapositiva anterior',
  'fileViewer.nextSlide': 'Diapositiva siguiente',
  'fileViewer.slideNavAria': 'Navegación de diapositivas',
  'fileViewer.present': 'Presentar',
  'fileViewer.presentInTab': 'En esta pestaña',
  'fileViewer.presentFullscreen': 'Pantalla completa',
  'fileViewer.presentNewTab': 'Pestaña nueva',
  'fileViewer.speakerNotes': 'Notas del orador',
  'fileViewer.speakerNotesSlide': 'Diapositiva {current} / {total}',
  'fileViewer.speakerNotesEmpty': 'No hay notas del orador para esta diapositiva.',
  'fileViewer.speakerNotesEdit': 'Editar',
  'fileViewer.speakerNotesSave': 'Guardar notas',
  'fileViewer.speakerNotesPlaceholder': 'Añade notas del orador para esta diapositiva…',
  'fileViewer.presenterEmptyDeck': 'No hay diapositivas en esta presentación.',
  'fileViewer.presenterReset': 'Restablecer',
  'fileViewer.presenterMode': 'Vista del presentador',
  'fileViewer.deckThumbnailRailAria': 'Diapositivas',
  'fileViewer.presenterPause': 'Pausar',
  'fileViewer.presenterResume': 'Reanudar',
  'fileViewer.presenterPrevious': 'Anterior',
  'fileViewer.presenterNext': 'Siguiente',
  'fileViewer.exitPresentation': 'Salir de la presentación',
  'fileViewer.shareLabel': 'Compartir',
  'fileViewer.shareMenuShareLink': 'COMPARTIR',
  'fileViewer.shareMenuPublishOnline': 'PUBLICAR EN LÍNEA',
  'fileViewer.shareMenuDownload': 'DESCARGAR',
  'fileViewer.shareMenuPresentation': 'Presentación',
  'fileViewer.shareMenuSourceFiles': 'Archivos fuente',
  'fileViewer.shareMenuSave': 'GUARDAR',
  'fileViewer.copyShareLink': 'Copiar enlace compartido',
  'fileViewer.openSharePage': 'Abrir página compartida',
  'fileViewer.shareLinkRequiresDeploy': 'Publica en línea primero para obtener un enlace',
  'fileViewer.shareLinkPublishGuide': 'Publica en línea arriba para habilitar compartir ↑',
  'fileViewer.shareAfterGenerationComplete': 'Comparte cuando termine la generación',
  'fileViewer.copyProviderLink': 'Copiar enlace de {provider}',
  'fileViewer.copyCloudflareLink': 'Copiar enlace de Cloudflare',
  'fileViewer.screenshotCopying': 'Copiando captura de pantalla...',
  'fileViewer.screenshotCopied': 'Captura de pantalla copiada al portapapeles',
  'fileViewer.screenshotClipboardDenied': 'El navegador bloqueó el acceso al portapapeles',
  'fileViewer.screenshotPreviewLoading': 'La vista previa aún se está cargando. Inténtalo de nuevo en un momento.',
  'fileViewer.screenshotCaptureFailed': 'No se pudo capturar la vista previa. Inténtalo de nuevo.',
  'fileViewer.exportPdf': 'Exportar como PDF',
  'fileViewer.exportPdfAllSlides': 'Exportar como PDF (todas las diapositivas)',
  'fileViewer.exportPptxBusy': 'Espera a que termine el turno actual.',
  'fileViewer.exportPptxHint': 'Envía una solicitud al agente para convertir este diseño a PPTX.',
  'fileViewer.exportPptxNa': 'La exportación a PPTX no está disponible aquí.',
  'fileViewer.exportZip': 'Descargar como .zip',
  'fileViewer.exportHtml': 'Exportar como HTML independiente',
  'fileViewer.exportMd': 'Exportar como Markdown',
  'fileViewer.exportImage': 'Exportar como imagen',
  'fileViewer.exportImageFailed': 'Error al capturar la imagen. Inténtalo de nuevo o usa la herramienta de captura de pantalla de tu navegador.',
  'fileViewer.exportImageModalSubtitle': 'Elige un formato y descarga la vista previa actual como imagen.',
  'fileViewer.exportImageFormatLabel': 'Formato',
  'fileViewer.exportImageSaving': 'Guardando imagen…',
  'fileViewer.exportImageSaved': 'Imagen guardada',
  'fileViewer.exportImageDownloadStarted': 'Descarga iniciada',
  'fileViewer.exportImageDownloadDetails': '{filename} está en las descargas del navegador si no apareció un cuadro de diálogo Guardar como.',
  'fileViewer.exportJsx': 'Exportar como JSX',
  'fileViewer.exportReactHtml': 'Exportar vista previa como HTML',
  'fileViewer.exportStarted': 'Exportación iniciada',
  'fileViewer.saveAsTemplate': 'Guardar como plantilla…',
  'fileViewer.savingTemplate': 'Guardando plantilla…',
  'fileViewer.savedTemplate': 'Guardado como «{name}»',
  'fileViewer.savedTemplateFail': 'No se pudo guardar la plantilla. Inténtalo de nuevo.',
  'fileViewer.templateNamePrompt': 'Nombre de la plantilla',
  'fileViewer.templateNameDefault': 'Plantilla sin título',
  'fileViewer.templateDescPrompt': 'Descripción breve (opcional: ¿qué hace útil esta plantilla?)',
  'liveArtifact.refresh.button': 'Actualizar',
  'liveArtifact.refresh.buttonTitle': 'Actualizar este artefacto en vivo',
  'liveArtifact.refresh.loadingTitle': 'Cargando artefacto en vivo…',
  'liveArtifact.refresh.noSourceTitle': 'Aún no hay ninguna fuente de actualización disponible.',
  'liveArtifact.refresh.running': 'Actualizando…',
  'liveArtifact.refresh.runningMessage': 'Actualizando datos y vista previa. Esto puede tardar un momento.',
  'liveArtifact.refresh.runningAction': 'La vista previa anterior permanece visible hasta que la actualización se complete correctamente.',
  'liveArtifact.refresh.successOne': 'Actualización completada. Datos actualizados.',
  'liveArtifact.refresh.successMany': 'Actualización completada. Datos actualizados.',
  'liveArtifact.refresh.successAction': 'La vista previa se ha recargado con los últimos datos confirmados.',
  'liveArtifact.refresh.previousFailure': 'La actualización anterior falló: {message}',
  'liveArtifact.refresh.failureAction': 'Revisa el historial de Actualizar, corrige el problema de origen o de permisos y vuelve a intentarlo.',
  'liveArtifact.refresh.networkFailure': 'La solicitud de actualización falló. Comprueba tu conexión e inténtalo de nuevo.',
  'liveArtifact.refresh.genericFailure': 'La actualización falló.',
  'liveArtifact.refresh.statusNever': 'No actualizable',
  'liveArtifact.refresh.statusReady': 'Listo para actualizar',
  'liveArtifact.refresh.statusSucceeded': 'Actualizado',
  'liveArtifact.refresh.statusFailed': 'La actualización falló',
  'liveArtifact.refresh.statusRunning': 'Actualizando',
  'liveArtifact.refresh.statusRunningDescription': 'Hay una actualización en curso actualmente.',
  'liveArtifact.refresh.statusSucceededDescription': 'La última actualización finalizó correctamente.',
  'liveArtifact.refresh.statusFailedDescription': 'El último intento de actualización no se completó correctamente.',
  'liveArtifact.refresh.statusReadyDescription': 'Hay fuentes actualizables configuradas, pero no hay ninguna ejecución en curso.',
  'liveArtifact.refresh.statusNeverDescription': 'Este artefacto en vivo aún no tiene fuente de actualización.',
  'liveArtifact.refresh.eventStarted': 'Iniciado',
  'liveArtifact.refresh.eventSucceeded': 'Correcto',
  'liveArtifact.refresh.eventFailed': 'Fallido',
  'liveArtifact.refresh.eventStartedDetail': 'Actualización iniciada…',
  'liveArtifact.refresh.sourcesUpdatedOne': '{n} fuente actualizada',
  'liveArtifact.refresh.sourcesUpdatedMany': '{n} fuentes actualizadas',
  'liveArtifact.refresh.timelineEmpty': 'Aún no hay actividad de actualización en esta sesión. Activa Actualizar para registrar una cronología o espera a las ejecuciones automáticas.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'Última actualización',
  'liveArtifact.refresh.heroLastRefreshedNever': 'Nunca',
  'liveArtifact.refresh.justNow': 'ahora mismo',
  'liveArtifact.refresh.factCreated': 'Creado',
  'liveArtifact.refresh.factLastUpdated': 'Última actualización',
  'liveArtifact.refresh.factUnknown': 'Desconocido',
  'liveArtifact.refresh.persistedTitle': 'Historial de actualizaciones persistente',
  'liveArtifact.refresh.persistedHint': 'Entradas cargadas desde refreshes.jsonl',
  'liveArtifact.refresh.persistedEmpty': 'Aún no hay historial de actualizaciones persistente.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'correcto',
  'liveArtifact.refresh.persistedStatusRunning': 'en ejecución',
  'liveArtifact.refresh.persistedStatusFailed': 'fallido',
  'liveArtifact.refresh.persistedStatusCancelled': 'cancelado',
  'liveArtifact.refresh.persistedStatusSkipped': 'omitido',
  'liveArtifact.refresh.sessionTitle': 'Actividad de la sesión',
  'liveArtifact.refresh.sessionHint': 'Eventos observados mientras esta pestaña está abierta',
  'liveArtifact.refresh.docSourceTitle': 'Fuente del documento',
  'liveArtifact.refresh.docSourceHint': 'Fuente configurada',
  'liveArtifact.refresh.docSourceType': 'Tipo',
  'liveArtifact.refresh.docSourceTool': 'Herramienta',
  'liveArtifact.refresh.docSourceConnector': 'Conector',
  'liveArtifact.refresh.debugSummary': 'Metadatos de depuración avanzados',
  'liveArtifact.refresh.debugNote': 'Puede incluir IDs de conectores, nombres de archivo, metadatos de la fuente y rutas internas de artefactos.',
  'liveArtifact.viewer.tabPreview': 'Vista previa',
  'liveArtifact.viewer.tabCode': 'Código',
  'liveArtifact.viewer.tabData': 'Datos',
  'liveArtifact.viewer.tabRefreshHistory': 'Historial de actualizaciones',
  'liveArtifact.viewer.dataEmpty': 'No hay caché data.json disponible.',
  'liveArtifact.viewer.code.templateHeading': 'HTML de plantilla',
  'liveArtifact.viewer.code.renderedHeading': 'HTML renderizado',
  'liveArtifact.viewer.code.templateHelp': 'La plantilla editable usada con data.json para generar la vista previa.',
  'liveArtifact.viewer.code.renderedHelp': 'El index.html generado que Preview carga actualmente.',
  'liveArtifact.viewer.code.variantAria': 'Variante de código',
  'liveArtifact.viewer.code.variantTemplate': 'Plantilla',
  'liveArtifact.viewer.code.variantRendered': 'Renderizado',
  'liveArtifact.viewer.code.loading': 'Cargando código…',
  'liveArtifact.viewer.code.unavailable': 'El código aún no está disponible.',
  'liveArtifact.viewer.code.empty': 'Este archivo de código está vacío.',
  'fileViewer.deployToVercel': 'Desplegar en Vercel',
  'fileViewer.redeployToVercel': 'Volver a desplegar',
  'fileViewer.deployingToVercel': 'Desplegando en Vercel…',
  'fileViewer.deployProviderLabel': 'Proveedor',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployToProvider': 'Desplegar en {provider}',
  'fileViewer.redeployToProvider': 'Volver a desplegar en {provider}',
  'fileViewer.deployingToProvider': 'Desplegando en {provider}…',
  'fileViewer.preparingPublicLink': 'Preparando enlace público…',
  'fileViewer.copyDeployLink': 'Copiar enlace',
  'fileViewer.deployModalTitle': 'Desplegar',
  'fileViewer.deployModalSubtitle': 'Usa la cuenta del proveedor seleccionado para desplegar esta vista previa HTML.',
  'fileViewer.vercelToken': 'Token de Vercel',
  'fileViewer.vercelTokenGetLink': 'Obtener token de Vercel',
  'fileViewer.vercelTokenPlaceholder': 'Pega tu token de Vercel',
  'fileViewer.vercelTokenReuseHint': 'Se usará el token guardado. Introduce uno nuevo para sustituirlo.',
  'fileViewer.vercelTokenRequired': 'Introduce y guarda primero un token de Vercel.',
  'fileViewer.cloudflareApiToken': 'Token de API de Cloudflare',
  'fileViewer.cloudflareApiTokenGetLink': 'Obtener token de API',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Pega tu token de API de Cloudflare',
  'fileViewer.cloudflareApiTokenReuseHint': 'Se usará el token de API de Cloudflare guardado. Introduce uno nuevo para sustituirlo.',
  'fileViewer.cloudflareApiTokenRequired': 'Introduce y guarda primero un token de API de Cloudflare.',
  'fileViewer.cloudflareApiTokenScopeHint': 'Selecciona Pages Edit al crear el token de API; los dominios personalizados necesitan Zone Read / DNS Edit.',
  'fileViewer.vercelTeamId': 'ID del equipo',
  'fileViewer.vercelTeamSlug': 'Slug del equipo',
  'fileViewer.cloudflareAccountId': 'ID de cuenta',
  'fileViewer.cloudflareAccountIdHint': 'Encuentra el ID de cuenta en el panel de Cloudflare.',
  'fileViewer.cloudflareAccountIdRequired': 'Introduce y guarda primero un Cloudflare Account ID.',
  'fileViewer.cloudflareZoneLabel': 'Dominio',
  'fileViewer.cloudflareZonePlaceholder': 'Guarda la configuración de Cloudflare para cargar los dominios',
  'fileViewer.cloudflareZoneRequired': 'Selecciona primero un dominio de Cloudflare.',
  'fileViewer.cloudflareZonesLoading': 'Cargando dominios de Cloudflare…',
  'fileViewer.cloudflareZonesRefresh': 'Actualizar dominios',
  'fileViewer.cloudflareZonesLoadFailed': 'No se pudieron cargar los dominios de Cloudflare.',
  'fileViewer.cloudflareZonesEmpty': 'No se encontraron dominios completos activos de Cloudflare para esta cuenta.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Prefijo de subdominio',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Usa una sola etiqueta DNS: letras minúsculas, números y guiones.',
  'fileViewer.cloudflareHostnamePreview': 'Vista previa del dominio personalizado: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Opcional: vincula un dominio personalizado. Si lo dejas vacío, se seguirá creando un enlace pages.dev.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'URL de pages.dev',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Dominio personalizado',
  'fileViewer.optional': 'Opcional',
  'fileViewer.vercelPreviewOnly': 'Los despliegues son solo Preview por ahora.',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages usa Direct Upload.',
  'fileViewer.savingConfig': 'Guardando…',
  'fileViewer.deployConfigSaveFailed': 'No se pudo guardar la configuración de Vercel.',
  'fileViewer.deployFailed': 'El despliegue falló. Revisa la configuración de Vercel e inténtalo de nuevo.',
  'fileViewer.deployProviderConfigSaveFailed': 'No se pudo guardar la configuración de {provider}.',
  'fileViewer.deployProviderFailed': 'El despliegue en {provider} falló. Revisa la configuración e inténtalo de nuevo.',
  'fileViewer.deployResultLabel': 'URL desplegada',
  'fileViewer.deployLinkReady': 'Listo',
  'fileViewer.deploySuccessToast': 'Despliegue subido correctamente',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Enlace público pendiente',
  'fileViewer.deployLinkDelayed': 'El sitio se ha desplegado. El proveedor aún está preparando el enlace público.',
  'fileViewer.deployLinkFailed': 'Falló el dominio personalizado',
  'fileViewer.deployLinkProtectedLabel': 'Protección del despliegue activada',
  'fileViewer.deployLinkProtected': 'El sitio se ha desplegado, pero este enlace de vista previa requiere autenticación. Desactiva Deployment Protection o usa un dominio personalizado.',
  'fileViewer.retryLink': 'Reintentar ahora',
  'fileViewer.versions.entry': 'Versions',
  'fileViewer.versions.entryFull': 'Version history',
  'fileViewer.versions.title': 'Versions',
  'fileViewer.versions.countOne': '1 version',
  'fileViewer.versions.countMany': '{count} versions',
  'fileViewer.versions.current': 'Current',
  'fileViewer.versions.sourceAi': 'AI edit',
  'fileViewer.versions.sourceManual': 'Manual edit',
  'fileViewer.versions.sourceRestore': 'Restored',
  'fileViewer.versions.restoredFrom': 'Restored from v{version}',
  'fileViewer.versions.versionLabel': 'Version {version}',
  'fileViewer.versions.listAria': 'File versions',
  'fileViewer.versions.loading': 'Loading versions…',
  'fileViewer.versions.empty': 'No versions yet.',
  'fileViewer.versions.loadFailed': 'Could not load version history.',
  'fileViewer.versions.previewFailed': 'Could not load this version.',
  'fileViewer.versions.noPrompt': 'No prompt recorded',
  'fileViewer.versions.promptTitle': 'Prompt',
  'fileViewer.versions.diffTitle': 'Compare with current',
  'fileViewer.versions.restore': 'Restore',
  'fileViewer.versions.restoreConfirmTitle': 'Switch to this version?',
  'fileViewer.versions.restoreConfirmCta': 'Restore this version',
  'fileViewer.versions.restoring': 'Restoring…',
  'fileViewer.versions.restoreFailed': 'Restore failed.',
  'fileViewer.versions.restoreSuccess': 'Restored version {version}.',
  'fileViewer.versions.currentHelp': 'This is already the current version.',
  'fileViewer.versions.restoreHelp': 'Restoring writes this HTML as a new current version.',
  'fileViewer.versions.close': 'Close version history',
  'questionForm.submit': 'Enviar',
  'questionForm.skip': 'Omitir',
  'questionForm.locked': 'Respondido',
  'conv.switch': 'Cambiar de conversación',
  'conv.label': 'Conversación',
  'conv.heading': 'Conversaciones',
  'conv.new': '+ Nueva',
  'conv.empty': 'Aún no hay conversaciones.',
  'conv.untitled': 'Conversación sin título',
  'conv.renameTooltip': 'Doble clic para renombrar',
  'conv.delete': 'Eliminar conversación',
  'conv.deleteConfirm': '¿Eliminar «{title}»? Se borrarán sus mensajes.',
  'agentPicker.label': 'Agente',
  'agentPicker.modeChoose': 'Elige el modo de ejecución',
  'agentPicker.localCli': 'CLI local',
  'agentPicker.daemonOff': 'daemon apagado',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'Selecciona una CLI de agente de código detectada',
  'agentPicker.noAgents': 'no hay agentes en el PATH',
  'agentPicker.notInstalled': 'no instalado',
  'agentPicker.rescan': 'Reescanear el PATH local en busca de agentes',
  'tool.openInTab': 'Abrir {name} en una pestaña',
  'tool.open': 'abrir',
  'tool.todos': 'Tareas',
  'tool.askQuestion': 'Pregunta',
  'tool.askQuestionSubmit': 'Enviar',
  'tool.askQuestionPending': 'Esperando tu respuesta',
  'tool.askQuestionAnswered': 'Respondido',
  'tool.todosExpand': 'Mostrar tareas',
  'tool.todosCollapse': 'Ocultar tareas',
  'tool.todosDone': 'Listo',
  'tool.todosDismiss': 'Descartar lista de tareas',
  'tool.write': 'Escribir',
  'tool.edit': 'Editar',
  'tool.read': 'Leer',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Obtener',
  'tool.search': 'Buscar',
  'tool.lines': '{n} líneas',
  'tool.changeSingular': 'cambio',
  'tool.changePlural': 'cambios',
  'tool.in': 'en {path}',
  'tool.hide': 'ocultar',
  'tool.output': 'salida',
  'tool.running': 'ejecutando…',
  'tool.error': 'error',
  'tool.done': 'listo',
  'assistant.role': 'Asistente',
  'assistant.workingLabel': 'Trabajando',
  'assistant.doneLabel': 'Listo',
  'assistant.copyMarkdown': 'Copiar Markdown de la respuesta',
  'assistant.forkConversation': 'Bifurcar desde aquí',
  'assistant.forkingConversation': 'Bifurcando…',
  'assistant.shareToOpenDesign': 'Compartir con Gini Studio',
  'assistant.shareToOpenDesignBusy': 'Compartiendo…',
  'assistant.feedbackPrompt': 'Comentarios',
  'assistant.feedbackPositive': 'Útil',
  'assistant.feedbackNegative': 'No útil',
  'assistant.feedbackReasonTitle': 'Dinos por qué',
  'assistant.feedbackReasonPositiveMatched': 'Entendió mi solicitud',
  'assistant.feedbackReasonPositiveVisual': 'Tiene buena pinta',
  'assistant.feedbackReasonPositiveUseful': 'Estructura útil',
  'assistant.feedbackReasonPositiveEasy': 'Fácil de seguir editando',
  'assistant.feedbackReasonPositiveDesignSystem': 'Siguió el sistema de diseño',
  'assistant.feedbackReasonNegativeMissed': 'No tuvo en cuenta mi solicitud',
  'assistant.feedbackReasonNegativeVisual': 'La calidad visual necesita mejoras',
  'assistant.feedbackReasonNegativeIncomplete': 'Resultado incompleto',
  'assistant.feedbackReasonNegativeHard': 'Difícil de usar',
  'assistant.feedbackReasonNegativeDesignSystem': 'No siguió el sistema de diseño',
  'assistant.feedbackReasonOther': 'Otro',
  'assistant.feedbackReasonPlaceholder': 'Añade una nota breve...',
  'assistant.feedbackReasonSubmit': 'Enviar',
  'assistant.emptyResponseLabel': 'Sin salida',
  'assistant.emptyResponseMessage': 'El proveedor finalizó la solicitud sin devolver texto ni un artefacto. Prueba con otro modelo o proveedor, comprueba la cuota o vuelve a intentarlo.',
  'assistant.unfinishedLabel': 'Detenido con tareas pendientes',
  'assistant.unfinishedSummary': 'quedan {n} tarea(s)',
  'assistant.unfinishedMore': '+{n} más',
  'assistant.continueRemaining': 'Continuar tareas pendientes',
  'assistant.outTokens': '{n} salida',
  'assistant.producedFiles': 'Archivos de este turno',
  'assistant.openFile': 'Abrir',
  'assistant.downloadFile': 'Descargar',
  'nextStep.title': 'Siguiente paso',
  'nextStep.share': 'Compartir',
  'nextStep.chipJoiner': ', ',
  'nextStep.chipPolishVisual': 'Hacerlo más premium',
  'nextStep.chipBrand': 'Reforzar el estilo de marca',
  'nextStep.chipConcise': 'Condensar el texto',
  'nextStep.chipSecondVersion': 'Generar una segunda versión',
  'assistant.thinking': 'Pensando',
  'assistant.thought': 'Pensó',
  'assistant.thoughtFor': 'Pensó durante {s}s',
  'assistant.systemReminder': 'Recordatorio del sistema',
  'assistant.possiblePromptInjection': 'Posible inyección de prompt',
  'assistant.waitingFirstOutput': 'Esperando la primera salida',
  'assistant.statusBootingAgent': 'Iniciando agente',
  'assistant.statusPreparing': 'Preparando...',
  'assistant.statusStarting': 'Iniciando',
  'assistant.statusRequesting': 'Enviando solicitud',
  'assistant.statusThinking': 'Pensando',
  'assistant.statusStreaming': 'Transmitiendo',
  'assistant.slowHint': 'Está tardando más de lo normal. El formulario suele aparecer en 5-10 s. Puedes pulsar Detener y reformular.',
  'assistant.verbEditing': 'Editando',
  'assistant.verbWriting': 'Escribiendo',
  'assistant.verbReading': 'Leyendo',
  'assistant.verbSearching': 'Buscando',
  'assistant.verbRunning': 'Ejecutando',
  'assistant.verbTodos': 'Tareas',
  'assistant.verbFetching': 'Obteniendo',
  'assistant.verbCalling': 'Llamando',
  'qf.answered': 'respondido',
  'qf.choose': 'Elige…',
  'qf.required': 'obligatorio',
  'qf.lockedSubmitted': 'Respuestas enviadas: el agente las usará durante el resto de la sesión.',
  'qf.lockedPrev': 'Este formulario es de un turno anterior.',
  'qf.hint': 'Elige lo que encaje. Omite los campos opcionales que no te importen: el agente usará valores predeterminados sensatos.',
  'qf.submitDefault': 'Enviar respuestas',
  'qf.submitDisabledTitle': 'Rellena primero los campos obligatorios',
  'qf.submitTitle': 'Enviar respuestas',
  'qf.cardSelected': 'seleccionado',
  'qf.cardRefs': 'Refs:',
  'qf.cardSampleText': 'El veloz murciélago hindú · 0123',
  'questions.tabLabel': 'Preguntas',
  'questions.banner': '¿Te importa si te hago un par de preguntas rápidas?',
  'questions.continue': 'Continuar',
  'questions.generating': 'Generando preguntas…',
  'questions.skipAll': 'Omitir todo',
  'questions.autoSkipHint': 'Continúa automáticamente cuando termina el temporizador',
  'sketch.toolSelect': 'Seleccionar (sin acción)',
  'sketch.toolPen': 'Lápiz',
  'sketch.toolText': 'Texto',
  'sketch.toolRect': 'Rectángulo',
  'sketch.toolArrow': 'Flecha',
  'sketch.toolEraser': 'Borrador',
  'sketch.color': 'Color',
  'sketch.strokeSize': 'Grosor del trazo',
  'sketch.undo': 'Deshacer',
  'sketch.clear': 'Limpiar',
  'sketch.close': 'Cerrar',
  'sketch.closeConfirm': '¿Cerrar el boceto y descartar los cambios sin guardar?',
  'sketch.textPrompt': 'Texto:',
  'sketch.textModalTitle': 'Añadir texto',
  'critiqueTheater.userFacingName': 'Jurado de Diseño',
  'critiqueTheater.roleDesigner': 'Diseñador',
  'critiqueTheater.roleCritic': 'Crítico',
  'critiqueTheater.roleBrand': 'Marca',
  'critiqueTheater.roleA11y': 'Accesibilidad',
  'critiqueTheater.roleCopy': 'Texto',
  'critiqueTheater.roundLabel': 'Ronda {n} de {m}',
  'critiqueTheater.mustFix': '{n} correcciones obligatorias',
  'critiqueTheater.composite': 'Compuesta',
  'critiqueTheater.threshold': 'Umbral',
  'critiqueTheater.consensus': 'Consenso',
  'critiqueTheater.interrupt': 'Interrumpir',
  'critiqueTheater.interrupting': 'Interrumpiendo…',
  'critiqueTheater.interrupted': 'Interrumpido',
  'critiqueTheater.degradedHeading': 'Panel sin conexión en esta ejecución',
  'critiqueTheater.degradedReasonMalformed': 'Salida del panel con formato incorrecto (el analizador rechazó el bloque).',
  'critiqueTheater.degradedReasonOversize': 'La salida del panel superó el presupuesto seguro de bytes.',
  'critiqueTheater.degradedReasonAdapter': 'El adaptador {adapter} no admitía el protocolo Critique.',
  'critiqueTheater.degradedReasonProtocol': 'El adaptador {adapter} envió una versión de protocolo no admitida.',
  'critiqueTheater.degradedReasonMissingArtifact': 'La ejecución finalizó sin un artefacto final.',
  'critiqueTheater.replay': 'Reproducir',
  'critiqueTheater.replaySpeed': 'Velocidad de reproducción',
  'critiqueTheater.readOnly': 'Solo lectura',
  'critiqueTheater.shippedSummary': 'Entregado en la ronda {round} · compuesto {composite}',
  'critiqueTheater.interruptedSummary': 'Interrumpido en la ronda {round} · mejor compuesto {composite}',
  'critiqueTheater.shippedBadge': 'Publicado',
  'critiqueTheater.belowThresholdBadge': 'Por debajo del umbral',
  'critiqueTheater.timedOutBadge': 'Tiempo agotado',
  'critiqueTheater.failedHeading': 'La ejecución falló',
  'critiqueTheater.failedReasonCliExit': 'El CLI del agente terminó con un código distinto de cero antes de que el panel pudiera finalizar.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'Una ronda superó su presupuesto de tiempo.',
  'critiqueTheater.failedReasonTotalTimeout': 'La ejecución completa superó su presupuesto total de tiempo.',
  'critiqueTheater.failedReasonOrchestrator': 'Error interno del orquestador.',
  'critiqueTheater.transcriptEmpty': 'Aún no hay ninguna transcripción que reproducir. Ejecuta una crítica para grabar una.',
  'critiqueTheater.transcriptLoading': 'Cargando transcripción…',
  'critiqueTheater.transcriptError': 'No se pudo cargar la transcripción: {error}',
  'critiqueTheater.replaySpeedPaused': 'En pausa',
  'critiqueTheater.replaySpeedInstant': 'Instantáneo',
  'critiqueTheater.replaySpeedLive': 'En directo',
  'critiqueTheater.replaySpeedFast': 'Rápido',
  'critiqueTheater.settingsNav': 'Jurado de Diseño',
  'critiqueTheater.settingsNavHint': 'Revisión de diseño de cinco paneles para tus ejecuciones',
  'critiqueTheater.settingsEnabledLabel': 'Mostrar el Jurado de Diseño durante las ejecuciones del agente',
  'critiqueTheater.settingsEnabledDescription': 'Cuando está activado, aparece una revisión de cinco paneles junto a las generaciones del agente y puntúa la salida antes de publicarla. Puedes interrumpir en cualquier momento.',
  'critiqueTheater.settingsEnabledProjectHint': 'Guardado para este proyecto. Las nuevas ejecuciones de este proyecto se enrutarán a través del Jurado de Diseño en el servidor.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'Abre un proyecto para conservar esto en el servidor. Hasta entonces, esto solo cambia la preferencia en el navegador.',
  'pet.title': 'Mascotas',
  'pet.subtitle': 'Adopta una mascotita que flota sobre tu workspace.',
  'pet.navTitle': 'Mascotas',
  'pet.navHint': 'Adopta o personaliza',
  'pet.tabBuiltIn': 'Integradas',
  'pet.tabBuiltInHint': 'Compañeros incluidos con Gini Studio — elige uno y adóptalo.',
  'pet.builtInEmpty': 'Las mascotas integradas no están disponibles ahora. Actualiza la pestaña Comunidad cuando el daemon vuelva a estar en línea.',
  'pet.tabCustom': 'Personalizada',
  'pet.tabCustomHint': 'Pon nombre, glifo, color o sube un sprite.',
  'pet.tabCommunity': 'Comunidad',
  'pet.tabCommunityHint': 'Mascotas eclosionadas de Codex — adopta o genera una con IA.',
  'pet.tabsAria': 'Fuente de la mascota',
  'pet.adopt': 'Adoptar',
  'pet.adoptedBadge': 'Adoptada',
  'pet.adoptCallout': 'Adopta una mascota',
  'pet.changePet': 'Cambiar mascota',
  'pet.wake': 'Despertar',
  'pet.tuck': 'Esconder',
  'pet.wakeTitle': 'Despertar la mascota — mostrar el overlay.',
  'pet.tuckTitle': 'Esconder la mascota — ocultar el overlay.',
  'pet.settingsTitle': 'Abrir ajustes de mascota',
  'pet.useCustom': 'Usar mi mascota',
  'pet.customTitle': 'Crea la tuya',
  'pet.customHint': 'Elige nombre, símbolo y color — el overlay se actualiza en vivo.',
  'pet.customGreetingPlaceholder': 'Saluda con tu mascota…',
  'pet.fieldName': 'Nombre',
  'pet.fieldGlyph': 'Símbolo',
  'pet.fieldGlyphHint': 'Un solo emoji va mejor (p. ej. 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Saludo',
  'pet.fieldAccent': 'Color de acento',
  'pet.fieldAccentCustom': 'Color personalizado',
  'pet.fieldAccentDefault': 'Color de acento predeterminado',
  'pet.overlayAria': 'Compañero',
  'pet.spriteAria': '{name} — arrastra para mover, haz clic para conversar',
  'pet.spriteTitle': '¡Hola de {name}! Haz clic para conversar.',
  'pet.taskSummarySingle': 'Se está ejecutando {count} tarea de agente.',
  'pet.taskSummaryMultiple': 'Se están ejecutando {count} tareas de agente en {projects} proyectos.',
  'pet.taskSummaryRecentSingle': '{count} tarea de agente se ha completado recientemente.',
  'pet.taskSummaryRecentMultiple': '{count} tareas de agente se han completado recientemente.',
  'pet.taskListAria': 'Tareas de agente activas',
  'pet.taskOpenProject': 'Abrir {project}',
  'pet.taskGroup.running': 'En ejecución',
  'pet.taskGroup.queued': 'En espera',
  'pet.taskGroup.recent': 'Completados recientemente',
  'pet.idleQuote.leonardo.text': 'Aprender nunca agota la mente.',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': 'Vi al ángel en el mármol y tallé hasta liberarlo.',
  'pet.idleQuote.michelangelo.author': 'Miguel Ángel',
  'pet.idleQuote.bernini.text': 'Hay dos recursos que pueden ayudar al escultor: la luz y la sombra.',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': 'Cuando uno pinta, no piensa.',
  'pet.idleQuote.raphael.author': 'Rafael',
  'pet.idleQuote.caravaggio.text': 'Todas las obras, sin importar qué representen ni quién las pinte, no son más que bagatelas y nimiedades infantiles a menos que se hagan y se pinten del natural.',
  'pet.idleQuote.caravaggio.author': 'Caravaggio',
  'pet.idleQuote.rodin.text': 'Lo principal es emocionarse, amar, esperar, temblar, vivir.',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': 'Mascotas — despertar, esconder o elegir',
  'pet.composerMenuTitle': 'Mascotas',
  'pet.composerMenuHint': 'tip: escribe /pet para alternar',
  'pet.composerOpenSettings': 'Administrar mascotas',
  'pet.welcomeTeaserTitle': 'Adopta una mascota',
  'pet.welcomeTeaserBody': 'Un compañerito que flota sobre tu workspace.',
  'pet.welcomeTeaserCta': 'Elegir',
  'pet.imageUpload': 'Subir sprite',
  'pet.imageReplace': 'Reemplazar sprite',
  'pet.imageRemove': 'Usar emoji',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF o SVG. ¿Spritesheet? Sube una tira horizontal y ajusta el número de frames.',
  'pet.imageHintActive': 'Mostrando tu sprite. Pon frames > 1 para animar un spritesheet horizontal.',
  'pet.fieldFrames': 'Frames',
  'pet.fieldFramesHint': '1 = estático. > 1 = spritesheet horizontal.',
  'pet.fieldFps': 'Velocidad (fps)',
  'pet.fieldFpsHint': 'Velocidad de cambio de frames.',
  'pet.atlasImport': 'Importar sprite de Codex',
  'pet.atlasImportTitle': 'Importa un atlas hatch-pet 8x9 / 192x208 (PNG o WebP).',
  'pet.atlasPickerTitle': 'Elige una fila de animación',
  'pet.atlasPickerHint': 'Las mascotas Codex traen 9 filas de animación. Por defecto mantenemos todo el atlas para que la mascota cambie de fila al pasar el ratón, según la dirección del arrastre o tras estar inactiva. También puedes fijar un solo bucle.',
  'pet.atlasCancel': 'Descartar atlas',
  'pet.atlasAdopt': 'Fijar a esta fila',
  'pet.atlasAdoptFull': 'Usar atlas completo (animado)',
  'pet.atlasAdoptFullTitle': 'Conserva todas las filas para que la mascota reaccione al hover, a la dirección del arrastre y a la inactividad larga.',
  'pet.atlasAdoptRowTitle': 'Recorta solo la fila resaltada en una tira con bucle único.',
  'pet.atlasActiveHint': 'Atlas animado activo — la mascota elige una fila según tu interacción (hover, arrastre, inactividad).',
  'pet.atlasRow.idle': 'Inactivo',
  'pet.atlasRow.running-right': 'Corre a la derecha',
  'pet.atlasRow.running-left': 'Corre a la izquierda',
  'pet.atlasRow.waving': 'Saludo',
  'pet.atlasRow.jumping': 'Salto',
  'pet.atlasRow.failed': 'Falló',
  'pet.atlasRow.waiting': 'Espera',
  'pet.atlasRow.running': 'Corre',
  'pet.atlasRow.review': 'Revisión',
  'pet.hatchTitle': 'Eclosiona una mascota nueva con IA',
  'pet.hatchHint': 'Usa la skill hatch-pet incluida desde el chat para generar un spritesheet estilo Codex y luego impórtalo aquí.',
  'pet.hatchConcept': 'Concepto de mascota (opcional)',
  'pet.hatchConceptPlaceholder': 'p. ej. un shiba pixel-art con un suéter cómodo',
  'pet.hatchCopy': 'Copiar prompt',
  'pet.hatchCopied': '¡Copiado!',
  'pet.hatchFoot': 'Cuando la skill guarde tu mascota, vuelve y pulsa "Importar sprite de Codex".',
  'pet.slashPopoverAria': 'Comandos slash',
  'pet.slashPopoverTitle': 'Comandos',
  'pet.slashPopoverHint': '↑↓ navegar · enter elegir · esc cerrar',
  'pet.slashPet': 'Alternar, adoptar o ir a ajustes de mascota.',
  'pet.slashPetWake': 'Despertar la mascota flotante.',
  'pet.slashPetTuck': 'Guardar la mascota por ahora.',
  'pet.slashHatch': 'Genera una mascota Codex con la skill hatch-pet.',
  'pet.slashHatchArg': '<concepto>',
  'pet.slashSearch': 'Busca en la web con el comando OD research.',
  'pet.slashSearchArg': '<consulta>',
  'pet.codexTitle': 'Recién eclosionadas',
  'pet.codexSubtitle': 'Las mascotas empaquetadas por la skill hatch-pet aparecen aquí para adopción en un clic.',
  'pet.codexSubtitleWithDir': 'Escaneando {dir} en busca de paquetes de hatch-pet.',
  'pet.codexEmpty': 'Aún no hay mascotas eclosionadas. Escribe /hatch en el chat para generar una.',
  'pet.codexLoading': 'Buscando mascotas eclosionadas…',
  'pet.codexRefresh': 'Refrescar',
  'pet.codexAdopt': 'Adoptar',
  'pet.codexAdopting': 'Adoptando…',
  'pet.communitySync': 'Descargar mascotas de la comunidad',
  'pet.communitySyncing': 'Descargando…',
  'pet.communitySyncTitle': 'Sincronizar las últimas mascotas de Codex Pet Share + j20 Hatchery en ~/.codex/pets/.',
  'pet.communitySyncDone': '{wrote} mascotas nuevas sincronizadas ({total} en total).',
  'pet.communitySyncFailed': 'Error al sincronizar: {error}',
  'pet.codexBundled': 'Incluida',
  'pet.codexBundledTitle': 'Viene con Gini Studio — sin descarga.',
  'settings.notifications': 'Notificaciones',
  'settings.notificationsHint': 'Sonido y notificación al completar la tarea',
  'settings.notifyCompletionSound': 'Sonido al completar',
  'settings.notifyCompletionSoundHint': 'Se reproduce al terminar un turno. Desactivado por defecto.',
  'settings.notifySuccessSound': 'Sonido de éxito',
  'settings.notifyFailureSound': 'Sonido de error',
  'settings.notifyDesktop': 'Notificación de escritorio',
  'settings.notifyDesktopHint': 'Se envía cuando la ventana no está en primer plano.',
  'settings.notifyDesktopBlocked': 'Bloqueadas por el navegador. Habilítalas en la configuración del sitio.',
  'settings.notifyDesktopUnsupported': 'Las notificaciones de escritorio no están disponibles en este entorno.',
  'settings.notifyTest': 'Enviar prueba',
  'settings.notifyTestSent': 'Notificación de prueba enviada. Si no aparece el aviso, revisa las notificaciones del navegador y del sistema.',
  'settings.notifyTestFailed': 'Falló la llamada de notificación. Revisa las notificaciones del navegador y del sistema.',
  'settings.notifySoundDing': 'Tilín',
  'settings.notifySoundChime': 'Carillón',
  'settings.notifySoundTwoToneUp': 'Dos tonos ascendente',
  'settings.notifySoundPluck': 'Pulsación',
  'settings.notifySoundBuzz': 'Zumbido',
  'settings.notifySoundTwoToneDown': 'Dos tonos descendente',
  'settings.notifySoundThud': 'Golpe',
  'settings.skills': 'Habilidades',
  'settings.skillsHint': 'Habilidades funcionales que el agente puede invocar durante la tarea',
  'settings.skillsNew': 'Nueva habilidad',
  'settings.skillsEmpty': 'Selecciona una habilidad a la izquierda o crea una nueva.',
  'settings.skillsEdit': 'Editar',
  'settings.skillsDelete': 'Eliminar',
  'settings.skillsDeleteConfirm': 'Confirmar eliminación',
  'settings.skillsName': 'Nombre',
  'settings.skillsTriggers': 'Disparadores (separados por comas o saltos de línea)',
  'settings.skillsDescription': 'Descripción',
  'settings.skillsBody': 'Cuerpo de SKILL.md',
  'settings.skillsCreate': 'Crear',
  'settings.skillsSave': 'Guardar',
  'settings.skillsSaving': 'Guardando…',
  'settings.skillsFiles': 'Archivos',
  'settings.skillsNoFiles': 'No hay archivos en esta carpeta de habilidad.',
  'settings.skillsNameRequired': 'El nombre de la habilidad es obligatorio.',
  'settings.skillsBodyRequired': 'El contenido de la habilidad es obligatorio.',
  'settings.designSystems': 'Sistemas de diseño',
  'settings.designSystemsHint': 'Explora y activa los sistemas de diseño disponibles',
  'settings.designSystemsInstalled': 'Instalados',
  'settings.designSystemsAdd': 'Añadir sistema de diseño',
  'settings.designSystemsHiddenCount': '{count} ocultos en la galería de inicio',
  'settings.designSystemsShowAll': 'Mostrar todo',
  'settings.designSystemsShowHidden': 'Mostrar ocultos',
  'settings.designSystemsSource': 'Origen',
  'settings.designSystemsSourceLocal': 'Local',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'Referencia del registro shadcn',
  'settings.designSystemsImportShadcn': 'Importar desde shadcn',
  'settings.designSystemsStructure': 'Estructura',
  'settings.designSystemsModeHybrid': 'Híbrido',
  'settings.designSystemsModeNormalized': 'Normalizado',
  'settings.designSystemsModeVerbatim': 'Literal',
  'settings.designSystemsCraft': 'Diseño',
  'settings.designSystemsCraftColor': 'Color',
  'settings.designSystemsCraftAccessibility': 'Accesibilidad',
  'settings.designSystemsGithubUrl': 'URL de GitHub',
  'settings.designSystemsProjectPath': 'Ruta del proyecto',
  'settings.designSystemsImportGithub': 'Importar desde GitHub',
  'settings.designSystemsImportProject': 'Importar desde proyecto',
  'settings.designSystemsImportedStatus': '{title} importado',
  'settings.designSystemsViewImported': 'Ver sistema de diseño importado',
  'settings.designSystemsCategory': 'Categoría',
  'settings.designSystemsAllCategories': 'Todas las categorías',
  'settings.designSystemsShowInHomeGallery': 'Mostrar en la galería de inicio',
  'settings.projectLocations': 'Ubicaciones de proyectos',
  'settings.projectLocationsHint': 'Raíces de almacenamiento del espacio de trabajo',
  'settings.projectLocationsDescription': 'Añade bases de trabajo que pueden contener varias carpetas de proyectos de Gini Studio. Los proyectos nuevos se guardan como una carpeta dentro de la base seleccionada.',
  'settings.projectLocationsSaveError': 'No se pudieron guardar las ubicaciones de proyectos. Comprueba que cada ruta sea una carpeta accesible.',
  'settings.projectLocationsSaved': 'Ubicaciones de proyectos guardadas.',
  'settings.projectLocationsScanError': 'No se pudieron escanear las ubicaciones de proyectos.',
  'settings.projectLocationsScanComplete': 'Escaneo completado: {imported} importados, {existing} ya registrados.',
  'settings.projectLocationsNoFolderSelected': 'No se seleccionó ninguna carpeta.',
  'settings.projectLocationsDuplicate': 'Esa base de trabajo ya está añadida.',
  'settings.projectLocationsWorkBaseMeta': 'Base de trabajo · los proyectos se crean aquí como subcarpetas',
  'settings.projectLocationsAddFolder': 'Añadir carpeta…',
  'settings.projectLocationsDefaultBadge': 'Ubicación predeterminada',
  'settings.projectLocationsMakeDefault': 'Hacer predeterminada',
  'settings.projectLocationsDefaultSaved': 'Ubicación de proyecto predeterminada actualizada.',
  'settings.librarySkills': 'Habilidades',
  'settings.libraryDesignSystems': 'Sistemas de diseño',
  'settings.librarySearch': 'Buscar...',
  'settings.libraryAll': 'Todo',
  'settings.libraryPreview': 'Vista previa',
  'settings.libraryPreviewClose': 'Cerrar',
  'settings.libraryLoading': 'Cargando...',
  'settings.libraryNoResults': 'Ningún elemento coincide con tu búsqueda.',
  'settings.libraryEnabled': 'Activado',
  'settings.libraryDisabled': 'Desactivado',
  'settings.connectorsNavHint': 'Conexiones a sistemas externos',
  'settings.connectorsHint': 'Gestiona la configuración de conectores y proveedores de herramientas para este dispositivo.',
  'settings.connectorsComposioApiKey': 'Clave API de Composio',
  'settings.connectorsSavedTitle': 'Guardada en el daemon local',
  'settings.connectorsSavedWithTail': 'Guardada · ••••{tail}',
  'settings.connectorsSaved': 'Guardada',
  'settings.connectorsGetApiKey': 'Obtener clave API',
  'settings.connectorsReplaceKeyPlaceholder': 'Pega una clave nueva para sustituir la guardada',
  'settings.connectorsApiKeyPlaceholder': 'Pega la clave API de Composio',
  'settings.connectorsClear': 'Borrar',
  'settings.connectorsClearConfirmTitle': '¿Borrar la clave de API de Composio guardada?',
  'settings.connectorsClearConfirmBody': 'Eliminar la clave desconecta todos los conectores de Composio vinculados a este espacio. Se quitarán las cuentas conectadas, los permisos OAuth y el acceso a las herramientas.',
  'settings.connectorsClearConfirmContinue': 'Continuar',
  'settings.connectorsClearFinalTitle': 'Esto desconectará todos los conectores',
  'settings.connectorsClearFinalBody': 'No hay vuelta atrás. Tendrás que volver a conectar cada integración desde cero después de pegar una clave nueva.',
  'settings.connectorsClearFinalConfirm': 'Borrar clave y desconectar',
  'settings.connectorsClearArming': 'Un momento…',
  'settings.connectorsClearCancel': 'Cancelar',
  'settings.connectorsSaveKey': 'Guardar clave',
  'settings.connectorsSaveKeyTitle': 'Enviar esta clave al daemon local',
  'settings.connectorsKeySaving': 'Guardando…',
  'settings.connectorsKeySaved': 'Guardado ✓',
  'settings.connectorsKeyError': 'No se pudo guardar la clave. Comprueba que el daemon local está activo y vuelve a intentarlo.',
  'settings.connectorsHelpSaved': 'Tu clave desbloquea el catálogo de abajo y permanece en el daemon local. Pega una clave nueva para sustituirla o bórrala.',
  'settings.connectorsHelpUnsaved': 'Cambios sin guardar — pulsa Guardar clave para almacenar esta credencial en el daemon local y desbloquear el catálogo de abajo.',
  'settings.connectorsHelpEmpty': 'Añade una clave para desbloquear el catálogo de abajo. Las claves se guardan localmente en el daemon y nunca se envían mediante variables de entorno.',
  'settings.connectorsLoadingSavedKey': 'Buscando una clave guardada en el daemon local…',
  'settings.autosaveSaving': 'Guardando…',
  'settings.autosaveSaved': 'Todos los cambios guardados',
  'settings.autosaveError': 'No se pudieron guardar los cambios. Es posible que el daemon local esté desconectado.',
  'settings.libraryToggleLabel': 'Alternar',
  'settings.memory': 'Memoria',
  'settings.memoryHint': 'Datos personales extraídos automáticamente de los chats',
  'assetLibrary.title': 'Asset Library',
  'assetLibrary.subtitle': 'Cross-project reusable images, docs, and design assets',
  'assetLibrary.navHint': 'Reusable assets across projects',
  'assetLibrary.searchPlaceholder': 'Search assets...',
  'assetLibrary.filterKind': 'Filter by kind',
  'assetLibrary.kindAll': 'All kinds',
  'assetLibrary.empty': 'No assets yet. Add one below to reuse it across projects.',
  'assetLibrary.count': '{count} assets',
  'assetLibrary.upload': 'Add to library',
  'assetLibrary.namePlaceholder': 'Asset name (e.g. brand-logo.png)',
  'assetLibrary.bodyPlaceholder': 'Paste text content or SVG/HTML source...',
  'assetLibrary.createRequired': 'Name and content are required.',
  'assetLibrary.createFailed': 'Could not add the asset.',
  'assetLibrary.created': 'Asset added to the library.',
  'assetLibrary.duplicateReused': 'Identical content already indexed - reused existing asset.',
  'assetLibrary.deleteFailed': 'Could not delete the asset.',
  'assetLibrary.deleted': 'Asset removed from the library.',
  'assetLibrary.noProject': 'Open a project to insert an asset.',
  'assetLibrary.insertFailed': 'Could not insert the asset into the project.',
  'assetLibrary.inserted': 'Inserted as {path}',
  'assetLibrary.useInProject': 'Use in project',
  'assetLibrary.loadFailed': 'Could not load the asset library.',
  'assetLibrary.previewViaApi': 'Preview is available via the safe /api/library/:id/preview path.',
  'assetLibrary.pickerTitle': 'Insert from Asset Library',
  'assetLibrary.clipperTitle': 'Browser Clipper',
  'assetLibrary.clipperHint': 'Load the MV3 extension from clipper/ (chrome://extensions → Load unpacked). Pairing is optional — zero-config ingest works on loopback.',
  'assetLibrary.clipperPair': 'Generate pairing code',
  'assetLibrary.clipperCode': 'Pairing code: {code}',
  'assetLibrary.clipperPaired': 'Extension paired ({count})',
  'assetLibrary.clipperUnpaired': 'No extension paired yet',
  'assetLibrary.clipperPairFailed': 'Could not start pairing.',
  'assetLibrary.editAsPage': 'Edit as page',
  'assetLibrary.editAsPageFailed': 'Could not open this capture as a page.',
  'assetLibrary.editAsPageOk': 'Opened project {projectId}',
  'settings.customInstructionsTitle': 'Reglas globales',
  'settings.customInstructionsHint': 'Instrucciones fijas que Gini Studio debe seguir en cada chat. Guarda hechos, preferencias y el contexto del proyecto como memorias.',
  'settings.customInstructionsPlaceholder': 'p. ej. «Usa siempre TypeScript. Prefiere componentes funcionales. Mantén las respuestas concisas.»',
  'settings.memoryDescription': 'Datos sobre tus preferencias extraídos automáticamente, guardados como Markdown e inyectados en cada chat.',
  'settings.memoryEnabled': 'Activada',
  'settings.memoryDisabled': 'Desactivada',
  'settings.memoryEnableLabel': 'Activar inyección de memoria',
  'settings.memoryDisabledBanner': 'La memoria está desactivada. Los datos existentes permanecen en disco pero no se inyectarán en nuevos chats.',
  'settings.memoryNew': 'Nueva memoria',
  'settings.memoryEdit': 'Editar',
  'settings.memoryDelete': 'Eliminar',
  'settings.memoryPreview': 'Vista previa',
  'settings.memoryEmpty': 'Aún no hay memoria.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'Prefiero el modo oscuro',
  'settings.memoryName': 'Nombre',
  'settings.memoryDesc': 'Descripción en una línea',
  'settings.memoryBody': 'Cuerpo (Markdown compatible)',
  'settings.memoryBodyHint': 'La regla primero, luego Why y How to apply.',
  'settings.memoryStartersLabel': '¿Necesitas un punto de partida? Haz clic para rellenar el formulario:',
  'settings.memoryStarterUserName': 'Mi rol',
  'settings.memoryStarterUserDesc': 'Soy ingeniero de frontend y trabajo en una herramienta de diseño SaaS',
  'settings.memoryStarterUserBody': '- Rol: ingeniero frontend sénior\n- Stack: React, TypeScript, Vite\n- Dominio: herramientas de diseño / colaboración\n- Zona horaria: GMT+8 (Asia/Shanghai)\n\nCuándo aplicarlo: cualquier chat — plantea los ejemplos en torno al frontend web.',
  'settings.memoryStarterFeedbackName': 'Preferencias de interfaz',
  'settings.memoryStarterFeedbackDesc': 'Modo oscuro, texto de cuerpo grande, baja densidad de información',
  'settings.memoryStarterFeedbackBody': '- Tema: oscuro por defecto\n- Texto del cuerpo: ≥ 18px\n- Densidad de información: prioriza el espacio en blanco, menos elementos por pantalla\n\nPor qué: menos fatiga visual durante sesiones largas.\nCuándo aplicarlo: siempre que generes interfaces, páginas web o diapositivas.',
  'settings.memoryStarterProjectName': 'Proyecto actual',
  'settings.memoryStarterProjectDesc': 'Gini Studio v0.5 — editor de diseño guiado por chat',
  'settings.memoryStarterProjectBody': '- Objetivo: lanzar el editor basado en chat este trimestre\n- Prioridades: renderizado en streaming, multimodal local, offline-first\n- Stack: Next.js 16, daemon de Express, SQLite\n\nCuándo aplicar: en cualquier conversación sobre este proyecto.',
  'settings.memorySaveHint': 'No se guarda automáticamente — haz clic en Crear / Guardar para aplicar.',
  'settings.memoryIndexSaveHint': 'Las ediciones del índice no se guardan automáticamente — haz clic en Guardar índice para aplicar.',
  'settings.memoryIndexUnsaved': 'Cambios sin guardar',
  'settings.memoryFlashCreated': '✓ Memoria creada',
  'settings.memoryFlashSaved': '✓ Memoria guardada',
  'settings.memoryFlashDeleted': '✓ Memoria eliminada',
  'settings.memoryFlashIndexSaved': '✓ Índice guardado',
  'settings.memoryFlashPathCopied': '✓ Ruta copiada',
  'settings.memoryNameLabel': 'Título',
  'settings.memoryTypeLabel': 'Tipo',
  'settings.memoryDescLabel': 'Descripción',
  'settings.memoryBodyLabel': 'Contenido',
  'settings.memoryTypeUser': 'Usuario',
  'settings.memoryTypeFeedback': 'Retroalimentación',
  'settings.memoryTypeProject': 'Proyecto',
  'settings.memoryTypeReference': 'Referencia',
  'settings.memoryIndex': 'MEMORY.md (índice)',
  'settings.memoryIndexSave': 'Guardar índice',
  'settings.memoryIndexReset': 'Restablecer',
  'settings.memoryToastChanged': 'Memoria actualizada',
  'settings.memoryToastClickHint': 'Ver',
  'settings.memoryAll': 'Todo',
  'settings.memoryExtractions': 'Historial de extracciones',
  'settings.memoryExtractionsHint': 'Recent LLM-backed extraction attempts. Heuristic regex extraction always runs first; LLM extraction runs in the background after each turn.',
  'settings.memoryExtractionsEmpty': 'Aún no hay extracciones. El próximo turno del chat poblará esta lista.',
  'settings.memoryExtractionsRefresh': 'Actualizar',
  'settings.memoryExtractionsRefreshing': 'Actualizando…',
  'settings.memoryExtractionPhaseRunning': 'Ejecutando…',
  'settings.memoryExtractionPhaseSuccess': 'Correcto',
  'settings.memoryExtractionPhaseSkipped': 'Omitido',
  'settings.memoryExtractionPhaseFailed': 'Fallido',
  'settings.memoryExtractionSkipNoProvider': 'No hay ninguna API key configurada para la extracción de memoria con LLM.',
  'settings.memoryExtractionSkipDisabled': 'La memoria está desactivada.',
  'settings.memoryExtractionSkipEmpty': 'Mensaje de usuario vacío — no hay nada que extraer.',
  'settings.memoryExtractionSkipNoMatch': 'Ningún patrón de regex coincidió en este turno.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'ajustes de medios',
  'settings.memoryExtractionProviderOverride': 'ajustes de memoria',
  'settings.memoryExtractionProposed': 'propuesto',
  'settings.memoryExtractionWritten': 'escrito',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': 'Eliminar',
  'settings.memoryExtractionsClear': 'Borrar',
  'settings.memoryExtractionsClearTitle': 'Borrar todo el historial de extracciones',
  'settings.memoryExtractionsClearConfirm': '¿Borrar todo el historial de extracciones? Esta acción no se puede deshacer.',
  'settings.memoryNoProviderBannerTitle': 'La extracción de memoria con LLM no se está ejecutando',
  'settings.memoryNoProviderBannerBody': 'No se encontró ninguna API key para el extractor de memoria. Añade una clave de OpenAI en Proveedores de medios, o define ANTHROPIC_API_KEY / OPENAI_API_KEY en el entorno, para habilitar la extracción basada en LLM. La extracción heurística por regex sigue activa.',
  'settings.libraryInstall': 'Instalar',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Ruta local',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Instalar',
  'settings.libraryUninstall': 'Desinstalar',
  'settings.libraryBuiltIn': 'Integrado',
  'settings.libraryInstalled': 'Instalado',
  'settings.orbit.eyebrow': 'Automatización',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Resumen diario de conectores',
  'settings.orbit.lede': 'Recopila actividad de conectores según una programación y publica el resultado como un live artifact actualizable.',
  'settings.orbit.statusOnTitle': 'Las ejecuciones diarias programadas están activadas',
  'settings.orbit.statusOffTitle': 'Las ejecuciones diarias programadas están desactivadas',
  'settings.orbit.statusActive': 'Activo',
  'settings.orbit.statusOff': 'Desactivado',
  'settings.orbit.runTitle': 'Iniciar una ejecución de Orbit y abrir la conversación en vivo',
  'settings.orbit.running': 'Ejecutando…',
  'settings.orbit.runOpen': 'Ejecutar ahora',
  'settings.orbit.dailySummaryTitle': 'Resumen diario',
  'settings.orbit.dailySummarySub': 'Se ejecuta una vez al día a la hora local programada.',
  'settings.orbit.on': 'Activado',
  'settings.orbit.off': 'Desactivado',
  'settings.orbit.runTimeTitle': 'Hora de ejecución',
  'settings.orbit.runTimeSub': 'Predeterminada 08:00. Guarda para aplicar la programación del daemon.',
  'settings.orbit.runTimeAria': 'Hora de ejecución diaria de Orbit',
  'settings.orbit.nextRun': 'Próxima ejecución',
  'settings.orbit.nextRunScheduledAfterSave': 'Programada después de guardar',
  'settings.orbit.schedule': 'Programación',
  'settings.orbit.pausedManualOnly': 'Pausado — solo ejecuciones manuales',
  'settings.orbit.templateTitle': 'Plantilla de prompt',
  'settings.orbit.templateMissing': 'La plantilla {id} no está instalada.',
  'settings.orbit.templateMissingOption': '{id} (falta)',
  'settings.orbit.templateMissingInstall': 'Instala una skill de Orbit para dirigir el prompt.',
  'settings.orbit.templateMissingPickAnother': 'Elige otra plantilla en el desplegable.',
  'settings.orbit.templateResetTitle': 'Restablecer a {id}',
  'settings.orbit.templateReset': 'Restablecer',
  'settings.orbit.templateHelp': 'Dirige Orbit con una skill: el prompt de ejemplo de la plantilla seleccionada se inyecta en cada ejecución de Orbit para que los resúmenes sigan esa forma.',
  'settings.orbit.templateAria': 'Plantilla de prompt de Orbit',
  'settings.orbit.templatesLoading': 'Cargando plantillas…',
  'settings.orbit.templatesOptgroup': 'Plantillas de skills de Orbit',
  'settings.orbit.lastRun': 'Última ejecución',
  'settings.orbit.triggerManual': 'Manual',
  'settings.orbit.triggerScheduled': 'Programada',
  'settings.orbit.meterAria': '{succeeded} correctos, {skipped} omitidos, {failed} fallidos de {checked} comprobados',
  'settings.orbit.countChecked': 'Comprobados',
  'settings.orbit.countSucceeded': 'Correctos',
  'settings.orbit.countSkipped': 'Omitidos',
  'settings.orbit.countFailed': 'Fallidos',
  'settings.orbit.runError': 'No se pudo ejecutar Orbit. Asegúrate de que el daemon local esté en ejecución y los conectores estén configurados.',
  'settings.orbit.gateAriaLabel': 'Se necesitan conectores para usar Orbit',
  'settings.orbit.gateEyebrow': 'Configuración requerida',
  'settings.orbit.gateTitle': 'Conecta una herramienta para impulsar Orbit',
  'settings.orbit.gateBody': 'Orbit resume la actividad de tus conectores. Aún no has conectado ninguno — añade al menos una integración para que Orbit tenga algo que informar.',
  'settings.orbit.gateBodyNoKey': 'Orbit resume la actividad de tus conectores, y los conectores funcionan a través de Composio. Añade una clave de API de Composio en Conectores para desbloquear el catálogo y elegir tu primera integración.',
  'settings.orbit.gateAction': 'Abrir Conectores',
  'settings.orbit.gateActionNoKey': 'Configurar Composio',
  'settings.orbit.gateLoading': 'Comprobando tus conectores…',
  'settings.orbit.controlsLockedBadge': 'Bloqueado',
  'settings.orbit.controlsLockedHint': 'Conecta una herramienta para desbloquear la programación y la plantilla de Orbit.',
  'settings.orbit.artifactKickerLive': 'artefacto en vivo',
  'settings.orbit.artifactKickerLegacy': 'Resumen heredado',
  'settings.orbit.artifactTitle': 'Resumen diario de actividad de Orbit',
  'settings.orbit.artifactMetaLive': 'Artefacto HTML actualizable generado a partir de actividad de conectores.',
  'settings.orbit.artifactMetaLegacy': 'Generado antes de activar la compatibilidad con live artifact; ejecuta Orbit de nuevo para publicar uno.',
  'settings.orbit.copyMarkdownTitle': 'Copiar resumen Markdown al portapapeles',
  'settings.orbit.copied': 'Copiado',
  'settings.orbit.copy': 'Copiar',
  'settings.orbit.openArtifact': 'Abrir artefacto',
  'settings.orbit.sourceMarkdown': 'Markdown fuente',
  'notify.successTitle': 'Tarea completada',
  'notify.failureTitle': 'La tarea falló',
  'notify.successBody': 'Un turno ha terminado.',
  'notify.failureBody': 'La tarea terminó con un error.',
  'updater.available': 'Actualización disponible',
  'updater.availableBody': 'Gini Studio {version} está disponible. Se descargará antes de abrir el instalador.',
  'updater.checking': 'Buscando actualizaciones',
  'updater.download': 'Descargar actualización',
  'updater.downloading': 'Descargando actualización',
  'updater.downloadingPercent': 'Descargando actualización {percent}%',
  'updater.done': 'Listo',
  'updater.failed': 'Error de actualización',
  'updater.installerOpenBody': 'El instalador está abierto. Gini Studio se está cerrando para que puedas completar la actualización.',
  'updater.installerOpened': 'Instalador abierto',
  'updater.later': 'Más tarde',
  'updater.openFailedFallback': 'No se pudo abrir el instalador.',
  'updater.openInstaller': 'Instalar actualización',
  'updater.opening': 'Abriendo instalador...',
  'updater.quitButton': 'Salir de Gini Studio',
  'updater.quitFailedBody': 'El instalador está abierto, pero Gini Studio no pudo cerrarse. Cierra Gini Studio antes de reemplazar la app.',
  'updater.quitFailedTitle': 'No se pudo salir',
  'updater.quitting': 'Cerrando...',
  'updater.ready': 'Actualización lista',
  'updater.readyGeneric': 'Hay una nueva versión lista. Gini Studio se cerrará y abrirá el instalador.',
  'updater.readyVersion': 'Gini Studio {version} está listo. Gini Studio se cerrará y abrirá el instalador.',
  'updater.upToDate': 'Ya tienes la versión más reciente.',
  'newsletter.label': 'Newsletter (opcional)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Modelo de memoria',
  'settings.memoryModelInlineSameAsChat': 'Igual que el chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Igual que el chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Igual que el chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineHintByokNeutral': 'La memoria usa un modelo distinto al del chat. Por defecto, usa el modelo de tu chat.',
  'settings.memoryModelInlineFlashSaved': 'Guardado',
  'settings.memoryModelInlineFlashCleared': 'Borrado',
  'diagnostics.exportTitle': 'Exportar diagnósticos',
  'diagnostics.exportButton': 'Exportar diagnósticos',
  'diagnostics.exportHint': 'Empaqueta los registros recientes y la información del equipo en un zip para enviar al soporte.',
  'diagnostics.exporting': 'Exportando…',
  'diagnostics.exportSuccess': 'Diagnósticos guardados en {path}',
  'diagnostics.exportFailed': 'No se pudieron exportar los diagnósticos: {message}',
  'automations.eyebrow': 'Sesiones de agente programadas',
  'automations.title': 'Automatizaciones',
  'automations.lede': 'Planifica conversaciones recurrentes para el trabajo de proyectos, resúmenes de Orbit y artefactos en vivo.',
  'automations.summaryAria': 'Resumen de automatización',
  'automations.metricActive': 'Activas',
  'automations.metricPaused': 'En pausa',
  'automations.metricTemplates': 'Plantillas',
  'automations.newAutomation': 'Nueva automatización',
  'automations.yourAutomations': 'Tus automatizaciones',
  'automations.loading': 'Cargando',
  'automations.emptyTitle': 'Aún no hay automatizaciones',
  'automations.emptyBody': 'Crea una a partir de una plantilla o empieza con una programación en blanco.',
  'automations.targetNewEachRun': 'Proyecto nuevo en cada ejecución',
  'automations.lastRun': 'Última ejecución {time}',
  'automations.openResult': 'Abrir resultado',
  'automations.run': 'Ejecutar',
  'automations.runNowTitle': 'Ejecutar ahora y abrir la conversación',
  'automations.history': 'Historial',
  'automations.hideHistory': 'Ocultar historial',
  'automations.edit': 'Editar',
  'automations.pause': 'Pausar',
  'automations.resume': 'Reanudar',
  'automations.deleteAria': 'Eliminar automatización',
  'automations.deleteTitle': 'Eliminar esta automatización',
  'automations.deleteConfirm': '¿Eliminar esta automatización? Se conservan las ejecuciones anteriores y sus proyectos.',
  'automations.proposalsTitle': 'Propuestas de evolución',
  'automations.proposalsSub': 'Revisa el resultado de la automatización antes de que cambie la memoria, las habilidades o los sistemas de diseño.',
  'automations.proposalsPending': '{n} pendientes',
  'automations.apply': 'Aplicar',
  'automations.reject': 'Rechazar',
  'automations.proposalsDismissReason': 'Descartada en Automatizaciones',
  'automations.templatesTitle': 'Plantillas',
  'automations.templatesSub': 'Orbit y los artefactos en vivo son plantillas dentro del mismo flujo de automatización.',
  'automations.templatesCount': '{filtered} de {total}',
  'automations.templateFiltersAria': 'Filtros de plantillas',
  'automations.templatesEmptyTitle': 'Aún no hay plantillas en esta categoría.',
  'automations.templatesEmptyBody': 'Prueba con otro filtro o empieza desde una automatización en blanco.',
  'automations.useTemplate': 'Usar plantilla',
  'automations.runHistoryLoading': 'Cargando historial de ejecuciones...',
  'automations.runHistoryEmpty': 'Aún no hay ejecuciones.',
  'automations.runHistoryTitle': 'Historial de ejecuciones',
  'automations.runHistoryLatest': 'Últimas 10',
  'automations.crystallize': 'Cristalizar',
  'automations.crystallizing': 'Cristalizando',
  'automations.crystallizeTitle': 'Redacta propuestas de habilidades y memoria a partir de esta ejecución',
  'automations.openConversation': 'Abrir conversación',
  'automations.runHistoryAria': 'Historial de ejecuciones de la automatización',
  'automations.proposalsAria': 'Propuestas de evolución de la automatización',
  'automations.templatesAria': 'Plantillas de automatización',
  'automations.runInProgress': 'En curso',
  'automations.scheduleStatusPaused': 'En pausa',
  'automations.nextRunManualOnly': 'Solo manual',
  'automations.nextRunScheduled': 'Programada',
  'automations.nextRunAt': 'Próxima {time}',
  'automations.statusSucceeded': 'Correcta',
  'automations.statusFailed': 'Fallida',
  'automations.statusRunning': 'En ejecución',
  'automations.statusQueued': 'En cola',
  'automations.statusCanceled': 'Cancelada',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'Artefacto en vivo',
  'automations.kindAutomation': 'Automatización',
  'automations.proposalTargetMemory': 'Memoria',
  'automations.proposalTargetDesignSystem': 'Sistema de diseño',
  'automations.proposalTargetSkill': 'Habilidad',
  'automations.proposalTargetTemplate': 'Plantilla de automatización',
  'automations.proposalActionCreate': 'Crear',
  'automations.proposalActionUpdate': 'Actualizar',
  'automations.proposalActionMerge': 'Combinar',
  'automations.proposalActionMove': 'Mover',
  'automations.proposalActionDelete': 'Eliminar',
  'automations.proposalActionPromote': 'Promover',
  'automations.filterAll': 'Todas',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'Artefactos en vivo',
  'automations.filterMemory': 'Memoria',
  'automations.filterDesignSystems': 'Sistemas de diseño',
  'automations.filterSkills': 'Habilidades',
  'automations.filterConnectors': 'Conectores',
  'automations.filterCompression': 'Compresión',
  'automations.filterRelease': 'Lanzamiento',
  'automations.filterQuality': 'Calidad',
  'automations.tpl.memoryRefresh.title': 'Actualiza la memoria del proyecto a partir del trabajo reciente.',
  'automations.tpl.memoryRefresh.desc': 'Convierte decisiones, preferencias y comentarios repetidos en actualizaciones de memoria reutilizables.',
  'automations.tpl.designSystemRefresh.title': 'Actualiza los sistemas de diseño a partir de los artefactos entregados.',
  'automations.tpl.designSystemRefresh.desc': 'Encuentra tokens, componentes y reglas reutilizables en el trabajo de diseño reciente.',
  'automations.tpl.liveArtifactRegistry.title': 'Audita los artefactos en vivo y actualiza las versiones obsoletas.',
  'automations.tpl.liveArtifactRegistry.desc': 'Mantiene actualizados los paneles, informes y vistas previas persistentes en lugar de duplicarlos.',
  'automations.tpl.orbitDashboard.title': 'Crea un panel de actividad de conectores.',
  'automations.tpl.orbitDashboard.desc': 'Agrega los conectores seleccionados en un panel en vivo de estilo Orbit.',
  'automations.tpl.releaseNotes.title': 'Redacta notas de lanzamiento a partir del trabajo de diseño entregado.',
  'automations.tpl.releaseNotes.desc': 'Conecta los PR fusionados, los artefactos y los cambios visibles para el usuario en notas de lanzamiento.',
  'automations.tpl.qualityRegressionWatch.title': 'Vigila las regresiones de diseño e implementación.',
  'automations.tpl.qualityRegressionWatch.desc': 'Compara los cambios recientes con los puntos de referencia, las trazas y las referencias aceptadas.',
  'automations.tpl.orbitDaily.title': 'Resumen diario de conectores.',
  'automations.tpl.orbitDaily.desc': 'Actualiza un resumen de actividad de conectores según una programación.',
  'automations.tpl.liveStatusBoard.title': 'Mantén actualizado un artefacto de estado en vivo.',
  'automations.tpl.liveStatusBoard.desc': 'Actualiza un único artefacto persistente en lugar de crear un informe nuevo en cada ejecución.',
  'dsManager.areaAria': 'Área de sistemas de diseño',
  'dsManager.tabDesignSystem': 'Sistema de diseño',
  'dsManager.tabTemplate': 'Plantilla',
  'dsManager.sourceAria': 'Origen del sistema de diseño',
  'dsManager.templateSourceAria': 'Origen de la plantilla',
  'dsManager.yourSystems': 'Tus sistemas',
  'dsManager.officialPresets': 'Ajustes preestablecidos oficiales',
  'dsManager.enterprise': 'Empresa',
  'dsManager.yourTemplates': 'Tus plantillas',
  'dsManager.yourSystemsAria': 'Tus sistemas de diseño',
  'dsManager.eyebrowDesignSystems': 'Sistemas de diseño',
  'dsManager.yourSystemsHeading': 'Tus sistemas',
  'dsManager.filterAria': 'Filtrar sistemas de diseño',
  'dsManager.filterAll': 'Todos',
  'dsManager.filterPublished': 'Publicados',
  'dsManager.filterDraft': 'Borrador',
  'dsManager.createTitle': 'Crear nuevo sistema de diseño',
  'dsManager.createBody': 'Enseña a Gini Studio tu marca, producto, código, recursos y referencias de diseño.',
  'dsManager.createAction': 'Crear',
  'dsManager.emptyMine': 'Aún no hay sistemas de diseño. Crea uno a partir de contexto real del producto, revisa el borrador y publícalo para futuros proyectos.',
  'dsManager.badgeDefault': 'Predeterminado',
  'dsManager.rowMetaUpdated': 'Tú · actualizado {date}',
  'dsManager.edit': 'Editar',
  'dsManager.makeDefault': 'Establecer como predeterminado',
  'dsManager.statusPublished': 'Publicado',
  'dsManager.statusDraft': 'Borrador',
  'dsManager.openSystemAria': 'Abrir {title}',
  'dsManager.deleteSystemAria': 'Eliminar {title}',
  'dsManager.presetsAria': 'Ajustes preestablecidos oficiales de sistemas de diseño',
  'dsManager.eyebrowLibrary': 'Biblioteca',
  'dsManager.eyebrowTemplates': 'Plantillas',
  'dsManager.yourTemplatesAria': 'Tus plantillas',
  'dsManager.emptyTemplates': 'Aún no hay plantillas. Crea una desde cualquier proyecto generado mediante Compartir cuando se habilite la publicación de plantillas.',
  'dsManager.templateDescFallback': 'Creada a partir de un proyecto',
  'dsManager.comingSoonBadge': 'Próximamente',
  'dsManager.enterpriseDsTitle': 'Sistemas de diseño para empresas',
  'dsManager.enterpriseDsBody': 'Los sistemas de diseño compartidos por equipos y las bibliotecas de marca gobernadas llegarán pronto.',
  'dsManager.enterpriseTplTitle': 'Plantillas para empresas',
  'dsManager.enterpriseTplBody': 'Las plantillas aprobadas por el equipo y la publicación a nivel de organización llegarán pronto.',
  'settings.instructionsTitle': 'Instrucciones / Reglas',
  'settings.instructionsSubtitle': 'Comportamiento fijo que el asistente debe seguir',
  'settings.instructionsNavSub': 'Comportamiento fijo del asistente',
  'settings.customInstructionsDesc': 'Instrucciones fijas que Gini Studio sigue en cada chat. No son memorias guardadas; usa Memoria para hechos, preferencias y contexto del proyecto.',
  'mcpClient.forwardedToLabel': 'Reenviado a:',
  'mcpClient.notForwardedToLabel': 'No reenviado a:',
  'mcpClient.forwardedAcpNote': 'Los adaptadores ACP marcados como stdio solo reciben servidores MCP de stdio de esta lista; las entradas HTTP y SSE se descartan en el momento de la creación.',
  'mcpClient.notForwardedNote': 'Para esos agentes, configura los servidores MCP en el propio archivo de configuración del agente (p. ej. ~/.codex/config.toml, ~/.gemini/settings.json); los servidores de abajo se ignoran de forma silenciosa allí.',

  'welcome.title': 'Iniciar sesión en Gini Studio',
  'welcome.subtitle': 'Use your GINI Studio account to continue.',
  'welcome.registerInviteHint': 'Create an account with an invited email address. Ask an admin for an invite if you do not have one yet.',
  'welcome.emailLabel': 'Correo electrónico',
  'welcome.passwordLabel': 'Contraseña',
  'welcome.nameLabel': 'Nombre (opcional)',
  'welcome.loginButton': 'Iniciar sesión',
  'welcome.loginPending': 'Iniciando sesión…',
  'welcome.registerButton': 'Create account',
  'welcome.registerPending': 'Creating account...',
  'welcome.toggleToRegister': 'Don\'t have an account? Create one',
  'welcome.toggleToLogin': '¿Ya tienes cuenta? Inicia sesión',
  'welcome.loadingSession': 'Comprobando tu sesión…',
  'authCallback.connecting': 'Conectando tu cuenta de Gini…',
  'authCallback.failed': 'No se pudo completar el inicio de sesión.',
  'authCallback.retryHint': 'Intenta abrir Gini Studio desde Gini Code de nuevo, o inicia sesión abajo.',
  'giniCodeBridge.title': 'GINI Code',
  'giniCodeBridge.sendTo': 'Send to GINI Code',
  'giniCodeBridge.copyFor': 'Copy for GINI Code',
  'giniCodeBridge.importResult': 'Import GINI Code Result',
  'giniCodeBridge.cancel': 'Cancelar',
  'giniCodeBridge.approveImport': 'Approve import',
  'giniCodeBridge.sendHint': 'Prepare a structured task for GINI Code. Copy it, paste into GINI Code, then import the result back here. Nothing is applied until you approve.',
  'giniCodeBridge.requestLabel': 'Implementation request',
  'giniCodeBridge.requestPlaceholder': 'Describe what GINI Code should implement...',
  'giniCodeBridge.prepareTask': 'Prepare task',
  'giniCodeBridge.copied': 'Copied for GINI Code.',
  'giniCodeBridge.copyFailed': 'Could not copy to clipboard.',
  'giniCodeBridge.importHint': 'Paste the GINI Code result. Studio validates and previews first - files are not changed until you approve.',
  'giniCodeBridge.pasteLabel': 'GINI Code result',
  'giniCodeBridge.pastePlaceholder': 'Paste the gini-code-result/v1 JSON here...',
  'giniCodeBridge.preview': 'Validate & preview',
  'giniCodeBridge.diffsSummary': 'Operations: {creates} create, {updates} update, {deletes} delete',
  'giniCodeBridge.verification': 'Verification: {status}',
  'giniCodeBridge.passed': 'passed',
  'giniCodeBridge.failed': 'failed',
  'giniCodeBridge.applied': 'Imported {count} file operation(s).',
  'giniCodeBridge.unexpectedMutation': 'Preview claimed a mutation; refusing to continue.',
  'giniCodeBridge.defaultRequest': 'Implement the requested changes for {project}.',
  'giniCodeBridge.working': 'Working...',
  'giniCodeBridge.taskReady': 'Task ready to copy',
  'giniCodeBridge.pasteRequired': 'Paste a result before importing',
  'giniCodeBridge.previewReady': 'Preview ready - approve to apply',
  'giniCodeBridge.previewHeading': 'Validation preview',
  'giniCodeBridge.warnings': 'Warnings',
  'giniCodeBridge.applySuccess': 'Applied {count} file operation(s)',
  'giniHandoff.opening': 'Abriendo tu transferencia…',
  'giniHandoff.unavailableTitle': 'Este enlace de transferencia ya no se puede usar',
  'giniHandoff.errorTitle': 'Algo salió mal',
  'giniHandoff.expiredBody': 'Este enlace de transferencia ha caducado. Inicia una nueva transferencia desde Gini Code.',
  'giniHandoff.consumedBody': 'Este enlace de transferencia ya se ha usado. Inicia una nueva transferencia desde Gini Code.',
  'giniHandoff.unknownBody': 'No reconocemos este enlace de transferencia.',
  'giniHandoff.openStudio': 'Abrir Gini Studio',
  'giniHandoff.projectCreated': 'Proyecto creado a partir de tu brief de Gini Code.',
  'giniHandoff.projectOpened': 'Se abrió tu proyecto existente de Gini Studio.',
  'giniHandoff.briefHeading': 'Brief importado',
  'giniHandoff.sourceConversation': 'Conversación de origen',
  'giniHandoff.sourceWorkspace': 'Espacio de trabajo de origen',
  'giniHandoff.projectHeading': 'Proyecto de Studio',
  'giniHandoff.openProject': 'Abrir en Studio',
  'giniHandoff.generationHeading': 'Generación',
  'giniHandoff.startHostedGeneration': 'Iniciar generación alojada',
  'giniHandoff.artifactsHeading': 'Artefactos',
  'giniHandoff.artifactsEmpty': 'Aún no hay versiones de artefactos.',
  'giniHandoff.refresh': 'Actualizar',
  'giniHandoff.checking': 'Buscando versiones nuevas…',
  'giniHandoff.lastChecked': 'Última comprobación',
  'giniHandoff.pollingStopped': 'Comprobación detenida. Usa Actualizar para reintentar.',
  'giniHandoff.preview': 'Vista previa',
  'giniHandoff.referenceExpired': 'Esta referencia de vista previa ha caducado. Solicita otra.',
  'giniHandoff.returnHeading': 'Volver a Gini Code',
  'giniHandoff.returnReady': 'Artefacto listo para Gini Code',
  'giniHandoff.returnAction': 'Preparar referencia de retorno',
  'giniHandoff.copyReference': 'Copiar referencia',
  'giniHandoff.copied': 'Copiado',
  'giniHandoff.accountHeading': 'Cuenta de Gini',
  'giniHandoff.accountEmail': 'Cuenta',
  'giniHandoff.accountTenant': 'Inquilino',
  'giniHandoff.accountPlan': 'Plan',
  'giniHandoff.platformManaged': 'La generación la gestiona la plataforma Gini. La selección de modelo y proveedor es del servidor.',
};
